import React, { useEffect, useRef, useState, useContext } from "react";
import Dashboardmenus from "./Dashboardmenus";
import tonsymbol from "../../../images/ton_symbol.png";
import moneyrecive from "../../../images/money-recive.svg";
import ChevronRightDuo from "../../../images/Chevron_Right_Duo.svg";
import moneywithdrawal from "../../../images/money-withdrawal.svg";
import divide02 from "../../../images/divide-02.svg";
import image2319 from "../../../images/image2319.svg";
import image2320 from "../../../images/image2320.svg";
import image2321 from "../../../images/image2321.svg";
import image2322 from "../../../images/image2322.svg";
import image2323 from "../../../images/image2323.svg";
import TRC from "../../../images/TRC.png";
import ERC20_USDC from "../../../images/ERC20_USDC.png";
import searchnormal from "../../../images/search-normal.svg";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { authcallApi, authcallApipost } from "../../common/API/Api";
import { WebSocketContext } from "../../common/API/WebSocketProvider";
import { Cell } from "ton-core";
import { QRCodeCanvas } from "qrcode.react";
import Paypalpaymwent from "../paymentgatweays/Paypalpaymwent";
import axios from "axios";
import { useTranslation, Trans } from "react-i18next";
import { useModal } from "../../common/Collapsfunction";
import {
  useTonConnectUI,
  useTonWallet,
  useTonAddress,
  TonConnectButton,
} from "@tonconnect/ui-react";
import { useNotification } from "../../common/Notification";
import { formatPrice } from "../../common/formatPrice";
import { exportToExcel } from "../../common/exportToExcel";
import CommonDropdown from "../../common/CommonDropdown";
import CommonHistorydate from "./commonmodal/CommonHistorydate";
import {
  adjustToTimezone,
  convertToServerTime,
  getServerTime,
  gettimezoneprefrence,
} from "./commonmodal/Getservertime";
import { convertLocalToUTCFormatted } from "./commonmodal/Formatedtime";
import Pagination from "./commonmodal/Pagination";
import Commonloader from "../../common/Commonloader";
import { Pakbankname } from "./commonmodal/Pakbankname";
import Accordion from "react-bootstrap/Accordion";
import { getBaseUrl } from "../../common/BaseUrl";
const Dashboarddeposit = () => {
  const { showNotification } = useNotification();
  const { message } = useContext(WebSocketContext);
  const [tonConnectUI] = useTonConnectUI();
  // const { account } = useTonConnect();
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const checkhistory = searchParams.get("history");
  const TOTAL_TIME = 20 * 60;
  const [withdrawaldeposit, setWithdrawaldeposit] = useState(false);
  const [timeLeft, setTimeLeft] = useState(TOTAL_TIME);
  const [isRunning, setIsRunning] = useState(false);
  const [checktonnetwork, setChecktonnetwork] = useState(false);
  const [showAllBanks, setShowAllBanks] = useState(false);
  const timerRef = useRef(null);
  const navigate = useNavigate();
  const [currencyloading, setCurrencyloading] = useState(false);
  const [phonepaypaymentinfo, setPhonepaypaymentinfo] = useState();
  const [cryptoypaymentinfo, setCryptoaypaymentinfo] = useState();
  const [locationdata, setLocationdata] = useState();
  const [invalidaddress, setInvalidaddress] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [defaultpage, setDefaultpage] = useState(false);
  const [complitewithdrawal, setComplewithdrawal] = useState(false);
  const [withdrawableinfo, setWithdrawaleinfo] = useState(true);
  const [totalPages, setTotlepages] = useState();
  const [itemsPerPage, setItemperpage] = useState();
  const [withdrawaladdress, setWithdrawaladdress] = useState([]);
  const [withdrawalload, setWithdrawalload] = useState(true);
  const [maxwithdrawalamount, setMaxwithdrawalamount] = useState(null);
  const [withdrawalamount, setWithdrawalamount] = useState();
  const [startMonthOffset, setStartMonthOffset] = useState(-1);
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();
  const location = useLocation();
  const state = location.state;
  const [walletupdate, setWallupdate] = useState(false);
  const [showcancel, setShowCancel] = useState(false);
  const useTonAddress1 = useTonAddress();
  const [showtonmodal, setShowmodal] = useState(true);
  const useTonAddressref = useRef(null);
  const wallet1 = useTonWallet();
  const { modalRefs, openModal } = useModal();
  const [gatwayslist, setGatwayslist] = useState([]);
  const [showUSDT, setShowUSDT] = useState(false);
  const [showUSDC, setShowUSDC] = useState(false);
  const { t } = useTranslation();
  const qrRef = useRef();
  const qrapayRef = useRef();
  const tabButtonRef = useRef(null);
  const paymenttabButtonRef = useRef(null);
  const paymentexecutiontabRef = useRef(null);
  const [updatetimezone, setUpdateTimezone] = useState();
  const [tempAmount, setTempAmount] = useState("10.00");
  const [usercouponlist, setUsercouponlist] = useState([]);
  const [usercouponhistorylist, setUsercouponhistorylist] = useState([]);
  const [canclecouponid, setCanclecouponid] = useState(null);
  const [bonusData, setBonusData] = useState({});
  const [paymenttype, setPaymenttype] = useState({
    logo: "",
    type: "",
    name: "",
    id: "",
  });
  const [copied, setCopied] = useState({
    amount: false,
    wallet: false,
  });
  const [checkpaypal, setCheckpaypal] = useState(false);
  const [cryptowallet, setCryptowallet] = useState();
  const [loadings, setLoadings] = useState({ step1: false, step2: false });
  const [checkwallet, setCheckwallet] = useState();
  const [giftstyle, setGiftstyle] = useState();
  const Paymentidref = useRef();
  const [checkstripepayment, setCheckstripepayment] = useState({
    paymentSuccess: false,
    errorMessage: "",
    loading: false,
    message: "",
  });
  const [amount, setAmount] = useState("");
  const [paymentcalc, setPaymentcalc] = useState();
  const settledref = useRef(true);
  const [apaypaymentdetail, setApaypaymentdetail] = useState("");
  const [validapay, setValidapay] = useState({ status: false, message: "" });
  const [apayprocess, setApayprocess] = useState(false);
  const [bonusloading, setBonusLoading] = useState(true);
  const [wallethistory, setWallehistory] = useState([]);
  const [searchhistory, setSeachhistory] = useState(null);
  const [paymentgiftlist, setPaymentlist] = useState([]);
  const [exportexceldata, setExportexceldata] = useState([]);
  const [loadingdeposit, setLoadingdeposit] = useState(true);
  const [walletfilter, setWalletfilter] = useState({
    from: "",
    to: "",
    action: "",
  });
  const [Withdrawal, setWithdrawal] = useState({
    payment_method: "",
    amount: "",
    payment_address: "",
  });
  const [Withdrawallist, setWithdrawallist] = useState([]);
  const [checkwalletaddress, setCheckwalletaddress] = useState(false);
  const [withdrawalErrors, setWithdrawalErrors] = useState({});
  const [walletprice, setWalletprice] = useState(null);
  let base_url = getBaseUrl();
  const [pomocode, setPomocode] = useState([]);
  const [paymentdetails, setPaymentdetails] = useState({ amount: "100" });
  const [userdata, setUserdata] = useState();
  const [updateapaydetails, setUpdateapaydetails] = useState(null);
  const [paymentvalidcation, setPaymentvalidcation] = useState();
  const [pomocodedata, setPomocodedata] = useState({
    code: "",
    discount: "",
    min_deposit: "",
    deposit: "",
    bonusamount: 0,
    showtrams: false,
  });
  const [paymentprocess, setPaymentprocess] = useState({
    depositmethod: false,
    paymentdetails: false,
    paymentprocess: false,
    Paymentexecution: false,
  });
  const getpomocode = async () => {
    try {
      if (state?.from !== "deposit") {
        setBonusLoading(true);
      }
      let postdata = {};
      let res = await authcallApi(postdata, `api/coupon`, "GET");
      if (res?.data?.success) {
        setPomocode(res?.data?.coupon);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setBonusLoading(false);
    }
  };
  useEffect(() => {
    let intervalId;
    if (state?.from === "deposit") {
      //  intervalId = setInterval(() => {
      getpomocode();
      // }, 1000);
    } else {
      getpomocode();
      clearInterval(intervalId);
    }
    return () => clearInterval(intervalId);
  }, [state?.from]);
  const isValidTimeZone = (tz) => {
    try {
      Intl.DateTimeFormat(undefined, { timeZone: tz });
      return true;
    } catch (e) {
      return false;
    }
  };

  const checkpromovalid = async (promo_code) => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/couponcheck?promo_code=${promo_code}`,
      );
      if (res?.data?.success) {
        return { status: true, message: "" };
      } else {
        return { status: false, message: res?.data?.message };
      }
    } catch (err) {
      console.log(err, "err");
      return { status: false, message: "Somthing Went Wrong" };
    }
  };
  const checkpomocode = async (value, type) => {
    let obj = {};

    // if (!value) return;
    const cleaned = value.trimEnd();
    let checkcoppon = await checkpromovalid(cleaned);
    if (!checkcoppon?.status) {
      if (type === "promocode") {
        showNotification(checkcoppon?.message, "error");
      } else {
        setPaymentvalidcation((state) => ({
          ...state,
          promocode: true,
          text: checkcoppon?.message,
        }));
      }

      return;
    }

    if (pomocode?.length) {
      pomocode.forEach((result) => {
        if (result?.code.toUpperCase() === cleaned.toUpperCase()) {
          obj = result;
        }
      });
      let coponcode = "";
      if (obj?.code) {
        coponcode = obj?.code.toUpperCase();
      }
      console.log(cleaned, "pomocodepomocode", coponcode);
      if (cleaned.toUpperCase() === coponcode) {
        if (type === "deposit") {
          let obj1 = { ...paymentcalc };
          if (paymentdetails?.amount) {
            let intamount = parseFloat(paymentdetails?.amount);
            if (intamount >= parseFloat(obj?.min_deposit)) {
              const baseAmount = parseFloat(paymentdetails.amount);
              const discountPercent = parseFloat(obj?.discount || 0);
              const maxBonus = parseFloat(obj?.max_bonus || 0);
              const commissionPercent = Number(obj1?.Commission || 0);
              let discountBonus = (baseAmount * discountPercent) / 100;
              if (discountBonus > maxBonus) {
                discountBonus = maxBonus;
              }
              const amountWithBonus = baseAmount + discountBonus;
              obj.bonusamount = discountBonus;
              const commissionAmount =
                (amountWithBonus * commissionPercent) / 100;
              const finalAmount = amountWithBonus - commissionAmount;
              obj1.receive = finalAmount.toFixed(2);
              const amount = Number(paymentdetails?.amount) || 0;
              const commission = Number(obj1?.Commission) || 0;
              const commissionper = ((amount * commission) / 100).toFixed(2);
              console.log(obj1, "currencyexchangeytyt 2 uppp", obj);
              // let upadtedfinalamount =
              //   Number(commissionper) + Number(paymentdetails?.amount) || 0;
              // let alldaat = await currencyexchange(
              //   Number(upadtedfinalamount) +
              //     (Number(upadtedfinalamount) * 0.2) / 100,
              //   obj1?.currency,
              // );
              //   console.log(obj1, "currencyexchangeytyt 2", obj);
              // obj.allcurrncydata = alldaat;
              setPaymentcalc(obj1);
              obj.showtrams = true;
              setPomocodedata(obj);
              setPaymentvalidcation((state) => ({
                ...state,
                promocode: false,
                text: "",
              }));

              return { status: true };
            } else {
              setPomocodedata((state) => ({
                ...state,
                showtrams: false,
              }));
              setPaymentvalidcation((state) => ({
                ...state,
                promocode: true,
                text: t("Minimum amount is ${{amount}}", {
                  amount: obj?.min_deposit,
                }),
              }));
              return {
                status: false,
                text: `Minimum amount is $${obj?.min_deposit}`,
              };
            }
          } else {
            setPaymentvalidcation((state) => ({
              ...state,
              promocode: true,
              text: t("Please Enter Amount"),
            }));
          }
        } else {
          const updatedObj = {
            ...obj,
            bonusamount: pomocodedata?.bonusamount,
            deposit: obj?.min_deposit,
          };

          setPomocodedata((state) => ({
            ...state,
            ...updatedObj,
          }));
        }
      } else {
        if (type === "deposit") {
          setPomocodedata((state) => ({
            ...state,
            showtrams: false,
          }));
          setPomocodedata((state) => ({
            ...state,
            bonusamount: 0,
          }));
          setPaymentvalidcation((state) => ({
            ...state,
            promocode: true,
            text: t("The specified promo code is not available."),
          }));

          return {
            status: false,
            text: t("The specified promo code is not available."),
          };
        } else {
          setPomocodedata({
            code: "",
            discount: "",
            min_deposit: "",
            deposit: "",
            bonusamount: 0,
          });
        }
      }
    } else {
      setPaymentvalidcation((state) => ({
        ...state,
        promocode: true,
        text: t("You don’t have a active Bonus Code."),
      }));
    }
  };

  const activepromocode = async () => {
    if (
      parseInt(pomocodedata?.deposit) >= parseInt(pomocodedata?.min_deposit)
    ) {
      try {
        let dataobj = {
          coupon_id: pomocodedata?.id,
          coupon_activated: 1,
          deposit: pomocodedata?.deposit,
          bonus:
            (parseInt(pomocodedata?.discount) *
              parseInt(
                pomocodedata?.deposit
                  ? pomocodedata?.deposit
                  : pomocodedata?.min_deposit,
              )) /
            100,
          turnover:
            (parseInt(pomocodedata?.discount) *
              parseInt(
                pomocodedata?.deposit
                  ? pomocodedata?.deposit
                  : pomocodedata?.min_deposit,
              )) /
              100 +
            parseInt(
              pomocodedata?.deposit
                ? pomocodedata?.deposit
                : pomocodedata?.min_deposit,
            ),
        };
        const cleaned = pomocodedata?.code.trimEnd();
        let checkcoppon = await checkpromovalid(cleaned);
        if (!checkcoppon?.status) {
          showNotification(
            `You have already used this coupon. Please apply another coupon.`,
            "error",
          );
          return;
        }
        const formData = new FormData();
        for (let key in dataobj) {
          if (dataobj.hasOwnProperty(key)) {
            formData.append(key, dataobj[key]);
          }
        }
        let postdata = formData;
        let res = await authcallApi(postdata, `api/assigncoupon`, "POST");
        if (res?.data?.success) {
          setPaymentprocess({
            depositmethod: false,
            paymentdetails: false,
            paymentprocess: false,
            Paymentexecution: false,
          });
          setShowmodal(true);
          setChecktonnetwork(false);
          depositbackbtn();
          setPaymentcalc();
          stopTimer();
          setApayprocess(false);
          setValidapay({ status: false, message: "" });
          setApaypaymentdetail("");
          setPaymentdetails({ amount: 100 });
          setPomocodedata({
            code: "",
            discount: "",
            min_deposit: "",
            deposit: "",
            bonusamount: 0,
          });
          getactivecopon();
          setPaymentvalidcation();
          navigate(`${base_url}userdashboarddeposit`, {
            state: { from: "deposit" },
          });
          showNotification(res?.data?.message, "success");
        } else {
          showNotification(res?.data?.message, "error");
        }
      } catch (err) {
        console.log(err, "err");
      }
    } else {
      showNotification(
        `Min. deposit to activate a Bonus Code: ${pomocodedata?.min_deposit}`,
        "error",
      );
    }
  };
  const getactivecopon = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/activatedcoupon`, "GET");
      if (res?.data?.success) {
        if (res?.data?.data?.length) {
          setPaymentdetails((state) => ({
            ...state,
            promocode: res?.data?.data[0].code,
            checkpromo: true,
          }));
        }
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };
  const deactivecoupon = async (coupon_code) => {
    try {
      let postdata = {
        coupon_code: coupon_code,
      };
      let res = authcallApi(postdata, `api/deactivecoupon`, "POST");
      if (res?.data?.success) {
        //  setPaymentdetails((state) => ({
        //   ...state,
        //   promocode: "",
        // checkpromo: false,
        // }));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getactivecopon();
  }, []);
  const setuppaymentdetails = (key, value) => [
    setPaymentdetails((state) => ({
      ...state,
      [key]: value,
    })),
  ];
  const deposittabref = useRef();
  // const gettimezoneprefrencegettime = async () => {
  //   try {
  //     let postdata = {};
  //     let res = await authcallApi(
  //       postdata,
  //       `api/preference?key=timezoneshow`,
  //       "GET"
  //     );
  //     if (res?.data?.success) {
  //       const parsedValue = JSON.parse(res?.data.value);
  //       setUpdateTimezone(parsedValue);
  //     }
  //   } catch (err) {
  //     console.log(err, "err");
  //   }
  // };
  // useEffect(() => {
  //   gettimezoneprefrencegettime();
  // }, []);
  const depositbackbtn = () => {
    const tab = new window.bootstrap.Tab(deposittabref.current);
    tab.show();
    setPaymentdetails({ amount: "100" });
  };
  const openTab = (
    paymentname,
    paymenttype,
    paymentlogo,
    processtab,
    category,
    id,
  ) => {
    if (tabButtonRef.current && paymenttype) {
      const tab = new window.bootstrap.Tab(tabButtonRef.current);
      tab.show();
      setPaymentprocess((state) => ({
        ...state,
        depositmethod: true,
        paymentdetails: false,
        paymentprocess: false,
        Paymentexecution: false,
      }));
      setPaymenttype({
        logo: paymentlogo,
        type: paymenttype,
        name: paymentname,
        category: category,
        id: id,
      });
      setCurrencyloading(false);
    }
    if (paymenttabButtonRef.current && processtab === "paymentdetails") {
      const tab = new window.bootstrap.Tab(paymenttabButtonRef.current);
      tab.show();
      setPaymentprocess((state) => ({
        ...state,
        depositmethod: true,
        paymentdetails: true,
        paymentprocess: false,
        Paymentexecution: false,
      }));
    }
    if (paymentexecutiontabRef.current && processtab === "paymentexecution") {
      const tab = new window.bootstrap.Tab(paymentexecutiontabRef.current);
      tab.show();
      setPaymentprocess((state) => ({
        ...state,
        depositmethod: true,
        paymentdetails: true,
        paymentprocess: true,
        Paymentexecution: false,
      }));
    }
  };
  const payvalidaction = async (paymentdetails) => {
    let returnvalue = true;
    let paymenntvaid = { ...paymentdetails };
    if (
      paymenttype?.type === "nagad_api_v" ||
      paymenttype?.type === "bkash_b" ||
      paymenttype?.type === "jazzcash_fast"
    ) {
      if (!paymentdetails?.account_number) {
        setPaymentvalidcation((state) => ({
          ...state,
          account_number: t("Enter account number"),
        }));
        returnvalue = false;
      }
      if (paymentvalidcation?.account_number) {
        returnvalue = false;
      }
    }
    if (
      paymenttype?.type === "bkash_api_v" ||
      paymenttype?.type === "bkash_p2p"
    ) {
      if (!paymentdetails?.phone_number) {
        setPaymentvalidcation((state) => ({
          ...state,
          phone_number: t("Enter phone number"),
        }));
        returnvalue = false;
      }
      if (paymentvalidcation?.phone_number) {
        returnvalue = false;
      }
    }
    if (!paymentdetails?.amount) {
      setPaymentvalidcation((state) => ({
        ...state,
        amount: true,
      }));
      returnvalue = false;
    } else {
      if (paymentcalc?.mindeposit > paymentdetails?.amount) {
        showNotification(
          `Minimum deposit amount is: $${paymentcalc?.mindeposit}`,
          "error",
        );

        returnvalue = false;
      } else if (paymentcalc?.maxamount < paymentdetails?.amount) {
        showNotification(
          `Maximum deposit amount is: $${paymentcalc?.maxamount}`,
          "error",
        );
        returnvalue = false;
      } else {
        setPaymentvalidcation((state) => ({
          ...state,
          amount: false,
        }));
      }
    }
    if (paymentdetails?.checkpromo && Number(withdrawalamount?.bonus) === 0) {
      if (paymentdetails?.checkpromo) {
        if (!paymentdetails?.promocode) {
          // setPaymentvalidcation((state) => ({
          //   ...state,
          //   promocode: true,
          //   text: "Enter Bonus Code",
          // }));
          // returnvalue = false;
          paymenntvaid.promocode = false;
          setPaymentdetails((state) => ({
            ...state,
            promocode: false,
          }));
          setPomocodedata({
            code: "",
            discount: "",
            min_deposit: "",
            deposit: "",
            bonusamount: 0,
          });
        } else {
          if (
            Number(pomocodedata?.min_deposit) > Number(paymentdetails?.amount)
          ) {
            setPaymentvalidcation((state) => ({
              ...state,
              promocode: true,
              text: t("Minimum amount is ${{amount}}", {
                amount: pomocodedata?.min_deposit,
              }),
            }));
            returnvalue = false;
          } else {
            if (!pomocodedata?.bonusamount) {
              setPaymentvalidcation((state) => ({
                ...state,
                promocode: true,
                text: paymentvalidcation?.text,
              }));
              if (paymentdetails?.promocode) {
                setPaymentvalidcation((state) => ({
                  ...state,
                  promocode: true,
                  text: paymentvalidcation?.text
                    ? paymentvalidcation?.text
                    : t("The specified promo code is not available."),
                }));
              }
              returnvalue = false;
            } else {
              let checkvalidpromo = await checkpomocode(
                paymentdetails?.promocode,
                "deposit",
              );
              if (checkvalidpromo?.status) {
                setPaymentvalidcation((state) => ({
                  ...state,
                  promocode: false,
                }));
              } else {
                setPaymentvalidcation((state) => ({
                  ...state,
                  promocode: true,
                  text: checkvalidpromo?.text,
                }));
                returnvalue = false;
              }
            }
          }
        }
      }
    }

    if (returnvalue) {
      // openTab("","", "", "paymentdetails");
      if (paymenttype?.type === "Paypal") {
        setCheckpaypal(true);
      }
      if (paymenttype?.category === "shkeeper") {
        cryptopayment(paymentdetails);
        openTab("", "", "", "paymentdetails");
      } else if (paymenttype?.category === "apay") {
        if (
          paymentvalidcation?.account_number ||
          paymentvalidcation?.phone_number
        ) {
          return;
        }
        phonepaypayment(paymenntvaid);
        openTab("", "", "", "paymentdetails");
      } else if (paymenttype?.category === "1Plate") {
        platgateway(paymentdetails);
        openTab("", "", "", "paymentdetails");
      } else if (paymenttype?.category === "bitcart") {
        cryptobitpaypayment(paymentdetails);
        openTab("", "", "", "paymentdetails");
      } else if (paymenttype?.category === "nowpayment") {
        cryptonowpaymentpayment(paymentdetails);
        openTab("", "", "", "paymentdetails");
      } else {
        const chain = tonConnectUI.account?.chain;

        const network =
          Number(chain) === -239
            ? "mainnet"
            : Number(chain) === -3
              ? "testnet"
              : "unknown";
        if (network === "mainnet") {
          gettonconnectqr(paymentdetails);
        } else {
          setChecktonnetwork(true);
        }
      }
    }
  };
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const openUpiApp = (upiUrl) => {
    window.location.href = upiUrl;
  };
  const platgateway = async () => {
    try {
      setLoadings((state) => ({
        ...state,
        step2: true,
      }));
      let postdata = {
        gateway_name: paymenttype?.name,
        status: "pending",
        user_id: userdata?.id,
        crypto_amount: 0,
        gift_id: giftstyle?.id ? giftstyle?.id : "",
        amount: paymentdetails?.amount,
        total_amount: paymentcalc?.receive,
        gateway_commission: paymentcalc?.gateway_commission,
        first_name: paymentdetails?.firstname,
        payment_method: paymenttype?.category,
        promo_code: paymentdetails?.checkpromo
          ? paymentdetails?.promocode
            ? paymentdetails?.promocode.toUpperCase()
            : ""
          : "",
        bonus:
          paymentdetails?.checkpromo && paymentdetails?.promocode
            ? pomocodedata?.bonusamount
              ? pomocodedata?.bonusamount
              : ""
            : "",
        gateway_id: paymenttype?.id
          ? paymenttype?.id
          : paymenttype?.name === "Ton Connect"
            ? 4
            : "",
        converted_amount: parseInt(paymentcalc?.allcurrncydata?.converted),
        currency: paymentcalc?.currency,
        payment_system: paymenttype?.type,
        commission:
          (Number(paymentdetails?.amount) * Number(paymentcalc?.Commission)) /
          100,
        withdrawal_commission: paymentcalc?.withdrawal_commission,
        deposit_max_revenue_percentage: paymentcalc?.deposit_max_commission,
        phone_number: paymentdetails?.phone_number
          ? paymentdetails?.phone_number
          : "",
      };
      let res = await authcallApi(
        postdata,
        `api/1plate/create-request`,
        "POST",
      );
      if (res?.data?.success) {
        if (postdata?.promo_code) {
          deactivecoupon(postdata?.promo_code);
        }
        window.location.href = res?.data?.checkout_url;
        // setLoadings((state) => ({
        //   ...state,
        //   step2: false,
        // }));
        transactionHistory();
      } else {
        setLoadings((state) => ({
          ...state,
          step2: false,
        }));
        setPhonepaypaymentinfo({
          error: true,
          message: t(
            "This payment gateway is under maintenance, please try again later.",
          ),
        });
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const phonepaypayment = async (paymentdetailsforphonepay) => {
    try {
      setCryptoaypaymentinfo(null);
      setLoadings((state) => ({
        ...state,
        step2: true,
      }));
      let postdata = {
        gateway_name: paymenttype?.name,
        status: "pending",
        user_id: userdata?.id,
        crypto_amount: 0,
        crypto_name: paymenttype?.type,
        gift_id: giftstyle?.id ? giftstyle?.id : "",
        amount: paymentdetails?.amount,
        total_amount: paymentcalc?.receive,
        gateway_commission: paymentcalc?.gateway_commission,
        first_name: paymentdetails?.firstname,
        payment_method: paymenttype?.category,
        gateway_id: paymenttype?.id
          ? paymenttype?.id
          : paymenttype?.name === "Ton Connect"
            ? 4
            : "",
        promo_code: paymentdetails?.checkpromo
          ? paymentdetails?.promocode
            ? paymentdetails?.promocode.toUpperCase()
            : ""
          : "",
        bonus:
          paymentdetails?.checkpromo && paymentdetails?.promocode
            ? pomocodedata?.bonusamount
              ? pomocodedata?.bonusamount
              : ""
            : "",
        converted_amount: Number(paymentcalc?.allcurrncydata?.converted),
        currency: paymentcalc?.currency,
        payment_system: paymenttype?.type,
        commission:
          (Number(paymentdetails?.amount) * Number(paymentcalc?.Commission)) /
          100,
        withdrawal_commission: paymentcalc?.withdrawal_commission,
        deposit_max_revenue_percentage: paymentcalc?.deposit_max_commission,
        phone_number:
          paymenttype?.type === "bkash_api_v" ||
          paymenttype?.type === "bkash_p2p"
            ? ""
            : paymentdetails?.phone_number
              ? paymentdetails?.phone_number
              : "",
        account_number:
          paymenttype?.type === "bkash_api_v" ||
          paymenttype?.type === "bkash_p2p"
            ? paymentdetails?.phone_number
            : paymentdetails?.account_number
              ? paymentdetails?.account_number
              : "",
      };

      let res = await authcallApi(postdata, `api/apay/create`, "POST");
      if (res?.data?.success) {
        if (postdata?.promo_code) {
          deactivecoupon(postdata?.promo_code);
        }
        if (paymenttype?.type === "egp_fast") {
          window.location.href = res?.data?.url;
          return;
        }
        let updatedobj = {
          ...res?.data?.payment_info,
          amount: postdata?.amount,
          alldata: res?.data,
          payment_system: postdata?.payment_system,
        };
        if (
          postdata?.payment_system === "phonepe" ||
          postdata?.payment_system === "paytm" ||
          postdata?.payment_system === "upi_p2p"
        ) {
          updatedobj.transactiondata = res?.data?.payment_info?.upi_address;
          setPhonepaypaymentinfo(updatedobj);
          window.interval = setInterval(() => {
            gettonstatus(res?.data?.payment_id);
          }, 5000);
          // if (isMobile) {
          //   openUpiApp(res?.data?.payment_info?.paymentpage_url);
          // }
        } else {
          updatedobj.transactiondata =
            res?.data?.payment_info?.receiver_account_number;
          setPhonepaypaymentinfo(updatedobj);
          window.interval = setInterval(() => {
            gettonstatus(res?.data?.payment_id);
          }, 5000);
        }
        startTimer();
      } else {
        console.log(res, "res?.data?.details?.message");
        setLoadings((state) => ({
          ...state,
          step2: false,
        }));
        setPhonepaypaymentinfo({
          error: true,
          message: t(
            res?.error?.details?.message ===
              "amount of deposit is out of limits"
              ? "Please try a lower amount."
              : "This payment gateway is under maintenance, please try again later.",
          ),
        });
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      if (paymenttype?.type === "egp_fast") return;
      setLoadings((state) => ({
        ...state,
        step2: false,
      }));
    }
  };
  const confirmapaypayment = async (paymentinfo, key) => {
    try {
      if (
        paymentinfo?.payment_system === "nagad_api_v" ||
        paymentinfo?.payment_system === "bkash_p2p" ||
        paymentinfo?.payment_system === "jazzcash_fast"
      ) {
        setApayprocess(true);
        transactionHistory(walletfilter, false);
        return;
      }
      if (!key) {
        setValidapay({ status: true, message: t("Required field") });
        return;
      } else {
        setValidapay({ status: false, message: "" });
      }
      setCryptoaypaymentinfo(null);
      setLoadings((state) => ({
        ...state,
        step2: true,
      }));
      let postdata = {
        order_id: paymentinfo?.alldata?.order_id,
        payment_system: paymentinfo?.payment_system,
        key: key,
        transaction_id: paymentinfo?.alldata?.transaction_id,
      };
      let res = await authcallApi(postdata, `api/apay/activate`, "POST");
      if (res?.data?.apay_response?.success) {
        setApayprocess(true);
        transactionHistory(walletfilter, false);
      } else {
        setPhonepaypaymentinfo({
          error: true,
          message: t(
            "This payment gateway is under maintenance, please try again later.",
          ),
        });
      }
    } catch (err) {
      setPhonepaypaymentinfo({
        error: true,
        message: t(
          "This payment gateway is under maintenance, please try again later.",
        ),
      });
      console.log(err, "err");
    } finally {
      setLoadings((state) => ({
        ...state,
        step2: false,
      }));
    }
  };
  useEffect(() => {
    if (isRunning) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timerRef.current);
            setIsRunning(false);
            setPhonepaypaymentinfo({
              error: true,
              message: "Failed: Time limit exceeded",
            });
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timerRef.current);
  }, [isRunning]);

  const startTimer = () => {
    // setPhonepaypaymentinfo({ error: false });
    setTimeLeft(TOTAL_TIME);
    setIsRunning(true);
  };

  const stopTimer = () => {
    clearInterval(timerRef.current);
    setIsRunning(false);
  };

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };
  const handleBlur = () => {
    setTempAmount(paymentdetails?.amount);
  };
  const prevAmount = useRef(paymentdetails?.amount);
  const checkallpayment = async () => {
    let obj = { ...paymentcalc };
    if (paymentdetails?.amount && paymentcalc?.maxamount) {
      let updatedAmount;
      if (pomocodedata?.discount) {
        if (paymentdetails?.checkpromo) {
          let obj1 = {};
          if (pomocode?.length) {
            pomocode.forEach((result) => {
              if (result?.code === paymentdetails?.promocode) {
                obj1 = result;
              }
            });
          }

          const baseAmount = parseFloat(paymentdetails?.amount || 0);
          const discountPercent = parseFloat(obj1?.discount || 0);
          const maxBonus = parseFloat(obj1?.max_bonus || 0);
          const commissionPercent = Number(obj?.Commission || 0);
          let discountBonus = (baseAmount * discountPercent) / 100;
          if (discountBonus > maxBonus) {
            discountBonus = maxBonus;
          }
          const amountWithBonus = baseAmount + discountBonus;
          const commissionAmount = (amountWithBonus * commissionPercent) / 100;
          const finalAmount = amountWithBonus - commissionAmount;
          updatedAmount = finalAmount.toFixed(2);
        } else {
          updatedAmount =
            parseFloat(paymentdetails?.amount).toFixed(2) *
            (1 - Number(obj?.Commission) / 100);
        }
      } else {
        updatedAmount =
          parseFloat(paymentdetails?.amount).toFixed(2) *
          (1 - Number(obj?.Commission) / 100);
      }
      const amount = Number(paymentdetails?.amount) || 0;
      const commission = Number(obj?.Commission) || 0;
      const commissionper = ((amount * commission) / 100).toFixed(2);
      let upadtedfinalamount =
        Number(commissionper) + Number(paymentdetails?.amount) || 0;
      let alldaat = await currencyexchange(
        Number(upadtedfinalamount) + (Number(upadtedfinalamount) * 0.2) / 100,
        obj.currency,
      );
      console.log(alldaat, "currencyexchangeytyt 4", upadtedfinalamount);
      obj.allcurrncydata = alldaat;
      obj.receive = updatedAmount;
      setPaymentcalc(obj);
    }
  };
  useEffect(() => {
    checkallpayment();
  }, [paymentdetails]);
  const currencyexchange = async (amount, currency) => {
    if (currency === "USD") {
      return;
    }
    try {
      if (Number(prevAmount.current) !== Number(amount)) {
        setCurrencyloading(true);
        prevAmount.current = Number(amount);
      }
      let postdata = `https://api.polygon.io/v1/conversion/USD/${currency}?amount=${amount}&apiKey=${process.env.REACT_APP_API_KEY}`;
      let response = await fetch(postdata);
      let callapi = await response.json();
      if (callapi?.status === "NOT_AUTHORIZED") {
        setCurrencyloading(false);
        if (currency === "EGP") {
          callapi.converted = 49.23 * Number(amount);
          return callapi;
        } else if (currency === "LKR") {
          callapi.converted = 336.1 * Number(amount);
          return callapi;
        } else if (currency === "INR") {
          callapi.converted = 94.65 * Number(amount);
          return callapi;
        } else if (currency === "PKR") {
          callapi.converted = 278.2 * Number(amount);
          return callapi;
        } else if (currency === "RUB") {
          callapi.converted = 78.2 * Number(amount);
          return callapi;
        } else if (currency === "BDT") {
          callapi.converted = 123.3 * Number(amount);
          return callapi;
        }
      } else {
        setCurrencyloading(false);
        callapi.converted = Math.round(Number(callapi?.converted || 0));
        return callapi;
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const complitepayment = async (
    transaction_id,
    payment_method,
    message,
    crypto_amount,
    paymentstatus,
    payment_id,
  ) => {
    try {
      setWallupdate(false);
      let postdata = {
        gateway_name: paymenttype?.name,
        payment_id: payment_id,
        status: paymentstatus,
        user_id: userdata?.id,
        amount: paymentdetails?.amount,
        total_amount: paymentcalc?.receive,
        payment_method: payment_method,
        transaction_id: transaction_id ? transaction_id : 0,
        first_name: paymentdetails?.firstname,
        // last_name: paymentdetails?.lastname,
        promo_code: paymentdetails?.promocode
          ? paymentdetails?.promocode.toUpperCase()
          : "",
        bonus:
          paymentdetails?.checkpromo && paymentdetails?.promocode
            ? pomocodedata?.bonusamount
              ? pomocodedata?.bonusamount
              : ""
            : "",
        message: message ? message : "",
        gateway_id: paymenttype?.id
          ? paymenttype?.id
          : paymenttype?.name === "Ton Connect"
            ? 4
            : "",
        crypto_amount: crypto_amount ? crypto_amount : 0,
        // useTonAddress: payment_method ==="ton" ?useTonAddress1?useTonAddress1:"":"",
        // sender_wallet: wallet1?.account?.address
        //   ? wallet1?.account?.address
        //   : "",
        sender_wallet:
          payment_method === "ton"
            ? useTonAddress1
              ? useTonAddress1
              : ""
            : "",
        gift_id: giftstyle?.id ? giftstyle?.id : "",
        withdrawal_commission: paymentcalc?.withdrawal_commission,
        deposit_max_revenue_percentage: paymentcalc?.deposit_max_commission,
        gateway_commission: paymentcalc?.gateway_commission,
      };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(formData, `api/payment-transaction`, "POST");
      if (res?.data?.success) {
        if (postdata?.promo_code) {
          deactivecoupon(postdata?.promo_code);
        }
        if (paymentstatus === "pending") {
          // setPaymentid(res?.data?.payment_id);
          Paymentidref.current = res?.data?.payment_id;
        } else {
          transactionHistory("", true);
          // setPaymentid("");
          if (paymentstatus === "failed") {
            setCheckstripepayment((state) => ({
              ...state,
              message: "Payment Failed",
              loading: false,
            }));
          } else {
            setWallupdate(true);
            setCheckstripepayment((state) => ({
              ...state,
              message: "Deposit Successfully",
              loading: false,
            }));
          }
        }
      } else {
        setCheckstripepayment((state) => ({
          ...state,
          message: "Payment Failed",
          loading: false,
        }));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const gettonstatus = async (id) => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/paymentstatus/${id}`, "GET");
      if (res?.data?.success) {
        if (res?.data?.data?.payment_status === "pending") {
          return true;
        }
        if (res?.data?.data?.payment_status === "completed") {
          setCheckstripepayment((state) => ({
            ...state,
            message: "Deposit Successfully",
            loading: false,
          }));
          transactionHistory();
          setWallupdate(true);
          clearInterval(window.interval);
          openTab("", "", "", "paymentexecution");
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getpaymentmethod = async () => {
    try {
      setLoadings((state) => ({
        ...state,
        step1: true,
      }));
      let payment_method;
      if (paymenttype?.type === "Stripe") {
        payment_method = "stripe";
      } else if (paymenttype?.type === "Paypal") {
        payment_method = "paypal";
      } else if (
        paymenttype?.type === "BTC" ||
        paymenttype?.type === "ETH" ||
        paymenttype?.type === "XRP" ||
        paymenttype?.type === "ETH-USDT" ||
        paymenttype?.type === "BNB" ||
        paymenttype?.type === "BNB-USDC" ||
        paymenttype?.type === "BNB-USDT" ||
        paymenttype?.type === "ETH-USDC" ||
        paymenttype?.type === "TRX" ||
        paymenttype?.type === "USDC" ||
        paymenttype?.type === "USDT" ||
        paymenttype?.type === "XMR" ||
        paymenttype?.type === "AVAX" ||
        paymenttype?.type === "DOGE" ||
        paymenttype?.type === "AVALANCHE-USDC" ||
        paymenttype?.type === "AVALANCHE-USDT" ||
        paymenttype?.type === "LTC" ||
        paymenttype?.type === "MATIC" ||
        paymenttype?.type === "POLYGON-USDC" ||
        paymenttype?.type === "POLYGON-USDT" ||
        paymenttype?.type === "phonepe" ||
        paymenttype?.type === "jazzcash_l" ||
        paymenttype?.category === "apay" ||
        paymenttype?.category === "bitcart" ||
        paymenttype?.category === "nowpayment"
      ) {
        payment_method = "ton";
      }
      console.log(paymenttype, "paymenttypepaymenttype");
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/payment-settings?id=${paymenttype?.id ? paymenttype?.id : paymenttype?.name === "Ton Connect" ? 4 : ""}`,
        "GET",
      );
      if (res?.data?.success) {
        let details = res?.data?.details;
        let obj = { ...paymentcalc };
        let max_apay_deposit = null;
        if (details?.apay_max_deposit) {
          const amount = Number(details?.apay_max_deposit) || 0;
          const commission = Number(details?.admin_commission) || 0;
          const commissionper = ((amount * commission) / 100).toFixed(2);
          let upadtedfinalamount =
            Number(details?.apay_max_deposit) - Number(commissionper) || 0;
          let alldaat = await currencyconvert(
            Number(upadtedfinalamount) -
              (Number(upadtedfinalamount) * 0.2) / 100,
            details.currency,
          );
          console.log(
            alldaat,
            "currencyexchangeytyt123",
            commission,
            commissionper,
            upadtedfinalamount,
          );
          max_apay_deposit = alldaat?.converted;
        }
        let symbol = await getCurrencySymbol(details?.currency);
        obj.Commission = Number(details?.admin_commission);
        obj.mindeposit = parseInt(details?.minimum_amount);
        obj.maxamount = max_apay_deposit
          ? parseInt(max_apay_deposit)
          : parseInt(details?.maximum_amount);
        obj.processtime = details?.processing_time;
        obj.gateway_commission = details?.gateway_commission;
        obj.currency = details?.currency;
        obj.currencySymbol = symbol;
        obj.network = details?.network;
        obj.withdrawal_commission = details?.withdrawal_commission;
        obj.deposit_max_commission = details?.deposit_max_commission;
        obj.apay_max_deposit = details?.apay_max_deposit;
        if (paymentdetails?.amount && obj?.maxamount) {
          let updatedAmount;
          if (pomocodedata?.discount) {
            if (paymentdetails?.checkpromo) {
              updatedAmount =
                parseFloat(paymentdetails?.amount).toFixed(2) *
                (1 + parseInt(pomocodedata?.discount) / 100) *
                (1 - Number(obj?.Commission) / 100);
            } else {
              updatedAmount =
                parseFloat(paymentdetails?.amount).toFixed(2) *
                (1 - Number(obj?.Commission) / 100);
            }
          } else {
            updatedAmount =
              parseFloat(paymentdetails?.amount).toFixed(2) *
              (1 - Number(obj?.Commission) / 100);
          }

          obj.receive = updatedAmount;
          obj.api_key = details?.api_key;
          const amount = Number(paymentdetails?.amount) || 0;
          const commission = Number(obj?.Commission) || 0;
          const commissionper = ((amount * commission) / 100).toFixed(2);
          let upadtedfinalamount =
            Number(commissionper) + Number(paymentdetails?.amount) || 0;

          let alldaat = await currencyexchange(
            Number(upadtedfinalamount) +
              (Number(upadtedfinalamount) * 0.2) / 100,
            obj.currency,
          );
          obj.allcurrncydata = alldaat;
          setPaymentcalc(obj);
          //  setPomocodedata(obj);
        }
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadings((state) => ({
        ...state,
        step1: false,
      }));
    }
  };
  useEffect(() => {
    if (paymenttype?.type) {
      getpaymentmethod();
    }
  }, [paymenttype]);
  const currencyconvert = async (amount, currency) => {
    try {
      if (!amount) {
        return;
      }
      if (Number(prevAmount.current) !== Number(amount)) {
        prevAmount.current = Number(amount);
      }
      let postdata = `https://api.polygon.io/v1/conversion/${currency}/USD?amount=${amount}&apiKey=${process.env.REACT_APP_API_KEY}`;
      let response = await fetch(postdata);
      let callapi = await response.json();
      if (callapi?.status === "NOT_AUTHORIZED") {
        setCurrencyloading(false);
        if (currency === "EGP") {
          callapi.converted = 49.23 * Number(amount);
          return callapi;
        } else if (currency === "LKR") {
          callapi.converted = 336.1 * Number(amount);
          return callapi;
        } else if (currency === "INR") {
          callapi.converted = 94.65 * Number(amount);
          return callapi;
        } else if (currency === "PKR") {
          callapi.converted = 278.2 * Number(amount);
          return callapi;
        } else if (currency === "RUB") {
          callapi.converted = 78.2 * Number(amount);
          return callapi;
        } else if (currency === "BDT") {
          callapi.converted = 123.3 * Number(amount);
          return callapi;
        }
      } else {
        callapi.converted = Math.round(Number(callapi?.converted || 0));
        return callapi;
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const cryptobitpaypayment = async (paymentdetails) => {
    try {
      setCryptoaypaymentinfo(null);
      setLoadings((state) => ({
        ...state,
        step2: true,
      }));
      const currentTimestamp = Math.floor(Date.now() / 1000) * 1000;
      let rendomid = await generateUniqueId();
      let transaction_id = userdata?.id + currentTimestamp + rendomid;
      let postdata = {
        gateway_name: paymenttype?.name,
        status: "pending",
        user_id: userdata?.id,
        crypto_name: paymenttype?.type,
        crypto_amount: 0,
        transaction_id: transaction_id ? transaction_id : 0,
        sender_wallet: "",
        message: "",
        fiat: "USD",
        gift_id: giftstyle?.id ? giftstyle?.id : "",
        amount: paymentdetails?.amount,
        gateway_id: paymenttype?.id
          ? paymenttype?.id
          : paymenttype?.name === "Ton Connect"
            ? 4
            : "",
        total_amount: paymentcalc?.receive,
        first_name: paymentdetails?.firstname,
        //  transaction_id: transaction_id ? transaction_id : 0,
        payment_method: paymenttype?.type,
        promo_code: paymentdetails?.checkpromo
          ? paymentdetails?.promocode
            ? paymentdetails?.promocode.toUpperCase()
            : ""
          : "",
        bonus:
          paymentdetails?.checkpromo && paymentdetails?.promocode
            ? pomocodedata?.bonusamount
              ? pomocodedata?.bonusamount
              : ""
            : "",
        commission:
          (Number(paymentdetails?.amount) * Number(paymentcalc?.Commission)) /
          100,
        withdrawal_commission: paymentcalc?.withdrawal_commission,
        deposit_max_revenue_percentage: paymentcalc?.deposit_max_commission,
      };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(formData, `api/bitcart/create`, "POST");
      if (res?.data?.success) {
        if (postdata?.promo_code) {
          deactivecoupon(postdata?.promo_code);
        }
        let obj = {
          name: res?.data?.payment_info[0]?.name,
          category: res?.data?.category,
          amount: res?.data?.payment_info[0]?.amount,
          wallet: res?.data?.payment_info[0]?.payment_address,
          payment_url: res?.data?.payment_info[0]?.payment_url,
        };
        setCryptowallet(obj);
        transactionHistory();
        window.interval = setInterval(() => {
          gettonstatus(res?.data?.payment_id);
        }, 1000);
        setLoadings((state) => ({
          ...state,
          step2: false,
        }));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    if (loadings.step2) {
      const timer = setTimeout(() => {
        setLoadings((state) => ({
          ...state,
          step2: false,
        }));
        setCryptoaypaymentinfo((state) => ({
          ...state,
          error: "This gateway is not available please try again later",
        }));
      }, 20000);
      return () => clearTimeout(timer);
    }
  }, [loadings.step2]);
  const cryptonowpaymentpayment = async (paymentdetails) => {
    try {
      setCryptoaypaymentinfo(null);
      setLoadings((state) => ({
        ...state,
        step2: true,
      }));
      const currentTimestamp = Math.floor(Date.now() / 1000) * 1000;
      let rendomid = await generateUniqueId();
      let transaction_id = userdata?.id + currentTimestamp + rendomid;
      let postdata = {
        gateway_name: paymenttype?.name,
        status: "pending",
        user_id: userdata?.id,
        crypto_name: paymenttype?.type,
        crypto_amount: 0,
        transaction_id: transaction_id ? transaction_id : 0,
        sender_wallet: "",
        message: "",
        fiat: "USD",
        gift_id: giftstyle?.id ? giftstyle?.id : "",
        gateway_commission: paymentcalc?.gateway_commission,
        amount: paymentdetails?.amount,
        total_amount: paymentcalc?.receive,
        first_name: paymentdetails?.firstname,
        gateway_id: paymenttype?.id
          ? paymenttype?.id
          : paymenttype?.name === "Ton Connect"
            ? 4
            : "",
        //  transaction_id: transaction_id ? transaction_id : 0,
        payment_method: "nowpayment",
        promo_code: paymentdetails?.checkpromo
          ? paymentdetails?.promocode
            ? paymentdetails?.promocode.toUpperCase()
            : ""
          : "",
        bonus:
          paymentdetails?.checkpromo && paymentdetails?.promocode
            ? pomocodedata?.bonusamount
              ? pomocodedata?.bonusamount
              : ""
            : "",
        commission:
          (Number(paymentdetails?.amount) * Number(paymentcalc?.Commission)) /
          100,
        withdrawal_commission: paymentcalc?.withdrawal_commission,
        deposit_max_revenue_percentage: paymentcalc?.deposit_max_commission,
      };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(
        formData,
        `api/nowpayment/create-request`,
        "POST",
      );
      if (res?.data?.success) {
        if (postdata?.promo_code) {
          deactivecoupon(postdata?.promo_code);
        }
        let obj = {
          amount: res?.data?.data?.pay_amount,
          wallet: res?.data?.data?.pay_address,
        };
        setCryptowallet(obj);
        transactionHistory();
        window.interval = setInterval(() => {
          gettonstatus(res?.data?.payment_id);
        }, 1000);
        setLoadings((state) => ({
          ...state,
          step2: false,
        }));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const cryptopayment = async (paymentdetails) => {
    try {
      setCryptoaypaymentinfo(null);
      setLoadings((state) => ({
        ...state,
        step2: true,
      }));
      const currentTimestamp = Math.floor(Date.now() / 1000) * 1000;
      let rendomid = await generateUniqueId();
      let transaction_id = userdata?.id + currentTimestamp + rendomid;
      let postdata = {
        gateway_name: paymenttype?.name,
        status: "pending",
        user_id: userdata?.id,
        crypto_name: paymenttype?.type,
        crypto_amount: 0,
        transaction_id: transaction_id ? transaction_id : 0,
        sender_wallet: "",
        message: "",
        fiat: "USD",
        gift_id: giftstyle?.id ? giftstyle?.id : "",
        amount: paymentdetails?.amount,
        total_amount: paymentcalc?.receive,
        first_name: paymentdetails?.firstname,
        gateway_commission: paymentcalc?.gateway_commission,
        gateway_id: paymenttype?.id
          ? paymenttype?.id
          : paymenttype?.name === "Ton Connect"
            ? 4
            : "",
        //  transaction_id: transaction_id ? transaction_id : 0,
        payment_method: "shkeeper",
        promo_code: paymentdetails?.checkpromo
          ? paymentdetails?.promocode
            ? paymentdetails?.promocode.toUpperCase()
            : ""
          : "",
        bonus:
          paymentdetails?.checkpromo && paymentdetails?.promocode
            ? pomocodedata?.bonusamount
              ? pomocodedata?.bonusamount
              : ""
            : "",
        commission:
          (Number(paymentdetails?.amount) * Number(paymentcalc?.Commission)) /
          100,
        withdrawal_commission: paymentcalc?.withdrawal_commission,
        deposit_max_revenue_percentage: paymentcalc?.deposit_max_commission,
      };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(
        formData,
        `api/shkeeper/create-request`,
        "POST",
      );
      if (res?.data?.success) {
        if (res?.data?.data?.status === "success") {
          if (postdata?.promo_code) {
            deactivecoupon(postdata?.promo_code);
          }
          setCryptowallet(res?.data?.data);
          transactionHistory();
          window.interval = setInterval(() => {
            gettonstatus(res?.data?.payment_id);
          }, 1000);
          setLoadings((state) => ({
            ...state,
            step2: false,
          }));
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const cryptopaymentcheck = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/shkeeper-status`, "GET");
      if (res?.data?.success) {
        return res?.data?.details?.crypto;
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  useEffect(() => {
    if (qrRef.current) {
      if (cryptowallet?.wallet) {
        let obj = { ...cryptowallet };
        const canvas = qrRef.current.querySelector("canvas");
        if (canvas) {
          const dataUrl = canvas.toDataURL("image/png");
          obj.dataUrl = dataUrl;
          setCryptowallet(obj);
        }
      }
    }
  }, [cryptowallet]);
  const transactionHistory = async (walletfilter, checkloading, checkpage) => {
    try {
      if (!userdata?.type) return;
      if (checkpage) {
        setDefaultpage(true);
      }
      setLoading(checkloading);
      let postdata = {
        start_date: formatDisplayDate(walletfilter?.from),
        end_date: formatDisplayDate(walletfilter?.to),
        action: walletfilter?.action?.value,
        page: checkpage ? 1 : currentPage ? currentPage : 1,
        search: searchhistory ? searchhistory : "",
      };
      if (!postdata?.start_date && !postdata?.end_date) {
        const today = new Date();
        const startdate = new Date(today);
        postdata = {
          start_date: formatDisplayDate(
            startdate.setDate(startdate.getDate() - 29),
          ),
          end_date: formatDisplayDate(today),
          action: walletfilter?.action?.value,
          page: currentPage ? currentPage : 1,
          search: searchhistory ? searchhistory : "",
        };
      }
      let res = await authcallApi(
        postdata,
        `api/wallethistory?${
          postdata?.start_date ? `start_date=${postdata.start_date}&` : ""
        }${postdata?.end_date ? `end_date=${postdata.end_date}&` : ""}${
          postdata?.action ? `action=${postdata.action}&` : ""
        }account_type=real&usertype=${userdata?.type}&page=${
          postdata?.page
        }&limit=${20}&search=${postdata.search}`,
        "GET",
      );
      if (res?.data?.success) {
        setCurrentPage(res?.data?.current_page);
        setTotlepages(res?.data?.total_count);
        setItemperpage(res?.data?.limit);
        setWallehistory(res?.data?.data);
        setDefaultpage(false);
      }
      let resforexport = await authcallApi(
        postdata,
        `api/wallethistory?${
          postdata?.start_date ? `start_date=${postdata.start_date}&` : ""
        }${postdata?.end_date ? `end_date=${postdata.end_date}&` : ""}${
          postdata?.action ? `action=${postdata.action}&` : ""
        }account_type=real&usertype=${userdata?.type}&limit=${100000}&search=${
          postdata.search
        }`,
        "GET",
      );
      if (resforexport?.data?.success) {
        if (resforexport?.data?.data?.length) {
          const array =
            resforexport?.data?.data?.map((item) => {
              // if (item?.action === "Withdrawal") {
              //   if (
              //     item?.payment_transaction?.payment_status.toLowerCase() ===
              //     "pending"
              //   ) {
              //     // setComplewithdrawal(true);

              //   }
              // }
              return {
                Date_Time: item?.created_at
                  ? convertLocalToUTCFormatted(item?.created_at, updatetimezone)
                      ?.formatted
                  : "-",
                Transaction_Type: item?.action ?? "",
                Method: item?.payment_transaction?.gateway_name
                  ? item?.payment_transaction?.gateway_name
                  : item?.payment_transaction?.payment_name
                    ? item?.payment_transaction?.payment_name
                    : "-",
                Amount: item?.amount ? item?.amount : "-",
                ID: item?.payment_transaction?.transaction_id ?? "-",
                Status: item?.payment_transaction?.payment_status ?? 0,
              };
            }) || [];
          setExportexceldata(array);
        }
        setLoading(false);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      // setLoading(false);
      setShowCancel(false);
    }
  };

  const userdetails = async () => {
    try {
      let res = await authcallApi({}, `api/userdetail?type=real`, "GET");
      if (res?.data?.success !== false) {
        setUserdata(res?.data?.data?.user);
        setPaymentdetails((state) => ({
          ...state,
          firstname: res?.data?.data?.user?.name,
        }));
        //  transactionHistory();
      } else {
        console.error("API error:", res.error);
      }
    } catch (err) {
      console.log(err, "error");
    }
  };
  const paymentmethodsetting = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/payment-methods-settings`,
        "GET",
      );
      if (res?.data?.success) {
        setCheckwallet(res?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    userdetails();
    paymentmethodsetting();
  }, []);
  useEffect(() => {
    if (userdata && updatetimezone && currentPage) {
      transactionHistory(walletfilter, true);
    }
  }, [userdata, updatetimezone, currentPage]);
  useEffect(() => {
    if (searchhistory) {
      transactionHistory(walletfilter, false, true);
    } else if (searchhistory === "") {
      transactionHistory(walletfilter, true);
    }
  }, [searchhistory]);
  useEffect(() => {
    const amount = parseInt(paymentdetails?.amount);
    if (paymentgiftlist?.length) {
      // let obj = {};
      paymentgiftlist.forEach((res) => {
        if (amount >= res?.deposit_amount) {
          if (res?.style === 1) {
            setGiftstyle({
              boxShadow: "0 0 10px #2fc789",
              border: "1px solid rgb(47, 199, 137)",
              type: "gift1",
              id: res?.id,
            });
          } else if (res?.style === 2) {
            setGiftstyle({
              boxShadow: "0 0 10px #842834",
              border: "1px solid #842834",
              type: "gift2",
              id: res?.id,
            });
          } else if (res?.style === 3) {
            setGiftstyle({
              boxShadow: "0 0 10px #ae742a",
              border: "1px solid #ae742a",
              type: "gift3",
              id: res?.id,
            });
          } else if (res?.style === 4) {
            setGiftstyle({
              boxShadow: "0 0 10px #4a1c7c",
              border: "1px solid #4a1c7c",
              type: "gift4",
              id: res?.id,
            });
          } else if (res?.style === 5) {
            setGiftstyle({
              boxShadow: "0 0 10px #2c7ab9",
              border: "1px solid #2c7ab9",
              type: "gift5",
              id: res?.id,
            });
          }
        }
      });
    }
  }, [paymentdetails]);
  useEffect(() => {
    if (paymentdetails?.checkpromo && paymentdetails?.promocode) {
      checkpomocode(paymentdetails?.promocode, "deposit");
    } else if (!paymentdetails?.checkpromo) {
      setPomocodedata({
        code: "",
        discount: "",
        min_deposit: "",
        deposit: "",
        bonusamount: 0,
        showtrams: false,
      });
    }
  }, [paymentdetails?.checkpromo, paymentdetails?.amount]);
  const setupgifts = async (type, giftid, amount, style) => {
    if (style === 1) {
      setPaymentdetails((state) => ({
        ...state,
        amount: amount,
      }));
      setGiftstyle({
        boxShadow: "0 0 10px #2fc789",
        border: "1px solid rgb(47, 199, 137)",
        type: "gift1",
        id: giftid,
      });
    } else if (style === 2) {
      setPaymentdetails((state) => ({
        ...state,
        amount: amount,
      }));
      setGiftstyle({
        boxShadow: "0 0 10px #842834",
        border: "1px solid #842834",
        type: "gift2",
        id: giftid,
      });
    } else if (style === 3) {
      setPaymentdetails((state) => ({
        ...state,
        amount: amount,
      }));
      setGiftstyle({
        boxShadow: "0 0 10px #ae742a",
        border: "1px solid #ae742a",
        type: "gift3",
        id: giftid,
      });
    } else if (style === 4) {
      setPaymentdetails((state) => ({
        ...state,
        amount: amount,
      }));
      setGiftstyle({
        boxShadow: "0 0 10px #4a1c7c",
        border: "1px solid #4a1c7c",
        type: "gift4",
        id: giftid,
      });
    } else if (style === 5) {
      setPaymentdetails((state) => ({
        ...state,
        amount: amount,
      }));
      setGiftstyle({
        boxShadow: "0 0 10px #2c7ab9",
        border: "1px solid #2c7ab9",
        type: "gift5",
        id: giftid,
      });
    }
  };
  const handleSearchChange = (e) => {
    const query = e.target.value;
    if (query === "") {
      transactionHistory("", false);
    } else {
      const filteredList = exportexceldata.filter((trade) =>
        trade?.payment_transaction?.gateway_name
          .toUpperCase()
          .includes(query.toUpperCase()),
      );

      setWallehistory(filteredList);
    }
  };
  const [value, setValue] = useState(1);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue >= 1 || inputValue === "") {
      setValue(inputValue);
    }
  };
  const generateUniqueId = () => {
    return Math.random().toString(36).substr(2, 9);
  };
  function base64ToHex(base64) {
    const raw = atob(base64);
    let result = "";
    for (let i = 0; i < raw.length; i++) {
      const hex = raw.charCodeAt(i).toString(16);
      result += hex.length === 2 ? hex : "0" + hex;
    }
    return result;
  }
  function stringToBase64(str) {
    return btoa(unescape(encodeURIComponent(str)));
  }
  const payloads = [
    "te6ccgEBAQEACwAAC1RYIDE3MTY4Mjc4MDAw",
    "te6ccgEBAQEACwAAC1RYIDE3MTY4Mjc4MDAx",
    "te6ccgEBAQEACwAAC1RYIDE3MTY4Mjc4MDAy",
    "te6ccgEBAQEACwAAC1RYIDE3MTY4Mjc4MDAz",
    "te6ccgEBAQEACwAAC1RYIDE3MTY4Mjc4MDA0",
    "te6ccgEBAQEACwAAC1RYIDE3MTY4Mjc4MDA1",
    "te6ccgEBAQEACwAAC1RYIDE3MTY4Mjc4MDA2",
    "te6ccgEBAQEACwAAC1RYIDE3MTY4Mjc4MDA3",
    "te6ccgEBAQEACwAAC1RYIDE3MTY4Mjc4MDA4",
    "te6ccgEBAQEACwAAC1RYIDE3MTY4Mjc4MDA5",
  ];
  const used = new Set();

  function getUniquePayload() {
    const available = payloads.filter((p) => !used.has(p));
    if (available.length === 0) {
      throw new Error("No more unique payloads left");
    }
    const payload = available[Math.floor(Math.random() * available.length)];
    used.add(payload);

    return payload;
  }
  function stringToCellBytes(str) {
    const encoder = new TextEncoder();
    const bytes = Array.from(encoder.encode(str));
    const lastByte = bytes.pop();
    const finalByte = lastByte | 0b10000000;
    return Uint8Array.from([...bytes, finalByte]);
  }
  function buildSimpleBOC(comment) {
    const dataBytes = stringToCellBytes(comment);
    const bitsLen = dataBytes.length * 8;

    const hasIndex = false;
    const hasCRC32 = false;
    const hasCacheBits = false;

    const flagsByte = 0b00000001;
    const offsetBytes = 1;
    const refIndexSize = 1;

    const cellData = [0x00, bitsLen / 8, ...dataBytes];

    const cellsNum = 1;
    const rootsNum = 1;
    const absentNum = 0;
    const totalCellSize = cellData.length;

    const header = [
      0xb5,
      0xee,
      0x9c,
      0x72,
      flagsByte,
      offsetBytes,
      cellsNum,
      rootsNum,
      absentNum,
      totalCellSize,
      0x00,
    ];

    const fullBOC = Uint8Array.from([...header, ...cellData]);
    return btoa(String.fromCharCode(...fullBOC));
  }
  const gettonconnectqr = async (paymentdetails) => {
    try {
      const amount = Number(paymentdetails?.amount) || 0;
      const commission = Number(paymentcalc?.Commission) || 0;
      const commissionper = ((amount * commission) / 100).toFixed(2);
      let upadtedfinalamount =
        Number(commissionper) + Number(paymentdetails?.amount) || 0;
      const usdamount = parseFloat(upadtedfinalamount).toFixed(2);
      const tonPriceUSD = await fetchTonPricePolygon();
      const amountTON = usdamount / tonPriceUSD;
      const nanoTON = Math.round(amountTON * 1e9);
      const currentTimestamp = Math.floor(Date.now() / 1000) * 1000;
      let rendomid = await generateUniqueId();
      let message = userdata?.id + currentTimestamp + rendomid;
      complitepayment(message, "ton", "", amountTON, "pending");
      const payload = await buildSimpleBOC(message);
      openTab("", "", "", "paymentexecution");
      setPaymentprocess((state) => ({
        ...state,
        depositmethod: true,
        paymentdetails: true,
        paymentprocess: true,
        Paymentexecution: true,
      }));
      setCheckstripepayment((state) => ({
        ...state,
        loading: true,
        message: "Deposit Successfully",
      }));

      let tonboc = await tonConnectUI.sendTransaction({
        validUntil: Math.floor(Date.now() / 1000) + 600,
        messages: [
          {
            address: paymentcalc?.api_key,
            amount: nanoTON,
            // payload: payload,
          },
        ],
      });

      const bocBase64 = tonboc?.boc;
      const cell = Cell.fromBoc(Buffer.from(bocBase64, "base64"))[0];
      const hash = cell.hash();
      let sendmessage = hash.toString("hex");
      complitepayment(
        sendmessage,
        "ton",
        bocBase64,
        amountTON,
        "completed",
        Paymentidref.current,
      );
    } catch (err) {
      console.log(err, "errro check ");
      const usdamount = parseFloat(paymentdetails?.amount).toFixed(2);
      const tonPriceUSD = await fetchTonPricePolygon();
      const amountTON = usdamount / tonPriceUSD;
      const currentTimestamp = Math.floor(Date.now() / 1000) * 1000;
      let rendomid = await generateUniqueId();
      let message = userdata?.id + currentTimestamp + rendomid;
      let checkstatus = await gettonstatus(Paymentidref.current);
      if (checkstatus) {
        complitepayment(
          "",
          "ton",
          "",
          amountTON,
          "failed",
          Paymentidref.current,
        );
      }
    }
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const modalEl = document.querySelector("#tc-widget-root");
      if (modalEl) {
        if (showtonmodal) {
          modalEl.classList.remove("d-none");
        } else {
          modalEl.classList.add("d-none");
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [showtonmodal]);
  const generatePayload = (text) => {
    const encoder = new TextEncoder();
    const bytes = encoder.encode(text);
    return btoa(String.fromCharCode(...bytes));
  };

  let API_KEY = process.env.REACT_APP_API_KEY;

  const symbol = "TONUSD";

  async function fetchTonPricePolygon() {
    const url = `https://api.polygon.io/v1/last/crypto/TON/USD?apiKey=${API_KEY}`;
    const res = await fetch(url);
    const data = await res.json();
    return data?.last?.price;
  }
  useEffect(() => {
    fetchTonPricePolygon();
  }, []);
  const handleConnect = async () => {
    try {
      if (useTonAddress1) {
        // setPaymentdetails((state) => ({
        //   ...state,
        //   checkpromo: false,
        //   promocode: "",
        // }));
        const chain = tonConnectUI.account?.chain;

        const network =
          Number(chain) === -239
            ? "mainnet"
            : Number(chain) === -3
              ? "testnet"
              : "unknown";
        if (network === "mainnet") {
          openTab("Ton Connect", "Ton", tonsymbol);
          setShowmodal(false);
        } else {
          showNotification(
            "Only real (mainnet) accounts are allowed. Please switch to mainnet.",
            "error",
          );
        }
      }
    } catch (err) {
      console.error("Connection failed:", err);
    }
  };

  useEffect(() => {
    const checkDisconnect = async () => {
      if (useTonAddress1) {
        useTonAddressref.current = useTonAddress1;
      } else if (useTonAddressref.current) {
        try {
          const postdata = {
            wallet_address: useTonAddressref.current,
          };
          const res = await authcallApi(postdata, `api/tondisconnect`, "POST");
          if (res?.data?.success) {
            useTonAddressref.current = "";
          }
        } catch (err) {
          console.log(err, "err");
        }
      }
    };

    checkDisconnect();
  }, [useTonAddress1]);
  const dummydeposit = async (amount) => {
    try {
      let postdata = {
        id: userdata?.id,
        amount: amount,
      };
      let res = await authcallApi(
        postdata,
        `api/add-amount-dummy-user`,
        "POST",
      );
      if (res?.data?.success) {
        showNotification(res?.data?.message, "success");
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const getgifts = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/gifts`, "GET");
      if (res?.data?.success) {
        setPaymentlist(res?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getgifts();
  }, []);
  const withdrawalrequest = async (withdrawalinfo) => {
    try {
      if (validate()) {
        const currentTimestamp = Math.floor(Date.now() / 1000) * 1000;
        let rendomid = await generateUniqueId();
        let message = userdata?.id + currentTimestamp + rendomid;
        setWallupdate(false);
        setWithdrawaldeposit(true);
        let currency = Withdrawal?.payment_method?.currency
          ? Withdrawal?.payment_method?.currency
          : Withdrawallist?.[0]?.currency;
        let converted_amount = "USD";
        if (currency !== "USD") {
          converted_amount = await currencyexchange(
            Number(withdrawalinfo?.amount),
            currency,
          );
        }
        const paymentType =
          Withdrawal?.payment_method?.maintitle ??
          Withdrawallist?.[0]?.maintitle;
        let postdata = {
          amount: withdrawalinfo?.amount,
          payment_method: withdrawalinfo?.payment_method?.payment_method
            ? withdrawalinfo?.payment_method?.payment_method
            : Withdrawallist?.[0]?.payment_method,
          payment_address: withdrawalinfo?.payment_address,
          gateway_name: withdrawalinfo?.payment_method?.title
            ? withdrawalinfo?.payment_method?.title.split("(")[0].trim()
            : Withdrawallist?.[0]?.title.split("(")[0].trim(),
          transaction_id: message ? message : 0,
          payment_name: withdrawalinfo?.payment_method?.payment_method
            ? withdrawalinfo?.payment_method?.payment_method
            : Withdrawallist?.[0]?.payment_method,
          converted_amount: converted_amount?.converted,
          currency: currency,
          impsaddress:
            paymentType === "IMPS"
              ? JSON.stringify({
                  account_name: Withdrawal?.account_name || "",
                  account_number: Withdrawal?.account_number || "",
                  bank_code: Withdrawal?.bank_code || "",
                })
              : paymentType === "PKR W"
                ? JSON.stringify({
                    phone_number: Withdrawal?.phone_number || "",
                    bank_name: Withdrawal?.bank_name || "",
                  })
                : paymentType === "Bkash B"
                  ? JSON.stringify({
                      account_email: Withdrawal?.account_email || "",
                      account_number: Withdrawal?.account_number || "",
                    })
                  : paymentType === "Vodafone fast"
                    ? JSON.stringify({
                        phone_number: Withdrawal?.phone_number || "",
                      })
                    : paymentType === "Ipay Fast"
                      ? JSON.stringify({
                          payment_method: "phone",
                          phone_number: Withdrawal?.phone_number || "",
                        })
                      : null,
        };
        let checkaddress = await validateAddress(postdata);
        if (!checkaddress) {
          setInvalidaddress(true);
          return;
        }
        setInvalidaddress(false);
        let res = await authcallApi(postdata, `api/withdrawal-request`, "POST");
        if (res?.data?.success) {
          if (!checkwalletaddress) {
            let array = [...withdrawaladdress];
            array.forEach((item, key) => {
              if (item?.payment_method === postdata?.payment_method) {
                array[key].payment_address = postdata?.payment_address;
              }
            });
            walletaddressprefrence(array, true);
          }
          transactionHistory("", true);
          setWallupdate(true);
          setComplewithdrawal(true);
          showNotification(res?.data?.message, "success");
          setWithdrawal((state) => ({
            ...state,
            amount: "",
          }));
        } else {
          const apiMessage = res?.data?.message;
          const isSqlError =
            apiMessage?.toLowerCase().includes("sql") ||
            apiMessage?.toLowerCase().includes("syntax") ||
            apiMessage?.toLowerCase().includes("query") ||
            apiMessage?.toLowerCase().includes("exception");
          let errormsg = isSqlError
            ? t("Somthing Went wrong")
            : apiMessage || t("Somthing Went wrong");
          showNotification(errormsg, "error");
        }
      }
    } catch (err) {
      console.log(err, "Err");
    } finally {
      setWithdrawaldeposit(false);
    }
  };
  const validateAddress = (data) => {
    if (
      data?.gateway_name === "BEP20 USDT" ||
      data?.gateway_name === "TRC20 USDT"
    ) {
      if (data?.gateway_name === "BEP20 USDT") {
        return /^0x[a-fA-F0-9]{40}$/.test(data?.payment_address);
      }

      if (data?.gateway_name === "TRC20 USDT") {
        return /^T[a-zA-Z0-9]{33}$/.test(data?.payment_address);
      }

      return false;
    } else {
      return true;
    }
  };
  const validate = () => {
    let newErrors = {};
    const paymentType =
      Withdrawal?.payment_method?.maintitle ?? Withdrawallist?.[0]?.maintitle;
    if (!Withdrawal.amount) {
      newErrors.amount = "Amount is required";
    } else if (
      Number(Withdrawal.amount) <
      (Number(Withdrawal?.payment_method?.min_amount) ||
        Number(Withdrawallist?.[0]?.min_amount))
    ) {
      newErrors.amount = `Amount must be greater than $${
        parseInt(Withdrawal?.payment_method?.min_amount) ||
        parseInt(Withdrawallist?.[0]?.min_amount)
      }`;
    } else if (Number(withdrawalamount?.withdrawable_amount) === 0) {
      newErrors.amount =
        "No withdrawal amount is available for this payment method.";
    } else if (
      Number(Withdrawal.amount) > Number(withdrawalamount?.withdrawable_amount)
    ) {
      newErrors.amount = `Amount must be less than or equal to $${Number(
        withdrawalamount?.withdrawable_amount,
      )}`;
    } else if (Number(Withdrawal.amount) > 40000) {
      newErrors.amount = `Amount must be less than or equal to $40000
      `;
    } else if (
      Number(Withdrawal.amount) >
      Number(maxwithdrawalamount)
    ) {
      if (Withdrawal?.payment_method.apay_max_withdrawals) {
        newErrors.amount = `This gateway's withdrawal limit is $${Number(
         maxwithdrawalamount,
        )}`;
      }
    }
    if (paymentType === "IMPS") {
      if (!Withdrawal.account_name) {
        newErrors.account_name = "Account name is required";
      }
      if (!Withdrawal.account_number) {
        newErrors.account_number = "Account number is required";
      }
      if (!Withdrawal.bank_code) {
        newErrors.bank_code = "Bank code is required";
      } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(Withdrawal.bank_code)) {
        newErrors.bank_code = "Invalid code (e.g. BKID0000001)";
      }
    } else if (paymentType === "PKR W") {
      if (!Withdrawal.phone_number) {
        newErrors.phone_number = "Account phone number is required";
      } else if (!/^[0-9]{9,17}$/.test(Withdrawal.phone_number)) {
        newErrors.phone_number =
          "Phone number must contain only digits and be between 9 and 17 digits";
      }
      if (!Withdrawal.bank_name) {
        newErrors.bank_name = "Bank name is required";
      }
    } else if (paymentType === "Bkash B") {
      if (!Withdrawal.account_email) {
        newErrors.account_email = "Account email is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(Withdrawal.account_email)) {
        newErrors.account_email = "Enter a valid email address";
      }

      if (!Withdrawal.account_number) {
        newErrors.account_number = "Account number is required";
      } else if (!/^01[0-9]{9}$/.test(Withdrawal.account_number)) {
        newErrors.account_number =
          "Account number must start with 01 and contain exactly 11 digits";
      }
    } else if (paymentType === "Vodafone fast") {
      if (!Withdrawal.phone_number) {
        newErrors.phone_number = "Phone number is required";
      } else if (!/^01[0-9]{9}$/.test(Withdrawal.phone_number)) {
        newErrors.phone_number =
          "Phone number must start with 01 and contain exactly 11 digits";
      }
    } else if (paymentType === "Ipay Fast") {
      if (!Withdrawal.phone_number) {
        newErrors.phone_number = "Phone number is required";
      } else if (!/^[0-9]{10}$/.test(Withdrawal.phone_number)) {
        newErrors.phone_number = "Phone number must contain exactly 10 digits";
      }
    } else {
      if (!Withdrawal.payment_address) {
        newErrors.payment_address = "Address is required";
      }
    }

    setWithdrawalErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const getwalletaddressprefrence = async (walletdata) => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=trcaddresswallet`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        const isArr = Array.isArray(parsedValue);
        if (!parsedValue?.length || !isArr) {
          if (walletdata?.length) {
            let array = [];
            walletdata.forEach((item) => {
              array.push({
                payment_address: "",
                payment_method: item?.payment_method,
              });
            });
            walletaddressprefrence(array, false);
            console.log("setWithdrawaladdress 1");
            setWithdrawaladdress(array);
          }
        } else if (parsedValue?.length !== walletdata?.length) {
          if (walletdata?.length) {
            const array = walletdata.map((wallet) => {
              const match = parsedValue?.find(
                (item) => item.payment_method === wallet.payment_method,
              );
              return {
                payment_method: wallet.payment_method,
                payment_address: match?.payment_address || "",
              };
            });
            walletaddressprefrence(array, false);
            console.log("setWithdrawaladdress 2");
            setWithdrawaladdress(array);
          }
        } else {
          if (parsedValue?.length && walletdata?.length) {
            parsedValue.forEach((item) => {
              if (item?.payment_method === walletdata[0]?.payment_method) {
                setWithdrawal((state) => ({
                  ...state,
                  payment_address: item?.payment_address,
                }));
                if (item?.payment_address) {
                  setCheckwalletaddress(true);
                }
              }
            });

            setWithdrawaladdress(parsedValue);
          }
        }
      } else {
        if (walletdata?.length) {
          let array = [];
          walletdata.forEach((item) => {
            array.push({
              payment_address: "",
              payment_method: item?.payment_method,
            });
          });
          walletaddressprefrence(array, false);
          setWithdrawaladdress(array);
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const walletaddressprefrence = async (value, callgetprefrence) => {
    try {
      let postdata = {
        key: "trcaddresswallet",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        if (callgetprefrence) {
          // getwalletaddressprefrence();
          setCheckwalletaddress(true);
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  // useEffect(()=>{
  // getwalletaddressprefrence()
  // },[])
  const canlelwithdrawal = async (postdata) => {
    try {
      setWallupdate(false);
      let res = await authcallApi(postdata, `api/withdrawal-cancel`, "POST");
      if (res?.data?.success) {
        setComplewithdrawal(false);
        setTimeout(() => {
          getWithdrawalsetting();
        }, 2000);
        showNotification(res?.data?.message, "success");
        transactionHistory(walletfilter, false);
        setWallupdate(true);
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getpaymetgatewaylist = async (loadingcheck) => {
    try {
      if (!loadingcheck) {
        setLoadingdeposit(true);
      }

      let postdata = {};
      let res = await authcallApi(postdata, `api/payment-gateways`, "GET");
      if (res?.data?.success) {
        let array = [...res.data.data];
        if (res?.data?.data?.length) {
          array.sort((a, b) => {
            if (a.payment_method === "ton") return -1;
            if (b.payment_method === "ton") return 1;
            return 0;
          });
          const capitalize = (str) =>
            str.charAt(0).toUpperCase() + str.slice(1);
          const currency = locationdata?.currency;

          const filtered = array.filter(
            (item) => item.payment_method !== "ton",
          );
          const sortedByUsage = filtered.sort(
            (a, b) => Number(b.usage_count) - Number(a.usage_count),
          );

          const sameCurrency = sortedByUsage.filter(
            (item) => item.currency === currency,
          );

          const otherCurrency = sortedByUsage.filter(
            (item) => item.currency !== currency,
          );

          const sameCurrencyCount = Math.min(sameCurrency.length, 3);
          const popular = [
            ...sameCurrency.slice(0, sameCurrencyCount),
            ...otherCurrency.slice(0, 6 - sameCurrencyCount),
          ];

          const grouped = Object.values(
            array.reduce((acc, item) => {
              const category = item.category;

              if (!acc[category]) {
                acc[category] = {
                  c_name: capitalize(category),
                  data: [],
                };
              }

              acc[category].data.push(item);
              return acc;
            }, {}),
          );
          const sortedGrouped = grouped
            .map((group) => {
              if (group.c_name.toLowerCase() === "bank" && currency) {
                let updatedData = group.data.map((item) => ({
                  ...item,
                  matched: item.currency === currency,
                }));

                let matchedCount = updatedData.filter(
                  (item) => item.matched,
                ).length;

                if (matchedCount < 4) {
                  updatedData = updatedData.map((item) => {
                    if (!item.matched && matchedCount < 4) {
                      matchedCount++;
                      return { ...item, matched: true, filler: true };
                    }
                    return { ...item, filler: false };
                  });
                } else {
                  updatedData = updatedData.map((item) => ({
                    ...item,
                    filler: false,
                  }));
                }

                updatedData.sort((a, b) => {
                  if (a.currency === currency && b.currency !== currency)
                    return -1;
                  if (a.currency !== currency && b.currency === currency)
                    return 1;

                  if (a.matched && !b.matched) return -1;
                  if (!a.matched && b.matched) return 1;

                  return 0;
                });

                return {
                  ...group,
                  data: [...updatedData].sort((a, b) => {
                    if (a.matched && !b.matched) return -1;
                    if (!a.matched && b.matched) return 1;
                    return 0;
                  }),
                };
              }

              return group;
            })
            .sort((a, b) => {
              const isBankA = a.c_name.toLowerCase() === "bank";
              const isBankB = b.c_name.toLowerCase() === "bank";
              const hasMatchA = isBankA
                ? a.data.some((item) => item.currency === currency)
                : false;
              const hasMatchB = isBankB
                ? b.data.some((item) => item.currency === currency)
                : false;
              const getOrder = (group, hasMatch) => {
                const name = group.c_name.toLowerCase();
                if (name === "bank") {
                  return hasMatch ? 1 : 3;
                }
                if (name === "crypto") return 2;
                return 99;
              };
              const aOrder = getOrder(a, hasMatchA);
              const bOrder = getOrder(b, hasMatchB);
              return aOrder - bOrder;
            });
          const result = [
            {
              c_name: "Popular",
              data: popular,
            },
            ...sortedGrouped,
          ];
          setGatwayslist(result);
        }
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadingdeposit(false);
    }
  };
  useEffect(() => {
    if (locationdata?.currency) {
      getpaymetgatewaylist();
    }
  }, [locationdata]);
  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };
  const handlePrev = () => {
    setStartMonthOffset((prev) => prev - 1);
  };

  const handleNext = () => {
    if (startMonthOffset < -1) {
      setStartMonthOffset((prev) => prev + 1);
    }
  };
  const getMonthDays = (year, month) => {
    const firstDay = new Date(year, month, 1).getDay();
    const totalDays = new Date(year, month + 1, 0).getDate();
    const days = [];

    for (let i = 0; i < (firstDay === 0 ? 6 : firstDay - 1); i++)
      days.push(null);
    for (let d = 1; d <= totalDays; d++) {
      days.push(new Date(year, month, d));
    }
    return days;
  };

  const handleDateClick = (date) => {
    if (!walletfilter?.from || (walletfilter?.from && walletfilter?.to)) {
      // setStartDate(date);
      setWalletfilter((state) => ({
        ...state,
        from: date,
      }));
      // setEndDate(null);
      setWalletfilter((state) => ({
        ...state,
        to: null,
      }));
    } else if (date >= walletfilter?.from) {
      // setEndDate(date);
      setWalletfilter((state) => ({
        ...state,
        to: date,
      }));
    } else {
      setWalletfilter((state) => ({
        ...state,
        from: date,
      }));
      setWalletfilter((state) => ({
        ...state,
        to: null,
      }));
    }
  };
  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date
      .toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  };
  const renderCalendar = (year, month) => {
    const days = getMonthDays(year, month);
    const monthName = new Date(year, month).toLocaleString("default", {
      month: "short",
    });

    return (
      <div key={`${year}-${month}`} className="calendar-month">
        <div className="calendar-header">
          {monthName} {year}
        </div>
        <div className="calendar-grid">
          {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((d) => (
            <div key={d} className="calendar-day-label">
              {d}
            </div>
          ))}
          {days.map((date, idx) => {
            const isSelected =
              date &&
              ((walletfilter?.from &&
                formatDate(date) === formatDate(walletfilter?.from)) ||
                (walletfilter?.to &&
                  formatDate(date) === formatDate(walletfilter?.to)));

            return (
              <div
                key={idx}
                className={`calendar-cell ${isSelected ? "selected" : ""}`}
                onClick={() => date && handleDateClick(date)}
              >
                {date ? date.getDate() : ""}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const getVisibleMonths = () => {
    const firstDate = new Date(currentYear, currentMonth + startMonthOffset);
    const secondDate = new Date(
      currentYear,
      currentMonth + startMonthOffset + 1,
    );

    return [
      { year: firstDate.getFullYear(), month: firstDate.getMonth() },
      { year: secondDate.getFullYear(), month: secondDate.getMonth() },
    ];
  };

  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied((prev) => ({ ...prev, [field]: true }));

      setTimeout(() => {
        setCopied((prev) => ({ ...prev, [field]: false }));
      }, 3000);
    });
  };
  const getWithdrawalsetting = async () => {
    try {
      setWallupdate(false);
      let postdata = {};
      let res = await authcallApi(postdata, `api/withdrawal-settings`, "GET");
      if (res?.data?.data?.length) {
        let priorityMethods = ["BNB-USDT", "usdt_trc_20"];
        setWallupdate(true);
        let array = res.data.data
          .filter(
            (item) =>
              item.available_amount !== "0.00" ||
              priorityMethods.includes(item.payment_method),
          )
          .map((item) => ({
            ...item,
            title: item.title + ` ($${item.available_amount})`,
            maintitle: item.title,
          }))
          .sort((a, b) => {
            const aBalance = parseFloat(a.available_amount);
            const bBalance = parseFloat(b.available_amount);
            const aPriority = priorityMethods.includes(a.payment_method);
            const bPriority = priorityMethods.includes(b.payment_method);
            if (aPriority && aBalance > 0 && !(bPriority && bBalance > 0))
              return -1;
            if (bPriority && bBalance > 0 && !(aPriority && aBalance > 0))
              return 1;
            if (aPriority && aBalance === 0 && !(bPriority && bBalance === 0))
              return 1;
            if (bPriority && bBalance === 0 && !(aPriority && aBalance === 0))
              return -1;
            return bBalance - aBalance;
          });
        let alldata = await currencyconvert(
          array[0]?.apay_max_withdrawals,
          array[0]?.currency,
        );
        setMaxwithdrawalamount(alldata?.converted);
        setWithdrawal((state) => ({
          ...state,
          payment_method: array[0],
        }));
        // setWithdrawal({
        //   payment_method: array[0],
        // });
        setWithdrawallist(array);
        let remaining = res.data.data.filter(
          (item) =>
            !array.some((a) => a.payment_method === item.payment_method),
        );
        let finalList = [...array, ...remaining];
        setWithdrawallist(array);
        getwalletaddressprefrence(finalList);
      } else {
        setWithdrawallist([]);
      }
      setWithdrawalload(false);
    } catch (err) {
      console.log(err, "err");
    }
  };

  useEffect(() => {
    if (Withdrawal?.payment_method?.title) {
      if (withdrawaladdress?.length) {
        setWithdrawal((state) => ({
          ...state,
          payment_address: "",
        }));
        setCheckwalletaddress(false);
        withdrawaladdress.forEach((item) => {
          if (
            item?.payment_method === Withdrawal?.payment_method?.payment_method
          ) {
            setWithdrawal((state) => ({
              ...state,
              payment_address: item?.payment_address,
            }));
            if (!item?.payment_address) {
              setCheckwalletaddress(false);
            } else {
              setCheckwalletaddress(true);
            }
          }
        });
      }
    }
  }, [Withdrawal?.payment_method?.title]);
  const fetchServerTimefordate = async () => {
    const data = await getServerTime();
    const timezonePref = await gettimezoneprefrence();
    setUpdateTimezone(timezonePref);
    if (data?.success) {
      const adjustedTimestamp = await adjustToTimezone(
        data?.server_time,
        timezonePref?.time,
      );
      return {
        ...data,
        adjustedTimestamp,
        timezonePref,
      };
    }
    return data;
  };
  const handledepositDateChange = async (start, end) => {
    const timezonePref = await gettimezoneprefrence();
    let updatedstart = convertToServerTime(start, timezonePref?.time);
    let updatedend = convertToServerTime(end, timezonePref?.time);
    setWalletfilter((state) => ({
      ...state,
      from: updatedstart,
      to: updatedend,
    }));
    let upadteddate = {
      ...walletfilter,
      from: updatedstart,
      to: updatedend,
    };
    transactionHistory(upadteddate, true, true);
    // gettradehistory("filter", upadteddate, true);
  };
  useEffect(() => {
    if (!location.state) {
      console.log(checkhistory, "checkhistory");
      if (Number(checkhistory) === 1) {
        navigate(location.pathname, {
          replace: true,
          state: { from: "transaction_history" },
        });
      } else {
        navigate(location.pathname, {
          replace: true,
          state: { from: "deposit" },
        });
      }
    }
  }, [location, navigate]);
  const goToPage = (page) => {
    const totalPagesall = Math.ceil(totalPages / itemsPerPage);
    if (page < 1 || page > totalPagesall) return;
    setCurrentPage(page);
  };

  const token = localStorage.getItem("token");

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const handleClick = async () => {
    if (!amount) {
      alert("Please enter amount");
      return;
    }

    if (!token) {
      alert("User not authenticated");
      return;
    }

    try {
      const response = await axios.post(
        "https://srv1078633.hstgr.cloud/backend/api/manualdeposit",
        {
          payment_method: "Trc20 Usdt",
          amount: Number(amount),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      console.log("API Response:", response.data);
      alert("Deposit request sent successfully");
    } catch (error) {
      console.error("API Error:", error.response || error);
      alert(error?.response?.data?.message || "Something went wrong");
    }
  };
  // useEffect(() => {
  //   fetch("https://ipapi.co/json/")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setLocationdata({
  //         country: data.country_name,
  //         countryCode: data.country,
  //         currency: data.currency,
  //       });
  //     })
  //     .catch((err) => console.error(err));
  // }, []);
  const getcurrency = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/user/location`, "GET");
      if (res?.data?.success) {
        setLocationdata({
          country: res?.data.country_name,
          countryCode: res?.data.country,
          currency: res?.data.currency,
        });
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };
  useEffect(() => {
    getcurrency();
  }, []);
  function getCurrencySymbol(currencyCode) {
    return (0)
      .toLocaleString("en", {
        style: "currency",
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
      .replace(/\d/g, "")
      .trim();
  }
  useEffect(() => {
    if (message?.data) {
      let stringifymsg = message?.data;
      console.log(stringifymsg, "stringifymsg");
      if (stringifymsg?.depositchange) {
        if (locationdata?.currency) {
          getpaymetgatewaylist(true);
        }
      }
    }
  }, [message]);
  const phoneRegex = /^01[0-9]{9}$/;

  const handlePhoneChange = (e, key, type) => {
    let value = e.target.value;
    value = value.replace(/\s/g, "");
    value = value.replace(/[^0-9]/g, "");
    setuppaymentdetails(key, value);
    let errorMessage = "";
    if (type === "jazzcash_fast") {
      const jazzCashRegex = /^03[0-9]{9}$/;
      if (value.length < 11) {
        errorMessage = `${key} must be at least 11 digits`;
      } else if (value.length > 11) {
        errorMessage = `${key} must be exactly 11 digits`;
      } else if (!jazzCashRegex.test(value)) {
        errorMessage = `${key} must start with 03`;
      }
    } else {
      if (value.length < 11) {
        errorMessage = `${key} must be at least 11 digits`;
      } else if (value.length > 11) {
        errorMessage = `${key} must be exactly 11 digits`;
      } else if (!phoneRegex.test(value)) {
        errorMessage = `${key} must start with 01`;
      }
    }

    setPaymentvalidcation((prev) => ({
      ...prev,
      [key]: errorMessage,
    }));
  };
  const handleaccountvalid = (e) => {
    const value = e.target.value;
    setApaypaymentdetail(value);
    let errorMessage = "";
    if (value.length < 11) {
      errorMessage = "Phone number must be at least 11 digits";
    } else if (value.length > 11) {
      errorMessage = "Phone number must be exactly 11 digits";
    } else if (!phoneRegex.test(value)) {
      errorMessage = "Phone number must start with 01";
    }
    if (errorMessage) {
      setValidapay({ status: true, message: errorMessage, checkvalid: true });
    } else {
      setValidapay({ status: false, message: "", checkvalid: false });
    }
  };

  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const checkbonus = (result) => {
    let obj = { ...result, bonusamount: pomocodedata?.bonusamount };
    obj.deposit = result?.min_deposit;
    handleScrollTop();
    setPomocodedata((state) => ({
      ...state,
      ...obj,
    }));
  };

  const withdrawablesteps = async (withdrawalinfo) => {
    let newErrors = {};
    if (!Withdrawal?.payment_method?.title && !Withdrawallist?.[0]?.title) {
      newErrors.amount = "Payment Method is required";
    }
    if (!Withdrawal.amount) {
      newErrors.amount = "Amount is required";
    } else if (
      Number(Withdrawal.amount) <
      (Number(Withdrawal?.payment_method?.min_amount) ||
        Number(Withdrawallist?.[0]?.min_amount))
    ) {
      newErrors.amount = `Amount must be greater than $${
        parseInt(Withdrawal?.payment_method?.min_amount) ||
        parseInt(Withdrawallist?.[0]?.min_amount)
      }`;
    } else if (Number(withdrawalamount?.withdrawable_amount) === 0) {
      newErrors.amount =
        "No withdrawal amount is available for this payment method.";
    } else if (
      Number(Withdrawal.amount) > Number(withdrawalamount?.withdrawable_amount)
    ) {
      newErrors.amount = `Amount must be less than or equal to $${Number(
        withdrawalamount?.withdrawable_amount,
      )}`;
    } else if (Number(Withdrawal.amount) > 40000) {
      newErrors.amount = `Amount must be less than or equal to $40000
      `;
    } else if (
      Number(Withdrawal.amount) >
      Number(maxwithdrawalamount)
    ) {
      if (Withdrawal?.payment_method.apay_max_withdrawals) {
        newErrors.amount = `This gateway's withdrawal limit is $${Number(
          maxwithdrawalamount,
        )}`;
      }
    }
    setWithdrawalErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      setWithdrawaleinfo(false);
    }
  };
  const withdrawcheck = async (currency, checking) => {
    try {
      let postdata = {
        currency: currency,
      };
      let res = await authcallApi(postdata, `api/withdrawal-check`, "POST");
      if (res?.data?.success) {
        if (window.widtdrawalcheck) {
          clearInterval(window.widtdrawalcheck);
          window.widtdrawalcheck = null;
        }
        if (checking) {
          setWithdrawalamount(res?.data);
          setInvalidaddress(false);
        }

        // getwalletaddressprefrence()
      } else {
        if (res?.data?.repeate) {
          // prevent creating multiple intervals
          if (!window.widtdrawalcheck) {
            window.widtdrawalcheck = setInterval(() => {
              withdrawcheck(currency, checking);
            }, 1000);
          }
        } else {
          if (window.widtdrawalcheck) {
            clearInterval(window.widtdrawalcheck);
            window.widtdrawalcheck = null;
          }
        }
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };
  useEffect(() => {
    if (Withdrawal?.payment_method?.currency || Withdrawallist?.[0]?.currency) {
      if (Withdrawal?.payment_method?.currency) {
        withdrawcheck(Withdrawal?.payment_method?.currency, !withdrawalload);
      } else if (Withdrawallist?.[0]?.currency) {
        withdrawcheck(Withdrawallist?.[0]?.currency, !withdrawalload);
      }
    }
  }, [
    Withdrawal?.payment_method?.currency,
    Withdrawallist?.[0]?.currency,
    walletprice,
  ]);
  const withdrawalfinal = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, "api/withdrawal-final", "GET");
      settledref.current = res?.data?.settled ? true : false;
      if (res?.data?.success) {
        if (res?.data?.settled) {
          if (
            Withdrawal?.payment_method?.currency ||
            Withdrawallist?.[0]?.currency
          ) {
            if (Withdrawal?.payment_method?.currency) {
              withdrawcheck(
                Withdrawal?.payment_method?.currency,
                res?.data?.settled,
              );
            } else if (Withdrawallist?.[0]?.currency) {
              withdrawcheck(Withdrawallist?.[0]?.currency, res?.data?.settled);
            }
          }
          getWithdrawalsetting();
          clearInterval(window.widtdrow);
        } else {
          setWithdrawalload(true);
        }
      } else {
        setWithdrawalload(true);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    // if (state?.from === "withdrawal") {
    window.widtdrow = setInterval(() => {
      withdrawalfinal();
    }, 1000);
    // } else {
    //   clearInterval(window.widtdrow);
    // }
    // withdrawalfinal();
    return () => clearInterval(window.widtdrow);
  }, []);
  const downloadQR = () => {
    const canvas = qrapayRef.current.querySelector("canvas");

    if (!canvas) return;

    const url = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = url;
    link.download = "payment-qr.png";
    link.click();
  };
  const getusercoppon = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, "api/usercoupon", "GET");

      if (res?.data?.success) {
        setUsercouponlist(res?.data?.coupon);
        const data = res?.data?.coupon?.length ? res?.data?.coupon[0] : {};
        const currentTurnover = Number(data.current_turnover || 0);
        const requiredTurnover = Number(data.required_turnover || 0);
        data.executionPercent = requiredTurnover
          ? Math.min((currentTurnover / requiredTurnover) * 100, 100).toFixed(2)
          : "0.00";
        setBonusData(data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getcouponhistory = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, "api/usercouponlog", "GET");
      if (res?.data?.success) {
        setUsercouponhistorylist(res?.data?.wallet_logs);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getusercoppon();
    getcouponhistory();
  }, []);
  const canclecoupon = async (id) => {
    try {
      let postdata = {
        payment_transaction_id: id,
      };
      let res = await authcallApi(postdata, "api/cancelbonus", "POST");
      if (res?.data?.success) {
        showNotification(res?.data?.message, "success");
        setCanclecouponid(null);
        getusercoppon();
        getcouponhistory();
        const modalEl = document.getElementById("removeCouponModal");
        const modal = window.bootstrap.Modal.getInstance(modalEl);
        modal?.hide();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const updateutr = async (paymentinfo) => {
    try {
      if (!paymentinfo?.utr_apay) {
        return;
      }
      let postdata = {
        order_id: paymentinfo?.order_id,
        payment_system: paymentinfo?.payment_method,
        key: paymentinfo?.utr_apay,
        transaction_id: paymentinfo?.transaction_id,
      };
      let res = await authcallApi(postdata, `api/apay/activate`, "POST");
      if (res?.data?.apay_response?.success) {
        setUpdateapaydetails(null);
        transactionHistory(walletfilter, false);
        showNotification("UTR updated successfully.", "success");
        const modalEl = document.getElementById("othTablemodal");
        const modal = window.bootstrap.Modal.getInstance(modalEl);
        modal?.hide();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  return (
    <React.Fragment>
      <Dashboardmenus
        walletupdate={walletupdate}
        setWalletprice={setWalletprice}
      />
      <div className="dashboard-contentbody">
        <section className="DepositSec">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  {/* <TonConnectButton /> */}
                  <li
                    className="nav-item"
                    role="presentation"
                    onClick={() => {
                      setPaymentprocess({
                        depositmethod: false,
                        paymentdetails: false,
                        paymentprocess: false,
                        Paymentexecution: false,
                      });
                      setShowmodal(true);
                      setChecktonnetwork(false);
                      depositbackbtn();
                      setPaymentcalc();
                      stopTimer();
                      setApayprocess(false);
                      setValidapay({ status: false, message: "" });
                      setApaypaymentdetail("");
                      setPaymentdetails({ amount: 100 });
                      setPomocodedata({
                        code: "",
                        discount: "",
                        min_deposit: "",
                        deposit: "",
                        bonusamount: 0,
                      });
                      getactivecopon();
                      setPaymentvalidcation();
                    }}
                  >
                    <Link
                      className={`nav-link ${
                        state?.from === "deposit" && "active"
                      }`}
                      to={`${base_url}userdashboarddeposit`}
                      state={{ from: "deposit" }}
                      id="deposit-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#deposit"
                      // type="button"
                      // role="tab"
                      // aria-controls="deposit"
                      // aria-selected="true"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.033 11.2917C14.683 11.6334 14.483 12.125 14.533 12.65C14.608 13.55 15.433 14.2084 16.333 14.2084H17.9163V15.2C17.9163 16.925 16.508 18.3334 14.783 18.3334H5.21634C3.49134 18.3334 2.08301 16.925 2.08301 15.2V9.59172C2.08301 7.86672 3.49134 6.45837 5.21634 6.45837H14.783C16.508 6.45837 17.9163 7.86672 17.9163 9.59172V10.7917H16.233C15.7663 10.7917 15.3413 10.975 15.033 11.2917Z"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.08301 10.3417V6.53342C2.08301 5.54175 2.69134 4.65838 3.61634 4.30838L10.233 1.80838C11.2663 1.41672 12.3747 2.18341 12.3747 3.29174V6.4584"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.7987 11.6418V13.3586C18.7987 13.8169 18.432 14.1918 17.9653 14.2085H16.332C15.432 14.2085 14.607 13.5502 14.532 12.6502C14.482 12.1252 14.682 11.6335 15.032 11.2918C15.3404 10.9752 15.7653 10.7919 16.232 10.7919H17.9653C18.432 10.8085 18.7987 11.1835 18.7987 11.6418Z"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M5.83301 10H11.6663"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {t("Deposit")}
                    </Link>
                  </li>
                  <li
                    className="nav-item"
                    role="presentation"
                    onClick={() => {
                      setComplewithdrawal(false);
                      setWithdrawaleinfo(true);
                    }}
                  >
                    <Link
                      className={`nav-link ${
                        state?.from === "withdrawal" && "active"
                      }`}
                      to={`${base_url}userdashboarddeposit`}
                      state={{ from: "withdrawal" }}
                      id="withdrawal-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#withdrawal"
                      // type="button"
                      // role="tab"
                      // aria-controls="withdrawal"
                      // aria-selected="false"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.91406 11.4575C7.91406 12.2659 8.53907 12.9159 9.30574 12.9159H10.8724C11.5391 12.9159 12.0808 12.3492 12.0808 11.6409C12.0808 10.8825 11.7474 10.6075 11.2558 10.4325L8.7474 9.55755C8.25573 9.38255 7.9224 9.11589 7.9224 8.34922C7.9224 7.64922 8.46406 7.07422 9.13072 7.07422H10.6974C11.4641 7.07422 12.0891 7.72422 12.0891 8.53256"
                          stroke="white"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10 6.25V13.75"
                          stroke="white"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.3308 10.0013C18.3308 14.6013 14.5974 18.3347 9.99737 18.3347C5.3974 18.3347 1.66406 14.6013 1.66406 10.0013C1.66406 5.4013 5.3974 1.66797 9.99737 1.66797"
                          stroke="white"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.3281 5.00391L18.3281 1.67058L14.9948 1.67058"
                          stroke="white"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.1614 5.83594L18.3281 1.66928"
                          stroke="white"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {/* <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.91699 11.4583C7.91699 12.2666 8.542 12.9166 9.30867 12.9166H10.8753C11.542 12.9166 12.0837 12.3499 12.0837 11.6416C12.0837 10.8833 11.7503 10.6083 11.2587 10.4333L8.75033 9.55828C8.25866 9.38328 7.92533 9.11662 7.92533 8.34995C7.92533 7.64995 8.46699 7.07495 9.13365 7.07495H10.7003C11.467 7.07495 12.092 7.72495 12.092 8.53328"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10 6.25V13.75"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.3337 9.99996C18.3337 14.6 14.6003 18.3333 10.0003 18.3333C5.40033 18.3333 1.66699 14.6 1.66699 9.99996C1.66699 5.39996 5.40033 1.66663 10.0003 1.66663"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.167 2.5V5.83333H17.5003"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.3337 1.66663L14.167 5.83329"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg> */}
                      {t("Withdrawal")}
                    </Link>
                  </li>
                  <li className="nav-item" role="presentation">
                    <Link
                      className={`nav-link ${
                        state?.from === "promo_codes" && "active"
                      }`}
                      to={`${base_url}userdashboarddeposit`}
                      state={{ from: "promo_codes" }}
                      id="promocodes-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#promocodes"
                      // type="button"
                      // role="tab"
                      // aria-controls="promocodes"
                      // aria-selected="false"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.2503 10.4167C16.2503 9.26671 17.1837 8.33337 18.3337 8.33337V7.50004C18.3337 4.16671 17.5003 3.33337 14.167 3.33337H5.83366C2.50033 3.33337 1.66699 4.16671 1.66699 7.50004V7.91671C2.81699 7.91671 3.75033 8.85004 3.75033 10C3.75033 11.15 2.81699 12.0834 1.66699 12.0834V12.5C1.66699 15.8334 2.50033 16.6667 5.83366 16.6667H14.167C17.5003 16.6667 18.3337 15.8334 18.3337 12.5C17.1837 12.5 16.2503 11.5667 16.2503 10.4167Z"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.5 12.2916L12.5 7.29163"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.4951 12.2917H12.5026"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.4951 7.70829H7.50258"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      {t("Bonus Codes")}
                    </Link>
                  </li>
                  <li className="nav-item" role="presentation">
                    <Link
                      className={`nav-link ${
                        state?.from === "transaction_history" && "active"
                      }`}
                      to={`${base_url}userdashboarddeposit`}
                      state={{ from: "transaction_history" }}
                      id="WithdrawalHistory-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#WithdrawalHistory"
                      // type="button"
                      // role="tab"
                      // aria-controls="WithdrawalHistory"
                      // aria-selected="false"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="18"
                        height="18"
                        fill="currentColor"
                      >
                        <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM13 7L12.9998 11.585L16.2426 14.8284L14.8284 16.2426L10.9998 12.413L11 7H13Z"></path>
                      </svg>{" "}
                      {t("Transaction History")}
                    </Link>
                  </li>
                  {/* <!-- <li className="nav-item" role="presentation">
                  <button className="nav-link" id="demotradesHistory-tab" data-bs-toggle="tab" data-bs-target="#demotradesHistory" type="button" role="tab" aria-controls="demotradesHistory" aria-selected="false"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM13 7L12.9998 11.585L16.2426 14.8284L14.8284 16.2426L10.9998 12.413L11 7H13Z"></path></svg> History of demo trades</button>
               </li> --> */}
                </ul>
                <div className="tab-content" id="myTabContent">
                  <div
                    className={`tab-pane fade deposit-tab ${
                      state?.from === "deposit" && "show active"
                    }`}
                    id="deposit"
                    role="tabpanel"
                    aria-labelledby="deposit-tab"
                  >
                    {/* <!-- <div className="deposit_box cardBox mb-4"> --> */}

                    {/* {userdata?.type === 1 ? ( */}
                    {paymentprocess?.depositmethod && (
                      <button
                        className="back_btn"
                        onClick={() => {
                          setPhonepaypaymentinfo({
                            error: false,
                            message: "",
                          });
                          setPaymentprocess({
                            depositmethod: false,
                            paymentdetails: false,
                            paymentprocess: false,
                            Paymentexecution: false,
                          });
                          setShowmodal(true);
                          setChecktonnetwork(false);
                          depositbackbtn();
                          setPaymentcalc();
                          stopTimer();
                          setApayprocess(false);
                          setValidapay({ status: false, message: "" });
                          setApaypaymentdetail("");
                          setPaymentdetails({ amount: 100 });
                          setPomocodedata({
                            code: "",
                            discount: "",
                            min_deposit: "",
                            deposit: "",
                            bonusamount: 0,
                          });
                          getactivecopon();
                          setPaymentvalidcation();
                        }}
                      >
                        <i class="fa-solid fa-arrow-left-long"></i>
                        <span style={{ marginLeft: "10px" }}>{t("Back")}</span>
                      </button>
                    )}

                    <ul
                      className="nav nav-pills stepprocess"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          style={{
                            color: paymentprocess?.depositmethod ? "green" : "",
                          }}
                          onClick={() => {
                            setPaymentprocess({
                              depositmethod: false,
                              paymentdetails: false,
                              paymentprocess: false,
                              Paymentexecution: false,
                            });
                            setShowmodal(true);
                          }}
                          id="depositmethod-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#depositmethod"
                          type="button"
                          role="tab"
                          aria-controls="depositmethod"
                          aria-selected="true"
                          ref={deposittabref}
                        >
                          {paymentprocess?.depositmethod ? (
                            <>
                              {" "}
                              <i
                                className="fa-solid fa-circle-check"
                                style={{
                                  color: "green",
                                }}
                              ></i>{" "}
                            </>
                          ) : (
                            <span>1</span>
                          )}
                          {t("Deposit method")}
                        </button>
                      </li>
                      <li
                        className=""
                        // role="presentation"
                      >
                        <button
                          className="nav-link"
                          style={{
                            color: paymentprocess?.paymentdetails
                              ? "green"
                              : "",
                          }}
                          id="paymentdetails-tab"
                          // data-bs-toggle="pill"
                          data-bs-target="#paymentdetails"
                          type="button"
                          role="tab"
                          aria-controls="paymentdetails"
                          aria-selected="false"
                          ref={tabButtonRef}
                        >
                          {paymentprocess?.paymentdetails ? (
                            <>
                              {" "}
                              <i
                                className="fa-solid fa-circle-check"
                                style={{
                                  color: "green",
                                }}
                              ></i>{" "}
                            </>
                          ) : (
                            <span>2</span>
                          )}
                          {t("Payment details")}
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          style={{
                            color: paymentprocess?.paymentprocess
                              ? "green"
                              : "",
                          }}
                          id="paymentprocess-tab"
                          // data-bs-toggle="pill"
                          data-bs-target="#paymentprocess"
                          type="button"
                          role="tab"
                          aria-controls="paymentprocess"
                          aria-selected="false"
                          ref={paymenttabButtonRef}
                        >
                          {paymentprocess?.paymentprocess ? (
                            <>
                              {" "}
                              <i
                                className="fa-solid fa-circle-check"
                                style={{
                                  color: "green",
                                }}
                              ></i>{" "}
                            </>
                          ) : (
                            <span>3</span>
                          )}
                          {t("Payment process")}
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="paymentexecution-tab"
                          // data-bs-toggle="pill"
                          data-bs-target="#paymentexecution"
                          type="button"
                          role="tab"
                          aria-controls="paymentexecution"
                          aria-selected="false"
                          ref={paymentexecutiontabRef}
                        >
                          <span>4</span> {t("Payment execution")}
                        </button>
                      </li>
                    </ul>

                    <div className="tab-content " id="pills-tabContent">
                      <div
                        className="tab-pane fade show active"
                        id="depositmethod"
                        role="tabpanel"
                        aria-labelledby="depositmethod-tab"
                      >
                        <div className="deposit_box">
                          <div className="row">
                            <div className="col-lg-8 col-md-12 col-sm-12 mb-lg-0 mb-4">
                              <div
                                className="cardBox position-reletive"
                                style={{
                                  position: "relative",
                                  minHeight: "100px",
                                }}
                              >
                                {loadingdeposit ? (
                                  <div className="depositloader">
                                    <Commonloader show={true} />
                                  </div>
                                ) : gatwayslist?.length ? (
                                  gatwayslist.map((category, catIndex) => {
                                    const isBank = category?.c_name === "Bank";
                                    const isCrypto =
                                      category?.c_name === "Crypto";

                                    let usdtList = [];
                                    let usdcList = [];
                                    let otherCrypto = [];

                                    if (isCrypto) {
                                      category?.data?.forEach((item) => {
                                        if (
                                          item?.name
                                            ?.toLowerCase()
                                            .includes("usdt")
                                        ) {
                                          usdtList.push(item);
                                        } else if (
                                          item?.name
                                            ?.toLowerCase()
                                            .includes("usdc")
                                        ) {
                                          usdcList.push(item);
                                        } else {
                                          otherCrypto.push(item);
                                        }
                                      });
                                    }
                                    const hasUnmatched =
                                      isBank &&
                                      category?.data?.some(
                                        (item) => item?.matched === false,
                                      );

                                    // Filter data
                                    const filteredData = category?.data?.filter(
                                      (item) => {
                                        if (!isBank) return true;
                                        if (showAllBanks) return true;
                                        return item?.matched === true;
                                      },
                                    );

                                    // Last matched === true index (ONLY for More Banks)
                                    const lastMatchedIndex =
                                      isBank && !showAllBanks
                                        ? filteredData
                                            ?.map((item, index) =>
                                              item?.matched === true
                                                ? index
                                                : -1,
                                            )
                                            .filter((i) => i !== -1)
                                            .pop()
                                        : -1;

                                    // Last index of rendered list (USED for Hide Banks)
                                    const lastIndex = filteredData?.length - 1;
                                    const hasAnyMatched =
                                      isBank &&
                                      category?.data?.some(
                                        (item) => item?.matched === true,
                                      );
                                    return (
                                      <div
                                        className="row paymentGatewayopt mb-3"
                                        key={catIndex}
                                      >
                                        {/* 🔹 Dynamic Category Title */}
                                        <div className="col-12">
                                          <div className="w-100 justify-content-between d-flex align-items-center">
                                            <h4 className="card_title">
                                              {category.c_name === "Popular" ? (
                                                <i class="fa-solid fa-star"></i>
                                              ) : category.c_name ===
                                                "Crypto" ? (
                                                <i class="fa-brands fa-btc"></i>
                                              ) : category.c_name === "Bank" ? (
                                                <i class="fa-solid fa-building-columns"></i>
                                              ) : (
                                                ""
                                              )}{" "}
                                              {t(category.c_name)}
                                            </h4>
                                          </div>
                                        </div>
                                        {isBank &&
                                          hasUnmatched &&
                                          !hasAnyMatched &&
                                          !showAllBanks && (
                                            <div className="col-lg-4 col-md-4 col-sm-6 mb-4">
                                              <div
                                                className="sub_deposit_box pointercursor moreoptcion01"
                                                onClick={() =>
                                                  setShowAllBanks(!showAllBanks)
                                                }
                                              >
                                                <div className="inner_deposit_box">
                                                  <i className="fa-solid fa-building-columns text-white"></i>

                                                  <h5 className="sub_card_title ms-2">
                                                    {showAllBanks
                                                      ? t("Hide Banks")
                                                      : t("More Banks")}
                                                  </h5>

                                                  <i
                                                    className={`fa-solid fa-angle-down text-white ${
                                                      showAllBanks
                                                        ? "arrowup01"
                                                        : ""
                                                    }`}
                                                  ></i>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        {isCrypto ? (
                                          <>
                                            {usdtList?.length ? (
                                              <div className="col-12">
                                                <div className="moreoptcion01dropdown">
                                                  {/* USDT DROPDOWN */}

                                                  <div
                                                    className="sub_deposit_box pointercursor moreoptcion01"
                                                    onClick={() =>
                                                      setShowUSDT(!showUSDT)
                                                    }
                                                  >
                                                    <div className="inner_deposit_box">
                                                      <h5 className="sub_card_title ms-2">
                                                        <img src={TRC} alt="" />{" "}
                                                        Tether (USDT)
                                                      </h5>

                                                      <div className="right_center">
                                                        <span>
                                                          {t(
                                                            "Select a network",
                                                          )}
                                                        </span>
                                                        <span>
                                                          {t("Available")}:{" "}
                                                          {usdtList?.length}
                                                        </span>
                                                        <i
                                                          className={`fa-solid fa-angle-down text-white ${
                                                            showUSDT
                                                              ? "arrowup01"
                                                              : ""
                                                          }`}
                                                        ></i>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="row mb2">
                                                    {showUSDT &&
                                                      usdtList.map(
                                                        (result, key) => (
                                                          <div
                                                            className="col-lg-4 col-md-4 col-sm-6 mt-4"
                                                            key={key}
                                                          >
                                                            <div
                                                              className="sub_deposit_box pointercursor"
                                                              onClick={() =>
                                                                openTab(
                                                                  result?.name,
                                                                  result?.payment_method,
                                                                  process.env
                                                                    .REACT_APP_IMAGE_URL +
                                                                    result?.image,
                                                                  "",
                                                                  result?.payment_category,
                                                                  result?.id,
                                                                )
                                                              }
                                                            >
                                                              <div className="inner_deposit_box">
                                                                <img
                                                                  src={
                                                                    process.env
                                                                      .REACT_APP_IMAGE_URL +
                                                                    result?.image
                                                                  }
                                                                  alt={
                                                                    result?.name
                                                                  }
                                                                />
                                                                <h5 className="sub_card_title">
                                                                  {result?.name}
                                                                </h5>
                                                              </div>

                                                              <div className="inner_deposit_footer">
                                                                <div>
                                                                  {t("Min")}: $
                                                                  {
                                                                    result?.minimum_amount
                                                                  }
                                                                </div>
                                                                <div className="borderLeft">
                                                                  ~
                                                                  {result?.time}{" "}
                                                                  {t("min")}.
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        ),
                                                      )}
                                                  </div>
                                                </div>
                                              </div>
                                            ) : (
                                              ""
                                            )}

                                            {/* USDC DROPDOWN */}
                                            {usdcList?.length ? (
                                              <div className="col-12">
                                                <div className="moreoptcion01dropdown">
                                                  <div
                                                    className="sub_deposit_box pointercursor moreoptcion01"
                                                    onClick={() =>
                                                      setShowUSDC(!showUSDC)
                                                    }
                                                  >
                                                    <div className="inner_deposit_box">
                                                      <h5 className="sub_card_title ms-2">
                                                        <img
                                                          src={ERC20_USDC}
                                                          alt=""
                                                        />{" "}
                                                        USD Coin (USDC)
                                                      </h5>
                                                      <div className="right_center">
                                                        <span>
                                                          {t(
                                                            "Select a network",
                                                          )}
                                                        </span>
                                                        <span>
                                                          {t("Available")}:{" "}
                                                          {usdcList?.length}
                                                        </span>
                                                        <i
                                                          className={`fa-solid fa-angle-down text-white ${
                                                            showUSDC
                                                              ? "arrowup01"
                                                              : ""
                                                          }`}
                                                        ></i>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="row mb2">
                                                    {showUSDC &&
                                                      usdcList.map(
                                                        (result, key) => (
                                                          <div
                                                            className="col-lg-4 col-md-4 col-sm-6 mt-4"
                                                            key={key}
                                                          >
                                                            <div
                                                              className="sub_deposit_box pointercursor"
                                                              onClick={() =>
                                                                openTab(
                                                                  result?.name,
                                                                  result?.payment_method,
                                                                  process.env
                                                                    .REACT_APP_IMAGE_URL +
                                                                    result?.image,
                                                                  "",
                                                                  result?.payment_category,
                                                                  result?.id,
                                                                )
                                                              }
                                                            >
                                                              <div className="inner_deposit_box">
                                                                <img
                                                                  src={
                                                                    process.env
                                                                      .REACT_APP_IMAGE_URL +
                                                                    result?.image
                                                                  }
                                                                  alt={
                                                                    result?.name
                                                                  }
                                                                />
                                                                <h5 className="sub_card_title">
                                                                  {result?.name}
                                                                </h5>
                                                              </div>

                                                              <div className="inner_deposit_footer">
                                                                <div>
                                                                  {t("Min")}: $
                                                                  {
                                                                    result?.minimum_amount
                                                                  }
                                                                </div>
                                                                <div className="borderLeft">
                                                                  ~
                                                                  {result?.time}{" "}
                                                                  {t("min")}.
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        ),
                                                      )}
                                                  </div>
                                                </div>
                                              </div>
                                            ) : (
                                              ""
                                            )}

                                            {/* OTHER CRYPTO (BTC / TRX / Ton Connect etc) */}
                                            {otherCrypto.map((result, key) =>
                                              result?.name === "Ton Connect" ? (
                                                <div
                                                  className="col-lg-4 col-md-4 col-sm-6 mb-4"
                                                  key={key}
                                                >
                                                  <div className="sub_deposit_box pointercursor">
                                                    <div className="connectWalletbtn">
                                                      {!useTonAddress1 && (
                                                        <h5 className="sub_card_title">
                                                          {result?.name}
                                                        </h5>
                                                      )}
                                                      <TonConnectButton />
                                                      {useTonAddress1 && (
                                                        <h5 className="sub_card_title m-0">
                                                          <button
                                                            type="button"
                                                            className="btn bg_btn"
                                                            onClick={
                                                              handleConnect
                                                            }
                                                          >
                                                            {t("Ton Deposit")}
                                                          </button>
                                                        </h5>
                                                      )}
                                                    </div>
                                                    <div className="inner_deposit_footer">
                                                      <div>
                                                        {t("Min")}: $
                                                        {result?.minimum_amount}
                                                      </div>
                                                      <div className="borderLeft">
                                                        ~{result?.time}{" "}
                                                        {t("min")}.
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : (
                                                <div
                                                  className="col-lg-4 col-md-4 col-sm-6 mb-4"
                                                  key={key}
                                                >
                                                  <div
                                                    className="sub_deposit_box pointercursor"
                                                    onClick={() =>
                                                      openTab(
                                                        result?.name,
                                                        result?.payment_method,
                                                        process.env
                                                          .REACT_APP_IMAGE_URL +
                                                          result?.image,
                                                        "",
                                                        result?.payment_category,
                                                        result?.id,
                                                      )
                                                    }
                                                  >
                                                    <div className="inner_deposit_box">
                                                      <img
                                                        src={
                                                          process.env
                                                            .REACT_APP_IMAGE_URL +
                                                          result?.image
                                                        }
                                                        alt={result?.name}
                                                      />
                                                      <h5 className="sub_card_title">
                                                        {result?.name}
                                                      </h5>
                                                    </div>
                                                    <div className="inner_deposit_footer">
                                                      <div>
                                                        {t("Min")}: $
                                                        {result?.minimum_amount}
                                                      </div>
                                                      <div className="borderLeft">
                                                        ~{result?.time}{" "}
                                                        {t("min")}.
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ),
                                            )}
                                          </>
                                        ) : (
                                          filteredData?.map((result, key) => {
                                            const currency =
                                              paymentcalc?.currency;
                                            const shouldHide =
                                              !currency ||
                                              (result?.payment_method ===
                                                "phonepe" &&
                                                currency !== "INR") ||
                                              (result?.payment_method ===
                                                "jazzcash_l" &&
                                                currency !== "PKR");
                                            return result?.name ===
                                              "Ton Connect" ? (
                                              <div
                                                className="col-lg-4 col-md-4 col-sm-6 mb-4"
                                                key={key}
                                              >
                                                <div className="sub_deposit_box pointercursor">
                                                  <div className="connectWalletbtn">
                                                    {!useTonAddress1 && (
                                                      <h5 className="sub_card_title">
                                                        {result?.name}
                                                      </h5>
                                                    )}
                                                    <TonConnectButton />
                                                    {useTonAddress1 && (
                                                      <h5 className="sub_card_title m-0">
                                                        <button
                                                          type="button"
                                                          className="btn bg_btn"
                                                          onClick={
                                                            handleConnect
                                                          }
                                                        >
                                                          {t("Ton Deposit")}
                                                        </button>
                                                      </h5>
                                                    )}
                                                  </div>
                                                  <div className="inner_deposit_footer">
                                                    <div>
                                                      {t("Min")}: $
                                                      {result?.minimum_amount}
                                                    </div>
                                                    <div className="borderLeft">
                                                      ~{result?.time} {t("min")}
                                                      .
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : (
                                              <>
                                                <div
                                                  className={`col-lg-4 col-md-4 col-sm-6 mb-4 `}
                                                  key={key}
                                                >
                                                  <div
                                                    className="sub_deposit_box pointercursor"
                                                    onClick={() =>
                                                      openTab(
                                                        result?.name,
                                                        result?.payment_method,
                                                        process.env
                                                          .REACT_APP_IMAGE_URL +
                                                          result?.image,
                                                        "",
                                                        result?.payment_category,
                                                        result?.id,
                                                      )
                                                    }
                                                  >
                                                    <div className="inner_deposit_box">
                                                      <img
                                                        src={
                                                          process.env
                                                            .REACT_APP_IMAGE_URL +
                                                          result?.image
                                                        }
                                                        alt={result?.name}
                                                      />
                                                      <h5 className="sub_card_title">
                                                        {result?.name}
                                                      </h5>
                                                    </div>
                                                    <div className="inner_deposit_footer">
                                                      <div>
                                                        {t("Min")}: $
                                                        {result?.minimum_amount}
                                                      </div>
                                                      <div className="borderLeft">
                                                        ~{result?.time}{" "}
                                                        {t("min")}.
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                {isBank &&
                                                  hasUnmatched &&
                                                  ((!hasAnyMatched &&
                                                    !showAllBanks) ||
                                                    (!showAllBanks &&
                                                      key ===
                                                        lastMatchedIndex) ||
                                                    (showAllBanks &&
                                                      key === lastIndex)) && (
                                                    <div className="col-lg-4 col-md-4 col-sm-6 mb-4">
                                                      <div
                                                        className="sub_deposit_box pointercursor moreoptcion01"
                                                        onClick={() =>
                                                          setShowAllBanks(
                                                            !showAllBanks,
                                                          )
                                                        }
                                                      >
                                                        <div className="inner_deposit_box">
                                                          <i className="fa-solid fa-building-columns text-white"></i>

                                                          <h5 className="sub_card_title ms-2">
                                                            {showAllBanks
                                                              ? t("Hide Banks")
                                                              : t("More Banks")}
                                                          </h5>

                                                          <i
                                                            className={`fa-solid fa-angle-down text-white ${
                                                              showAllBanks
                                                                ? "arrowup01"
                                                                : ""
                                                            }`}
                                                          ></i>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )}
                                              </>
                                            );
                                          })
                                        )}
                                      </div>
                                    );
                                  })
                                ) : null}
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-12 col-sm-12">
                              <div className="deposit_secure mb-4">
                                <ul className="icontext">
                                  <li>
                                    <img src={moneyrecive} alt="" />{" "}
                                    <span>
                                      {t("Minimum deposit amount :")}{" "}
                                      <strong>$10</strong>
                                    </span>
                                  </li>
                                  <li>
                                    <img src={moneywithdrawal} alt="" />{" "}
                                    <span>
                                      {t("Minimum withdrawal amount :")}{" "}
                                      <strong>$10</strong>
                                    </span>
                                  </li>
                                  <li>
                                    <img src={ChevronRightDuo} alt="" />
                                    {t("Quick withdrawal from your account")}
                                  </li>
                                  <li>
                                    <img src={divide02} alt="" />{" "}
                                    {t("Without a fee")}
                                  </li>
                                </ul>
                                <div className="depositlogos">
                                  <img
                                    src={image2319}
                                    alt=""
                                    onLoad={(e) =>
                                      e.target.classList.add("loaded")
                                    }
                                  />
                                  <img
                                    src={image2320}
                                    alt=""
                                    onLoad={(e) =>
                                      e.target.classList.add("loaded")
                                    }
                                  />
                                  <img
                                    src={image2321}
                                    alt=""
                                    onLoad={(e) =>
                                      e.target.classList.add("loaded")
                                    }
                                  />
                                  <img
                                    src={image2322}
                                    alt=""
                                    onLoad={(e) =>
                                      e.target.classList.add("loaded")
                                    }
                                  />
                                  <img
                                    src={image2323}
                                    alt=""
                                    onLoad={(e) =>
                                      e.target.classList.add("loaded")
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="paymentdetails"
                        role="tabpanel"
                        aria-labelledby="paymentdetails-tab"
                      >
                        <div className="row">
                          <div className="col-12">
                            <div className="cardBox paymentdetailsbox">
                              <div className="row paymentinfo03 mb-3 align-items-center">
                                <div className="col-lg-4 col-md-4 col-sm-3 col-3">
                                  <img src={paymenttype?.logo} alt="" />
                                </div>
                                <div className="col-lg-8 col-md-8 col-sm-9 col-9">
                                  <h5 className="sub_card_title">
                                    {paymenttype?.name}
                                  </h5>
                                  <p>
                                    {t("Commission")}:{" "}
                                    {paymentcalc?.Commission
                                      ? paymentcalc?.Commission
                                      : 0}
                                    %
                                    <br />
                                    {t("Minimum deposit amount:")} $
                                    {paymentcalc?.mindeposit
                                      ? paymentcalc?.mindeposit
                                      : 0}
                                    <br />
                                    {t("Max. amount per transaction")}: $
                                    {paymentcalc?.maxamount
                                      ? paymentcalc?.maxamount
                                      : 0}
                                    <br />
                                    {t("Processing time:")} ~
                                    {paymentcalc?.processtime
                                      ? paymentcalc?.processtime
                                      : 0}{" "}
                                    {t("min.")}
                                  </p>
                                </div>
                              </div>
                              {loadings?.step1 ? (
                                <div className="col-lg-12 col-md-6">
                                  <div className="cardBox paymentexecutionbox">
                                    <div className="text-center">
                                      <div
                                        className="spinner-border"
                                        role="status"
                                      ></div>
                                      <p>{t("Payment Processing...")}</p>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <form className="darkInput">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      {t("Amount")} :
                                    </label>
                                    <div className="input-group">
                                      <input
                                        onChange={(e) =>
                                          setuppaymentdetails(
                                            "amount",
                                            e.target.value,
                                          )
                                        }
                                        value={paymentdetails?.amount}
                                        onBlur={handleBlur}
                                        min={paymentcalc?.mindeposit}
                                        max={paymentcalc?.maxamount}
                                        autoComplete="off"
                                        inputMode="numeric"
                                        type="number"
                                        className={`${
                                          paymentvalidcation?.amount
                                            ? "form-control border-danger"
                                            : "form-control"
                                        }`}
                                        placeholder=""
                                        name="amount"
                                      />
                                      <span
                                        className="input-group-text"
                                        id="basic-addon1"
                                      >
                                        $
                                      </span>
                                    </div>
                                    {paymentvalidcation?.amount ? (
                                      <p className="text-danger">
                                        {t("Enter Amount")}
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  {paymenttype?.type === "bkash_api_v" ||
                                  paymenttype?.type === "bkash_p2p" ? (
                                    <div className="mb-3">
                                      {paymenttype?.type === "bkash_api_v" ? (
                                        <>
                                          <label className="form-label">
                                            <b>
                                              {t(
                                                "Check your bKash wallet balance before paying",
                                              )}
                                            </b>
                                          </label>
                                          <label className="form-label">
                                            {t(
                                              "Enter your bKash mobile number from which the transfer will be made, click Next",
                                            )}
                                          </label>
                                        </>
                                      ) : (
                                        ""
                                      )}

                                      <label className="form-label">
                                        {t("Enter your phone number:")}
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          value={
                                            paymentdetails?.phone_number || ""
                                          }
                                          onChange={(e) =>
                                            handlePhoneChange(e, "phone_number")
                                          }
                                          onKeyDown={(e) => {
                                            if (e.key === " ") {
                                              e.preventDefault();
                                            }
                                          }}
                                          maxLength="11"
                                          className={`form-control ${
                                            paymentvalidcation?.phone_number
                                              ? "border-danger"
                                              : ""
                                          }`}
                                        />
                                      </div>
                                      {paymentvalidcation?.phone_number ? (
                                        <p className="text-danger">
                                          {paymentvalidcation?.phone_number}
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {paymenttype?.type === "nagad_api_v" ||
                                  paymenttype?.type === "bkash_b" ||
                                  paymenttype?.type === "jazzcash_fast" ? (
                                    <div className="mb-3">
                                      <label className="form-label">
                                        {paymenttype?.type === "bkash_b"
                                          ? "Your bKash Account Number"
                                          : paymenttype?.type ===
                                              "jazzcash_fast"
                                            ? "Your Jazzcash Fast Account Number"
                                            : "Enter your Nagad wallet number, click Pay."}
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          value={
                                            paymentdetails?.account_number || ""
                                          }
                                          onChange={(e) =>
                                            handlePhoneChange(
                                              e,
                                              "account_number",
                                              paymenttype?.type,
                                            )
                                          }
                                          maxLength="11"
                                          className={`form-control ${
                                            paymentvalidcation?.account_number
                                              ? "border-danger"
                                              : ""
                                          }`}
                                        />
                                      </div>
                                      {paymentvalidcation?.account_number ? (
                                        <p className="text-danger">
                                          {paymentvalidcation?.account_number}
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {settledref.current ? (
                                    <div className="mb-3">
                                      <label className="form-label checkbox-input">
                                        <input
                                          onChange={(e) =>
                                            setuppaymentdetails(
                                              "checkpromo",
                                              !paymentdetails?.checkpromo,
                                            )
                                          }
                                          checked={paymentdetails?.checkpromo}
                                          type="checkbox"
                                          // value="lowerText"
                                          id="lowerCheck"
                                          onclick="toggleCheckbox(this)"
                                        />
                                        {t("I have a Bonus Code")}
                                      </label>
                                      {paymentdetails?.checkpromo ? (
                                        <>
                                          <div className="input-group my-3">
                                            <input
                                              type="text"
                                              placeholder={t(
                                                "Enter Bonus Code",
                                              )}
                                              value={paymentdetails?.promocode}
                                              aria-label="Bonus Code"
                                              onChange={(e) => {
                                                const value = e.target.value;

                                                setuppaymentdetails(
                                                  "promocode",
                                                  value,
                                                );
                                                if (value.length > 2) {
                                                  checkpomocode(
                                                    value,
                                                    "deposit",
                                                  );
                                                } else {
                                                  setPaymentvalidcation(
                                                    (state) => ({
                                                      ...state,
                                                      promocode: false,
                                                      text: "",
                                                    }),
                                                  );
                                                }
                                              }}
                                              className={`${
                                                paymentvalidcation?.promocode
                                                  ? "form-control border-danger"
                                                  : "form-control"
                                              }`}
                                            />
                                            {paymentdetails?.promocode ? (
                                              <button
                                                type="button"
                                                className="btn btn-primary"
                                                style={{
                                                  background: "#474451",
                                                  borderRadius: "8px",
                                                }}
                                                onClick={() => {
                                                  setPomocodedata({
                                                    code: "",
                                                    discount: "",
                                                    min_deposit: "",
                                                    deposit: "",
                                                    bonusamount: 0,
                                                    showtrams: false,
                                                  });
                                                  setPaymentvalidcation(
                                                    (state) => ({
                                                      ...state,
                                                      promocode: false,
                                                      text: "",
                                                    }),
                                                  );
                                                  setuppaymentdetails(
                                                    "promocode",
                                                    "",
                                                  );
                                                }}
                                              >
                                                {t("Delete")}
                                              </button>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                          {paymentvalidcation?.promocode ? (
                                            <div className="alertBox">
                                              <div className="alert alert-danger">
                                                <ul>
                                                  <li>
                                                    {paymentvalidcation?.text}
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                          ) : (
                                            // <p className="text-danger">
                                            //   {paymentvalidcation?.text}
                                            // </p>
                                            ""
                                          )}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  ) : // withdrawalamount?.bonuscode
                                  //     ?.promo_code ? (
                                  //   <div className="mb-3">
                                  //     <div class="alertBox">
                                  //       <div class="alert alert-warning">
                                  //         <ul>
                                  //           <li>
                                  //             {
                                  //               withdrawalamount?.bonuscode
                                  //                 ?.promo_code
                                  //             }{" "}
                                  //             bonus code is already active.
                                  //           </li>
                                  //         </ul>
                                  //       </div>
                                  //     </div>
                                  //   </div>
                                  // ) :
                                  !settledref.current ? (
                                    <div className="mb-3">
                                      <div class="alertBox">
                                        <div class="alert alert-warning">
                                          <ul>
                                            <li>
                                              {t(
                                                "New bonus funds cannot be added while a trade is open.",
                                              )}
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  <div className="row">
                                    {paymenttype?.type === "Stripe" ? (
                                      <>
                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                          <div className="mb-3">
                                            <label className="form-label">
                                              {t("Name :")}
                                            </label>
                                            <input
                                              onChange={(e) =>
                                                setuppaymentdetails(
                                                  "firstname",
                                                  e.target.value,
                                                )
                                              }
                                              value={paymentdetails?.firstname}
                                              type="text"
                                              className={`${
                                                paymentvalidcation?.firstname
                                                  ? "form-control border-danger"
                                                  : "form-control"
                                              }`}
                                              placeholder=""
                                              name="firstname"
                                            />
                                            {paymentvalidcation?.firstname ? (
                                              <p className="text-danger">
                                                {t("Enter Name")}
                                              </p>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </div>
                                        {/* <div className="col-lg-6 col-md-6 col-sm-12">
                                          <div className="mb-3">
                                            <label className="form-label">
                                              Last name:
                                            </label>
                                            <input
                                              onChange={(e) =>
                                                setuppaymentdetails(
                                                  "lastname",
                                                  e.target.value
                                                )
                                              }
                                              value={paymentdetails?.lastname}
                                              type="text"
                                              className={`${
                                                paymentvalidcation?.lastname
                                                  ? "form-control border-danger"
                                                  : "form-control"
                                              }`}
                                              placeholder=""
                                              name="lastname"
                                            />
                                            {paymentvalidcation?.lastname ? (
                                              <p className="text-danger">
                                                Enter Last Name
                                              </p>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </div> */}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                  {pomocodedata?.showtrams &&
                                    paymentdetails?.promocode && (
                                      <div className="alertBox">
                                        <div className="alert alert-success">
                                          <p>
                                            {t("Terms and Conditions")}:
                                            <br />
                                            {t(
                                              "Min. deposit to activate a promo code",
                                            )}
                                            : $
                                            {formatPrice(
                                              pomocodedata?.min_deposit,
                                              2,
                                            )}
                                            <br />
                                            {t(
                                              "Max. bonus amount available with this promo code",
                                            )}
                                            : $
                                            {formatPrice(
                                              pomocodedata?.max_bonus,
                                              2,
                                            )}
                                            <br />
                                            {t("Bonus")}:{" "}
                                            {pomocodedata?.discount}%
                                            <br />
                                            {t(
                                              "You can take profit and invested funds at any time.",
                                            )}
                                            <br />
                                            {t(
                                              "The bonus becomes withdrawable if your total trade amount exceeds",
                                            )}{" "}
                                            $
                                            {formatPrice(
                                              Number(
                                                pomocodedata?.turnover_required,
                                              ) *
                                                Number(paymentdetails?.amount),
                                              2,
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                    )}

                                  <div className="mb-3">
                                    <h5 className="price-title">
                                      {t("You receive:")}{" "}
                                      <strong>
                                        $
                                        {pomocodedata?.code &&
                                        pomocodedata?.bonusamount &&
                                        paymentdetails?.promocode
                                          ? formatPrice(
                                              Number(paymentdetails?.amount) +
                                                Number(
                                                  pomocodedata?.bonusamount,
                                                ),
                                              2,
                                            )
                                          : formatPrice(
                                              Number(paymentdetails?.amount),
                                              2,
                                            )}
                                      </strong>
                                    </h5>
                                  </div>
                                  {/* {
                                 paymenttype?.type === "Stripe" ? ( */}
                                  <div
                                    className="mb-3"

                                    //  onClick={() =>
                                    //   sendTon(paymentdetails)
                                    // }
                                  >
                                    {paymenttype?.type === "Ton" ? (
                                      checktonnetwork ? (
                                        <div className="alertBox">
                                          <div className="alert alert-danger">
                                            <ul>
                                              <li>
                                                {t(
                                                  "Only real (mainnet) accounts are allowed. Please switch to mainnet.",
                                                )}
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      ) : (
                                        ""
                                      )
                                    ) : (
                                      ""
                                    )}
                                    {paymenttype?.category === "apay" ||
                                    paymenttype?.category === "1Plate" ? (
                                      currencyloading ? (
                                        <button
                                          type="button"
                                          className="btn bg_btn"
                                        >
                                          {t("Continue and pay")}(
                                          <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                          )
                                        </button>
                                      ) : (
                                        <button
                                          onClick={() =>
                                            payvalidaction(paymentdetails)
                                          }
                                          type="button"
                                          className="btn bg_btn"
                                        >
                                          {t("Continue and pay")}
                                          {(paymentcalc?.allcurrncydata
                                            ?.converted &&
                                            paymenttype?.category === "apay") ||
                                          paymenttype?.category === "1Plate"
                                            ? `(${paymentcalc?.currencySymbol} ${Number(paymentdetails?.amount) === 0 ? 0 : formatPrice(Number(paymentcalc?.allcurrncydata?.converted), 2)})`
                                            : ""}
                                        </button>
                                      )
                                    ) : (
                                      <button
                                        onClick={() =>
                                          payvalidaction(paymentdetails)
                                        }
                                        type="button"
                                        className="btn bg_btn"
                                      >
                                        {t("Continue and pay")}
                                        {paymentcalc?.allcurrncydata
                                          ?.converted &&
                                        paymenttype?.category === "apay"
                                          ? `(${paymentcalc?.currencySymbol} ${Number(paymentdetails?.amount) === 0 ? 0 : formatPrice(Number(paymentcalc?.allcurrncydata?.converted), 2)})`
                                          : ""}
                                      </button>
                                    )}
                                  </div>
                                  {/* ) 
                                 : (
                                   //  <PayPalScriptProvider
                                   //  options={{
                                   //    "client-id": CLIENT_ID,
                                   //    currency: "USD",
                                   //  }}
                                   //  >
                                   <Paypalpaymwent
                                     paymentdetails={paymentdetails}
                                     openTab={openTab}
                                     tempAmount={tempAmount}
                                   />
                                 )
                                 // </PayPalScriptProvider>
                               } */}

                                  <div className="links mb-3">
                                    <Link
                                      to={`${base_url}supportdashboard`}
                                      state={{ from: "my_requests" }}
                                    >
                                      {t("Contact Support Service")}
                                    </Link>
                                  </div>
                                  <div className="row">
                                    <div className="col-12">
                                      <div className="mb-3">
                                        <label className="form-label">
                                          {t("Choose your Gift for deposit:")}
                                        </label>
                                      </div>
                                      <ul className="chooseyourGift">
                                        {paymentgiftlist?.length
                                          ? paymentgiftlist.map(
                                              (result, key) => {
                                                return (
                                                  <li
                                                    onClick={(e) =>
                                                      setupgifts(
                                                        `gift${result?.style}`,
                                                        result?.id,
                                                        result?.deposit_amount,
                                                        result?.style,
                                                      )
                                                    }
                                                    style={{
                                                      boxShadow:
                                                        giftstyle?.type ===
                                                        `gift${result?.style}`
                                                          ? giftstyle?.boxShadow
                                                          : "",
                                                      border:
                                                        giftstyle?.type ===
                                                        `gift${result?.style}`
                                                          ? giftstyle?.border
                                                          : "",
                                                    }}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title={result?.description}
                                                    key={key}
                                                  >
                                                    <img
                                                      src={
                                                        process.env
                                                          .REACT_APP_IMAGE_URL +
                                                        result?.image
                                                      }
                                                      alt=""
                                                    />
                                                  </li>
                                                );
                                              },
                                            )
                                          : ""}
                                      </ul>
                                    </div>
                                  </div>
                                </form>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="paymentprocess"
                        role="tabpanel"
                        aria-labelledby="paymentprocess-tab"
                      >
                        {paymenttype?.type === "Stripe" ? (
                          <></>
                        ) : // <Elements stripe={stripePromise}>
                        //   <Stripe
                        //     complitepayment={complitepayment}
                        //     paymentdetails={paymentdetails}
                        //     openTab={openTab}
                        //     setCheckstripepayment={setCheckstripepayment}
                        //     checkstripepayment={checkstripepayment}
                        //   />
                        // </Elements>
                        paymenttype?.type === "BTC" ||
                          paymenttype?.type === "Ton" ||
                          paymenttype?.type === "BTC" ||
                          paymenttype?.type === "XRP" ||
                          paymenttype?.type === "ETH" ||
                          paymenttype?.type === "ETH-USDT" ||
                          paymenttype?.type === "BNB" ||
                          paymenttype?.type === "BNB-USDC" ||
                          paymenttype?.type === "BNB-USDT" ||
                          paymenttype?.type === "ETH-USDC" ||
                          paymenttype?.type === "TRX" ||
                          paymenttype?.type === "USDC" ||
                          paymenttype?.type === "USDT" ||
                          paymenttype?.type === "XMR" ||
                          paymenttype?.type === "AVAX" ||
                          paymenttype?.type === "DOGE" ||
                          paymenttype?.type === "AVALANCHE-USDC" ||
                          paymenttype?.type === "AVALANCHE-USDT" ||
                          paymenttype?.type === "LTC" ||
                          paymenttype?.type === "MATIC" ||
                          paymenttype?.type === "POLYGON-USDC" ||
                          paymenttype?.type === "POLYGON-USDT" ||
                          paymenttype?.category === "bitcart" ||
                          paymenttype?.category === "nowpayment" ? (
                          loadings?.step2 ? (
                            <div className="col-lg-12 col-md-6">
                              <div className="cardBox paymentexecutionbox">
                                <div className="text-center">
                                  <div
                                    className="spinner-border"
                                    role="status"
                                  ></div>
                                  <p>{t("Payment Processing...")}</p>
                                </div>
                              </div>
                            </div>
                          ) : cryptoypaymentinfo?.error ? (
                            <div className="col-lg-12 col-md-12">
                              <div className="cardBox paymentexecutionbox">
                                <div className="text-center">
                                  <div
                                    className="payment-success"
                                    style={{
                                      color: "#ff0000",
                                    }}
                                  >
                                    <i className="fa-regular fa-circle-xmark"></i>
                                  </div>

                                  <p>{cryptoypaymentinfo?.error}</p>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="Payment_details-mobileview">
                              <div className="row justify-content-center align-items-center">
                                <div className="col-lg-9 col-md-11 col-12">
                                  <div className="alertBox">
                                    <div className="alert alert-warning poalt">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        height="24"
                                        fill="rgba(240,187,64,1)"
                                      >
                                        <path d="M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM10.9999 16.0002V18.0002H12.9999V16.0002H10.9999ZM10.9999 9.00017V14.0002H12.9999V9.00017H10.9999Z"></path>
                                      </svg>
                                      <ul>
                                        <li>
                                          <Trans
                                            i18nKey="auto_payment_message"
                                            values={{
                                              paymentName: paymenttype?.name,
                                            }}
                                            components={{ strong: <strong /> }}
                                          />
                                        </li>
                                        <li>
                                          <Trans
                                            i18nKey="use_network_message"
                                            values={{
                                              networkName: paymentcalc?.network,
                                            }}
                                            components={{ strong: <strong /> }}
                                          />
                                        </li>
                                        <li>
                                          <strong>
                                            {t(
                                              "Failure to meet one of the requirements will result in the loss of funds.",
                                            )}
                                          </strong>
                                        </li>
                                      </ul>
                                      <img
                                        className="alertpaymenttype-icon"
                                        src={paymenttype?.logo}
                                        style={{
                                          width: "auto",
                                          height: "80px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-5 col-md-6">
                                  <div
                                    className="cardBox paymentdetailsbox mb-4"
                                    style={{ maxWidth: "100%" }}
                                  >
                                    <form action="#" className="darkInput">
                                      <div className="mb-3">
                                        <label className="form-label">
                                          {t(
                                            "Please deposit the same or a higher amount shown below. Lower amounts will not be credited, while any excess will be added to your account.",
                                          )}
                                        </label>
                                        <label className="form-label">
                                          {t(
                                            "To complete the payment, please transfer:",
                                          )}
                                        </label>
                                        <div className="input-group copyinputtext position-relative">
                                          {paymenttype?.category ===
                                          "bitcart" ? (
                                            <input
                                              value={`${cryptowallet?.amount} ${cryptowallet?.name}`}
                                              type="text"
                                              className="form-control"
                                              placeholder=""
                                              name="merchantname"
                                              disabled
                                            />
                                          ) : (
                                            <input
                                              value={`${cryptowallet?.amount} ${paymenttype?.type}`}
                                              type="text"
                                              className="form-control"
                                              placeholder=""
                                              name="merchantname"
                                              disabled
                                            />
                                          )}

                                          {!copied.amount ? (
                                            <div
                                              className="btn copy-btn"
                                              onClick={() =>
                                                handleCopy(
                                                  cryptowallet?.amount,
                                                  "amount",
                                                )
                                              }
                                            >
                                              <i className="fa-regular fa-copy"></i>{" "}
                                              {t("Copy")}
                                            </div>
                                          ) : (
                                            <div className="btn copied-btn">
                                              <i className="fa-solid fa-check"></i>{" "}
                                              {t("Copied")}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="mb-3">
                                        <label className="form-label">
                                          {t(
                                            `Only deposit via ${paymentcalc?.network} network:`,
                                          )}
                                        </label>
                                        <div className="input-group copyinputtext position-relative">
                                          <input
                                            value={cryptowallet?.wallet}
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            name="upiid"
                                            disabled
                                          />
                                          {!copied.wallet ? (
                                            <div
                                              className="btn copy-btn"
                                              onClick={() =>
                                                handleCopy(
                                                  cryptowallet?.wallet,
                                                  "wallet",
                                                )
                                              }
                                            >
                                              <i className="fa-regular fa-copy"></i>{" "}
                                              {t("Copy")}
                                            </div>
                                          ) : (
                                            <div className="btn copied-btn">
                                              <i className="fa-solid fa-check"></i>{" "}
                                              {t("Copied")}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                                <div className="col-lg-4 col-md-5">
                                  <div className="qroption">
                                    <div>
                                      {paymenttype?.category === "bitcart" ? (
                                        <div
                                          // style={{ display: "none" }}
                                          ref={qrRef}
                                        >
                                          {/* <QRCode value={"ton://transfer/UQC_qaSScF4i18ofvzfYHnKoR_0C6qQIGuT20Ff7DusiFoaT?amount=1"} size={200} /> */}
                                          <QRCodeCanvas
                                            value={cryptowallet?.wallet}
                                            size={256}
                                            level="H"
                                            bgColor="#ffffff"
                                            fgColor="#000000"
                                            includeMargin={true}
                                          />
                                        </div>
                                      ) : (
                                        <div
                                          // style={{ display: "none" }}
                                          ref={qrRef}
                                        >
                                          {/* <QRCode value={"ton://transfer/UQC_qaSScF4i18ofvzfYHnKoR_0C6qQIGuT20Ff7DusiFoaT?amount=1"} size={200} /> */}
                                          <QRCodeCanvas
                                            value={cryptowallet?.wallet}
                                            size={256}
                                            level="H"
                                            bgColor="#ffffff"
                                            fgColor="#000000"
                                            includeMargin={true}
                                          />
                                        </div>
                                      )}
                                      {/* <img
                                      src={cryptowallet?.dataUrl}
                                      className="qrcodeimg"
                                      alt=""
                                    /> */}
                                      <p>
                                        <small>
                                          {t(
                                            "Or simply scan the generated Qr code to make your payment.",
                                          )}
                                        </small>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div class="spinner-border-loader">
                                    <span role="status">
                                      {t("Waiting for confirmation")}
                                    </span>
                                    <span
                                      class="spinner-grow spinner-grow-sm"
                                      aria-hidden="true"
                                    ></span>
                                    <span
                                      class="spinner-grow spinner-grow-sm"
                                      aria-hidden="true"
                                    ></span>
                                    <span
                                      class="spinner-grow spinner-grow-sm"
                                      aria-hidden="true"
                                    ></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        ) : paymenttype?.category === "apay" ? (
                          loadings?.step2 ? (
                            <div className="col-lg-12 col-md-6">
                              <div className="cardBox paymentexecutionbox">
                                <div className="text-center">
                                  <div
                                    className="spinner-border"
                                    role="status"
                                  ></div>
                                  <p>{t("Payment Processing...")}</p>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="row justify-content-center align-items-center">
                              {phonepaypaymentinfo?.error ? (
                                <div className="col-lg-12 col-md-12">
                                  <div className="cardBox paymentexecutionbox">
                                    <div className="text-center">
                                      <div
                                        className="payment-success"
                                        style={{
                                          color: "#ff0000",
                                        }}
                                      >
                                        <i className="fa-regular fa-circle-xmark"></i>
                                      </div>

                                      <p>{phonepaypaymentinfo?.message}</p>
                                    </div>
                                  </div>
                                </div>
                              ) : apayprocess ? (
                                <>
                                  <div className="col-lg-12 col-md-12">
                                    <div className="cardBox paymentexecutionbox mb-3">
                                      <div className="text-center payment-wrapper">
                                        <div className="processing-icon">
                                          <i
                                            className="fa-solid fa-clock"
                                            style={{
                                              color: "#fff",
                                              fontSize: "3.5rem",
                                            }}
                                          ></i>
                                        </div>

                                        <h5
                                          className="title pt-3"
                                          style={{ color: "#fff" }}
                                        >
                                          {t("Processing your payment")}
                                        </h5>
                                        <p className="subtitle">
                                          {t("Wait for deposit to be credited")}
                                        </p>

                                        <h2
                                          className="amount"
                                          style={{ color: "#fff" }}
                                        >
                                          {paymentcalc?.allcurrncydata
                                            ?.converted &&
                                          paymenttype?.category === "apay"
                                            ? `${
                                                paymentcalc?.currencySymbol
                                              } ${formatPrice(
                                                paymentcalc?.allcurrncydata
                                                  ?.converted,
                                              )}`
                                            : ""}
                                        </h2>

                                        <p className="info-text">
                                          {t(
                                            "The payment is being processed. It takes up to 5 minutes, but might be delayed due to bank transfer processing.",
                                          )}
                                        </p>
                                        <div className="back-link">
                                          <i className="fa-solid fa-angle-left"></i>
                                          <span>
                                            {t("Back to merchant store")}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="spinner-border-loader">
                                    <span role="status">
                                      {t("Waiting for confirmation")}
                                    </span>
                                    <span
                                      class="spinner-grow spinner-grow-sm"
                                      aria-hidden="true"
                                    ></span>
                                    <span
                                      class="spinner-grow spinner-grow-sm"
                                      aria-hidden="true"
                                    ></span>
                                    <span
                                      class="spinner-grow spinner-grow-sm"
                                      aria-hidden="true"
                                    ></span>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="col-lg-9 col-md-11 col-12">
                                    <div className="alertBox">
                                      <div className="alert alert-warning poalt">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 24 24"
                                          width="24"
                                          height="24"
                                          fill="rgba(240,187,64,1)"
                                        >
                                          <path d="M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM10.9999 16.0002V18.0002H12.9999V16.0002H10.9999ZM10.9999 9.00017V14.0002H12.9999V9.00017H10.9999Z"></path>
                                        </svg>
                                        <ul>
                                          <li>
                                            <Trans
                                              i18nKey="auto_payment_message"
                                              values={{
                                                paymentName: paymenttype?.name,
                                              }}
                                              components={{
                                                strong: <strong />,
                                              }}
                                            />
                                          </li>
                                          {/* <li>
                                          - Use only{" "}
                                          <strong>{paymenttype?.name}</strong>{" "}
                                          Network for your transfer
                                        </li> */}
                                          <li>
                                            <strong>
                                              {t(
                                                "Failure to meet one of the requirements will result in the loss of funds.",
                                              )}
                                            </strong>
                                          </li>
                                        </ul>
                                        <img
                                          className="alertpaymenttype-icon"
                                          src={paymenttype?.logo}
                                          style={{
                                            width: "auto",
                                            height: "80px",
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-9 col-md-11 col-12">
                                    <div className="input-group copyinputtext timerleft03 mb-3">
                                      <input
                                        value={t("Make the payment before")}
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name="merchantname"
                                        disabled
                                      />
                                      <div className="btn copy-btn">
                                        <span className="timerdown">
                                          {formatTime(timeLeft)}
                                        </span>{" "}
                                        {t("Time left")}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-5 col-md-6">
                                    {/* <div
                                      className="cardBox paymentdetailsbox mb-4"
                                      style={{ maxWidth: "100%" }}
                                    > */}
                                    <div
                                      className="mb-4"
                                      style={{ maxWidth: "100%" }}
                                    >
                                      <form
                                        action="#"
                                        className="darkInput label-line-height"
                                      >
                                        <div className="mb-3">
                                          <label className="form-label mb-3">
                                            {t(
                                              "Please deposit the same or a higher amount shown below. Lower amounts will not be credited, while any excess will be added to your account.",
                                            )}
                                          </label>
                                          {phonepaypaymentinfo?.payment_system ===
                                          "nagad_api_v" ? (
                                            <label className="form-label spn">
                                              <span>1</span>
                                              {t(
                                                "Copy account number from the account number field",
                                              )}
                                            </label>
                                          ) : (
                                            ""
                                          )}
                                          {phonepaypaymentinfo?.payment_system !==
                                          "egp_fast" ? (
                                            phonepaypaymentinfo?.payment_system !==
                                            "jazzcash_fast" ? (
                                              <div className="position-relative mb-3 inputGroupcopyinputtext">
                                                <label className="form-label posl">
                                                  {phonepaypaymentinfo?.payment_system ===
                                                  "nagad_api_v"
                                                    ? t(
                                                        "Recipient's account number:",
                                                      )
                                                    : phonepaypaymentinfo?.payment_system ===
                                                          "ipay_l" ||
                                                        phonepaypaymentinfo?.payment_system ===
                                                          "ipay_fast"
                                                      ? t(
                                                          "Copy Mobile number from the Mobile number field",
                                                        )
                                                      : paymentcalc?.currency ===
                                                          "INR"
                                                        ? t("UPI ID:")
                                                        : t(
                                                            "To complete the payment, please transfer:",
                                                          )}
                                                </label>
                                                <div className="input-group copyinputtext">
                                                  <input
                                                    value={
                                                      phonepaypaymentinfo?.transactiondata
                                                    }
                                                    type="text"
                                                    className="form-control pt"
                                                    placeholder=""
                                                    name="merchantname"
                                                    disabled
                                                  />
                                                  {!copied.transactiondata ? (
                                                    <div
                                                      className="btn copy-btn"
                                                      onClick={() =>
                                                        handleCopy(
                                                          phonepaypaymentinfo?.transactiondata,
                                                          "transactiondata",
                                                        )
                                                      }
                                                    >
                                                      <i className="fa-regular fa-copy"></i>{" "}
                                                    </div>
                                                  ) : (
                                                    <div className="btn copied-btn">
                                                      <i className="fa-solid fa-check"></i>{" "}
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            ) : (
                                              ""
                                            )
                                          ) : (
                                            ""
                                          )}
                                          <div className="position-relative mb-3">
                                            <label className="form-label posl">
                                              {t("Amount")} :
                                            </label>
                                            <div className="input-group copyinputtext">
                                              <input
                                                value={
                                                  paymentcalc?.allcurrncydata
                                                    ?.converted &&
                                                  paymenttype?.category ===
                                                    "apay"
                                                    ? `${paymentcalc?.currencySymbol} ${formatPrice(Number(paymentcalc?.allcurrncydata?.converted), 2)}`
                                                    : ""
                                                }
                                                type="text"
                                                className="form-control pt"
                                                placeholder=""
                                                name="merchantname"
                                                disabled
                                              />
                                              {!copied.converted ? (
                                                <div
                                                  className="btn copy-btn"
                                                  onClick={() =>
                                                    handleCopy(
                                                      paymentcalc
                                                        ?.allcurrncydata
                                                        ?.converted,
                                                      "converted",
                                                    )
                                                  }
                                                >
                                                  <i className="fa-regular fa-copy"></i>{" "}
                                                </div>
                                              ) : (
                                                <div className="btn copied-btn">
                                                  <i className="fa-solid fa-check"></i>{" "}
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                          {paymentcalc?.currency === "INR" ? (
                                            <>
                                              <label className="form-label spn">
                                                <span>1</span>{" "}
                                                {t(
                                                  "Transfer funds to the wallet in your UPI mobile app",
                                                )}
                                              </label>
                                              <label className="form-label spn">
                                                <span>2</span>{" "}
                                                {t(
                                                  "Confirm the payment by entering the UTR of the transaction in the Transaction UTR field.",
                                                )}
                                              </label>
                                              <div className="input-group copyinputtext">
                                                <input
                                                  onChange={(e) =>
                                                    setApaypaymentdetail(
                                                      e.target.value,
                                                    )
                                                  }
                                                  value={apaypaymentdetail}
                                                  type="number"
                                                  className={`form-control ${
                                                    validapay?.status
                                                      ? "border-danger"
                                                      : ""
                                                  }`}
                                                  placeholder="Transaction UTR"
                                                  name="merchantname"
                                                />
                                              </div>
                                              {validapay?.status ? (
                                                <label className="form-label text-danger">
                                                  {validapay?.message}
                                                </label>
                                              ) : (
                                                ""
                                              )}
                                              <div className="text-center">
                                                <button
                                                  type="button"
                                                  className="btn bg_btn w-100 justify-content-center mt-3"
                                                  onClick={() =>
                                                    confirmapaypayment(
                                                      phonepaypaymentinfo,
                                                      apaypaymentdetail,
                                                    )
                                                  }
                                                >
                                                  {t("Confirm")}
                                                </button>
                                              </div>
                                            </>
                                          ) : paymentcalc?.currency ===
                                            "PKR" ? (
                                            <>
                                              {phonepaypaymentinfo?.payment_system ===
                                              "jazzcash_l" ? (
                                                <>
                                                  {" "}
                                                  <label className="form-label spn">
                                                    <span>1</span>{" "}
                                                    {t(
                                                      "Go to the Jazzcash app, paste the Till id and make the transfer",
                                                    )}
                                                  </label>{" "}
                                                  <label className="form-label spn">
                                                    <span>2</span>{" "}
                                                    {t(
                                                      "Next, copy the Transaction ID and paste it into the Transaction ID field",
                                                    )}
                                                  </label>{" "}
                                                  <label className="form-label spn">
                                                    <span>3</span>{" "}
                                                    {t(
                                                      "Click Confirm and wait for the successful payment",
                                                    )}
                                                  </label>{" "}
                                                </>
                                              ) : phonepaypaymentinfo?.payment_system ===
                                                "nayapay_l" ? (
                                                <>
                                                  {" "}
                                                  <label className="form-label spn">
                                                    <span>1</span>{" "}
                                                    {t("nayapay_step_one")}
                                                  </label>{" "}
                                                  <label className="form-label spn">
                                                    <span>2</span>{" "}
                                                    {t(
                                                      "Attention! Deposits are accepted only when transferring from NayaPay",
                                                    )}
                                                  </label>{" "}
                                                  <label className="form-label spn">
                                                    <span>3</span>{" "}
                                                    {t(
                                                      "Paste the account number and make the transfer",
                                                    )}
                                                  </label>{" "}
                                                  <label className="form-label spn">
                                                    <span>4</span>{" "}
                                                    {t(
                                                      "Next, copy the Transaction ID and paste it into the Transaction ID field",
                                                    )}
                                                  </label>
                                                  <label className="form-label spn">
                                                    <span>5</span>{" "}
                                                    {t(
                                                      "Click Confirm and wait for the successful payment",
                                                    )}
                                                  </label>{" "}
                                                </>
                                              ) : phonepaypaymentinfo?.payment_system ===
                                                "jazzcash_fast" ? (
                                                ""
                                              ) : (
                                                <label className="form-label spn">
                                                  <span>1</span>{" "}
                                                  {t(
                                                    "Enter your easypaisa account number, click Pay",
                                                  )}
                                                </label>
                                              )}
                                              {phonepaypaymentinfo?.payment_system !==
                                              "jazzcash_fast" ? (
                                                <>
                                                  {" "}
                                                  <div className="input-group copyinputtext">
                                                    <input
                                                      onChange={(e) =>
                                                        setApaypaymentdetail(
                                                          e.target.value,
                                                        )
                                                      }
                                                      value={apaypaymentdetail}
                                                      type="number"
                                                      className={`form-control ${
                                                        validapay?.status
                                                          ? "border-danger"
                                                          : ""
                                                      }`}
                                                      placeholder={
                                                        phonepaypaymentinfo?.payment_system ===
                                                          "jazzcash_l" ||
                                                        phonepaypaymentinfo?.payment_system ===
                                                          "nayapay_l"
                                                          ? t("Transaction ID")
                                                          : t("Account number")
                                                      }
                                                      name="merchantname"
                                                    />
                                                  </div>
                                                  {validapay?.status ? (
                                                    <label className="form-label text-danger">
                                                      {validapay?.message}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}{" "}
                                                </>
                                              ) : (
                                                ""
                                              )}

                                              <div className="text-center">
                                                <button
                                                  type="button"
                                                  className="btn bg_btn mt-3"
                                                  onClick={() =>
                                                    confirmapaypayment(
                                                      phonepaypaymentinfo,
                                                      apaypaymentdetail,
                                                    )
                                                  }
                                                >
                                                  {t("Confirm")}
                                                </button>
                                              </div>
                                            </>
                                          ) : paymentcalc?.currency ===
                                            "BDT" ? (
                                            phonepaypaymentinfo?.payment_system ===
                                              "nagad_b" ||
                                            phonepaypaymentinfo?.payment_system ===
                                              "nagad_api_v" ? (
                                              <>
                                                {" "}
                                                {phonepaypaymentinfo?.payment_system ===
                                                "nagad_b" ? (
                                                  <>
                                                    <label className="form-label spn">
                                                      <span>1</span>
                                                      {t(
                                                        "Enter your Nagad wallet number, click Pay.",
                                                      )}
                                                    </label>
                                                    <div className="input-group copyinputtext">
                                                      <input
                                                        onChange={(e) =>
                                                          handleaccountvalid(e)
                                                        }
                                                        value={
                                                          apaypaymentdetail
                                                        }
                                                        type="text"
                                                        maxLength={11}
                                                        className={`form-control ${
                                                          validapay?.status
                                                            ? "border-danger"
                                                            : ""
                                                        }`}
                                                        placeholder="Account Number"
                                                        name="merchantname"
                                                      />
                                                    </div>
                                                    {validapay?.status ? (
                                                      <label className="form-label text-danger">
                                                        {validapay?.message}
                                                      </label>
                                                    ) : (
                                                      ""
                                                    )}
                                                    <label className="form-label spn">
                                                      <span>2</span>
                                                      {t(
                                                        "Wait for the Nagad B page to open, then enter your wallet number",
                                                      )}
                                                    </label>{" "}
                                                    <label className="form-label spn">
                                                      <span>3</span>{" "}
                                                      {t(
                                                        "Enter the one-time password that will be sent by SMS",
                                                      )}
                                                    </label>{" "}
                                                    <label className="form-label spn">
                                                      <span>4</span>{" "}
                                                      {t(
                                                        "Enter the PIN code from your wallet to confirm the payment",
                                                      )}
                                                    </label>
                                                  </>
                                                ) : (
                                                  <>
                                                    <label className="form-label spn mt-3">
                                                      <span>2</span>
                                                      {t("nagad_step_two")}
                                                    </label>{" "}
                                                    <label className="form-label spn">
                                                      <span>3</span>
                                                      {t(
                                                        "Paste the account number and make the transfer",
                                                      )}
                                                    </label>{" "}
                                                    <label className="form-label spn">
                                                      <span>4</span>{" "}
                                                      {t(
                                                        "Click Confirm and wait for the successful payment",
                                                      )}
                                                    </label>
                                                  </>
                                                )}
                                                <div className="text-center">
                                                  <button
                                                    type="button"
                                                    className="btn bg_btn w-100 justify-content-center mt-3"
                                                    onClick={() =>
                                                      confirmapaypayment(
                                                        phonepaypaymentinfo,
                                                        apaypaymentdetail,
                                                      )
                                                    }
                                                  >
                                                    {t("Confirm")}
                                                  </button>
                                                </div>
                                              </>
                                            ) : (
                                              <>
                                                {phonepaypaymentinfo?.payment_system !==
                                                "bkash_p2p" ? (
                                                  <>
                                                    <label className="form-label spn">
                                                      {t(
                                                        "After the payment, copy the Transaction ID and paste it below",
                                                      )}
                                                    </label>
                                                    <div className="input-group copyinputtext">
                                                      <input
                                                        onChange={(e) =>
                                                          setApaypaymentdetail(
                                                            e.target.value,
                                                          )
                                                        }
                                                        value={
                                                          apaypaymentdetail
                                                        }
                                                        type="text"
                                                        className={`form-control ${
                                                          validapay?.status
                                                            ? "border-danger"
                                                            : ""
                                                        }`}
                                                        placeholder={t(
                                                          "Transaction ID",
                                                        )}
                                                        name="merchantname"
                                                      />
                                                    </div>
                                                    {validapay?.status ? (
                                                      <label className="form-label text-danger">
                                                        {validapay?.message}
                                                      </label>
                                                    ) : (
                                                      ""
                                                    )}{" "}
                                                  </>
                                                ) : (
                                                  ""
                                                )}{" "}
                                                <div className="text-center">
                                                  <button
                                                    type="button"
                                                    className="btn bg_btn w-100 justify-content-center mt-3"
                                                    onClick={() =>
                                                      confirmapaypayment(
                                                        phonepaypaymentinfo,
                                                        apaypaymentdetail,
                                                      )
                                                    }
                                                  >
                                                    {t("Confirm")}
                                                  </button>
                                                </div>
                                              </>
                                            )
                                          ) : paymentcalc?.currency ===
                                            "EGP" ? (
                                            <div className="text-center">
                                              <button
                                                type="button"
                                                className="btn bg_btn w-100 justify-content-center mt-3"
                                                onClick={() =>
                                                  confirmapaypayment(
                                                    phonepaypaymentinfo,
                                                    apaypaymentdetail,
                                                  )
                                                }
                                              >
                                                {t("Confirm")}
                                              </button>
                                            </div>
                                          ) : paymentcalc?.currency ===
                                            "LKR" ? (
                                            <>
                                              <label className="form-label spn">
                                                <span>1</span>{" "}
                                                {t(
                                                  "Go to the Ipay app, choose 'Send Money' paste the Mobile number and make the transfer",
                                                )}
                                              </label>
                                              <label className="form-label spn">
                                                <span>!</span>{" "}
                                                {t(
                                                  "Please do not write any comments when transferring money",
                                                )}
                                              </label>
                                              <label className="form-label spn">
                                                <span>2</span>{" "}
                                                {t(
                                                  "Next, copy the Transaction ID and paste it into the Transaction ID field",
                                                )}
                                              </label>
                                              <div className="input-group copyinputtext">
                                                <input
                                                  onChange={(e) =>
                                                    setApaypaymentdetail(
                                                      e.target.value,
                                                    )
                                                  }
                                                  value={apaypaymentdetail}
                                                  type="number"
                                                  className={`form-control ${
                                                    validapay?.status
                                                      ? "border-danger"
                                                      : ""
                                                  }`}
                                                  placeholder={t(
                                                    "Transaction ID",
                                                  )}
                                                  name="merchantname"
                                                />
                                              </div>
                                              {validapay?.status ? (
                                                <label className="form-label text-danger">
                                                  {validapay?.message}
                                                </label>
                                              ) : (
                                                ""
                                              )}
                                              <div className="text-center">
                                                <button
                                                  type="button"
                                                  className="btn bg_btn w-100 justify-content-center mt-3"
                                                  onClick={() =>
                                                    confirmapaypayment(
                                                      phonepaypaymentinfo,
                                                      apaypaymentdetail,
                                                    )
                                                  }
                                                >
                                                  {t("Confirm")}
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                  {phonepaypaymentinfo?.paymentpage_url && (
                                    <div className="col-lg-4 col-md-5">
                                      <div className="qroption">
                                        <div>
                                          <div
                                            // style={{ display: "none" }}
                                            ref={qrapayRef}
                                          >
                                            {/* <QRCode value={"ton://transfer/UQC_qaSScF4i18ofvzfYHnKoR_0C6qQIGuT20Ff7DusiFoaT?amount=1"} size={200} /> */}
                                            <QRCodeCanvas
                                              value={
                                                phonepaypaymentinfo?.paymentpage_url
                                              }
                                              size={256}
                                              level="H"
                                              bgColor="#ffffff"
                                              fgColor="#000000"
                                              includeMargin={true}
                                            />
                                          </div>

                                          {/* <img
                                      src={cryptowallet?.dataUrl}
                                      className="qrcodeimg"
                                      alt=""
                                    /> */}
                                          <button
                                            className="btn btn-primary mt-2 bg_btn"
                                            onClick={downloadQR}
                                          >
                                            Download QR
                                          </button>
                                          <p>
                                            <small>
                                              {t(
                                                "Or simply scan the generated Qr code to make your payment.",
                                              )}
                                            </small>
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div class="spinner-border-loader">
                                    <span role="status">
                                      {t("Waiting for confirmation")}
                                    </span>
                                    <span
                                      class="spinner-grow spinner-grow-sm"
                                      aria-hidden="true"
                                    ></span>
                                    <span
                                      class="spinner-grow spinner-grow-sm"
                                      aria-hidden="true"
                                    ></span>
                                    <span
                                      class="spinner-grow spinner-grow-sm"
                                      aria-hidden="true"
                                    ></span>
                                  </div>
                                </>
                              )}
                            </div>
                          )
                        ) : paymenttype?.category === "1Plate" ? (
                          loadings?.step2 ? (
                            <div className="col-lg-12 col-md-6">
                              <div className="cardBox paymentexecutionbox">
                                <div className="text-center">
                                  <div
                                    className="spinner-border"
                                    role="status"
                                  ></div>
                                  <p>{t("Payment Processing...")}</p>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="row justify-content-center align-items-center">
                              {phonepaypaymentinfo?.error ? (
                                <div className="col-lg-12 col-md-12">
                                  <div className="cardBox paymentexecutionbox">
                                    <div className="text-center">
                                      <div
                                        className="payment-success"
                                        style={{
                                          color: "#ff0000",
                                        }}
                                      >
                                        <i className="fa-regular fa-circle-xmark"></i>
                                      </div>

                                      <p>{phonepaypaymentinfo?.message}</p>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          )
                        ) : (
                          <div className="row justify-content-center align-items-center">
                            <div className="col-lg-5 col-md-6">
                              <div
                                className="cardBox paymentdetailsbox mb-4"
                                style={{ maxWidth: "100%" }}
                              >
                                <form action="#" className="darkInput">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      {t("Transaction Amount:")}
                                    </label>
                                    <div className="input-group">
                                      <span
                                        className="input-group-text"
                                        id="basic-addon1"
                                      >
                                        $
                                      </span>
                                      <input
                                        disabled
                                        value={paymentdetails?.amount}
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name="transactionamount"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3">
                                    <label className="form-label">
                                      {t("You receive:")}
                                    </label>
                                    <div className="input-group">
                                      <input
                                        disabled
                                        value={paymentdetails?.amount}
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        name="upiid"
                                      />
                                    </div>
                                  </div>
                                  {checkpaypal ? (
                                    <div className="mb-3">
                                      <Paypalpaymwent
                                        paymentdetails={paymentdetails}
                                        openTab={openTab}
                                        tempAmount={tempAmount}
                                        complitepayment={complitepayment}
                                      />
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </form>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div
                        className="tab-pane fade"
                        id="paymentexecution"
                        role="tabpanel"
                        aria-labelledby="paymentexecution-tab"
                      >
                        <div className="row">
                          {checkstripepayment?.loading ? (
                            <div className="col-lg-12 col-md-6">
                              <div className="cardBox paymentexecutionbox">
                                <div className="text-center">
                                  <div
                                    className="spinner-border"
                                    role="status"
                                  ></div>
                                  <p>{t("Open your wallet and pay")}</p>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="col-lg-12 col-md-12">
                              <div className="cardBox paymentexecutionbox">
                                {checkstripepayment?.message ===
                                "Deposit Successfully" ? (
                                  <div className="text-center">
                                    <div className="payment-success">
                                      <i className="fa-regular fa-circle-check"></i>
                                    </div>
                                    <p>{checkstripepayment?.message}</p>
                                  </div>
                                ) : (
                                  <div className="text-center">
                                    <div
                                      className="payment-success"
                                      style={{
                                        color: "#ff0000",
                                      }}
                                    >
                                      <i className="fa-regular fa-circle-xmark"></i>
                                    </div>

                                    <p>{checkstripepayment?.message}</p>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${
                      state?.from === "withdrawal" && "show active"
                    }`}
                    id="withdrawal"
                    role="tabpanel"
                    aria-labelledby="withdrawal-tab"
                  >
                    <div className="withdrawal_tab">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 mb-lg-0 mb-3">
                          <div className="cardBox">
                            <div className="row">
                              <div className="col-12">
                                <h4 className="card_title">{t("Account")}</h4>
                              </div>
                              {withdrawalload ? (
                                <div className="loaderparentpositaion">
                                  {" "}
                                  <Commonloader show={true} />{" "}
                                </div>
                              ) : (
                                <>
                                  <div className="col-lg-6 col-md-12 col-sm-6 col-12 mb-4">
                                    <div className="sub_deposit_box">
                                      <div className="withdrawal_sub_deposit">
                                        <h5 className="sub_card_title mt-0">
                                          {t("In The Account")}
                                        </h5>
                                        <h3 className="sub_card_title">
                                          $
                                          {formatPrice(
                                            Number(
                                              walletprice?.available_balance,
                                            ) - Number(walletprice?.bonus),
                                            2,
                                          )}
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-md-12 col-sm-6 col-12 mb-4">
                                    <div className="sub_deposit_box">
                                      <div className="withdrawal_sub_deposit">
                                        <h5 className="sub_card_title mt-0">
                                          Deductable bonus profit{" "}
                                          {withdrawalamount?.bonus ? (
                                            <span className="position-relative toolTip-position-center">
                                              <i class="fa-solid fa-circle-exclamation"></i>
                                              <span class="toolTip01">
                                                If a withdrawal is made, all
                                                active bonuses will be
                                                automatically deducted.
                                              </span>
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </h5>
                                        <h3 className="sub_card_title">
                                          $
                                          {withdrawalamount?.bonus
                                            ? formatPrice(
                                                withdrawalamount?.bonus,
                                                2,
                                              )
                                            : "0.00"}
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-md-12 col-sm-6 col-12 mb-4">
                                    <div className="sub_deposit_box">
                                      <div className="withdrawal_sub_deposit">
                                        <h5 className="sub_card_title mt-0">
                                          Withdrawable amount
                                        </h5>
                                        {withdrawalload ? (
                                          <div className="col-lg-12 col-md-6">
                                            <div
                                              className="cardBox py-0 paymentexecutionbox"
                                              style={{ minHeight: "auto" }}
                                            >
                                              <div className="justify-content-center">
                                                <div
                                                  className="spinner-border"
                                                  role="status"
                                                ></div>
                                              </div>
                                            </div>
                                          </div>
                                        ) : (
                                          <h3 className="sub_card_title">
                                            $
                                            {formatPrice(
                                              Number(
                                                withdrawalamount?.withdrawable_amount,
                                              ),
                                              2,
                                            )}
                                          </h3>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  {/* <div className="col-lg-6 col-md-12 col-sm-6 col-12 mb-4">
                                <div className="sub_deposit_box">
                                  <div>
                                    <h5 className="sub_card_title mt-0">
                                      Commission
                                    </h5>
                                    <h3 className="sub_card_title">$0</h3>
                                  </div>
                                </div>
                              </div> */}
                                  <div className="col-12">
                                    <p className="sub_card_title">
                                      {t("Minimum withdrawal amount must be")} $
                                      {Withdrawal?.payment_method?.min_amount ??
                                        Withdrawallist?.[0]?.min_amount ??
                                        "0.00"}
                                    </p>
                                  </div>

                                  <div className="col-12">
                                    <p className="sub_card_title">
                                      {t("Commission")} $
                                      {Withdrawal?.payment_method?.commission ??
                                        Withdrawallist?.[0]?.commission ??
                                        "0.00"}
                                    </p>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="cardBox">
                            <button
                              className={`back_btn mb-0 pb-3 text-white ${withdrawableinfo && "d-none"}`}
                              onClick={() => {
                                setWithdrawaleinfo(true);
                                setComplewithdrawal(false);
                                setInvalidaddress(false);
                              }}
                            >
                              <i class="fa-solid fa-arrow-left-long"></i>
                              <span style={{ marginLeft: "10px" }}>Back</span>
                            </button>
                            <h4 className="card_title">{t("Withdrawal")}</h4>

                            <form action="#" className="withdrawal_form">
                              {loading ? (
                                <div className="loaderparentpositaion">
                                  {" "}
                                  <Commonloader show={true} />{" "}
                                </div>
                              ) : (
                                <>
                                  <div
                                    className={`row ${!withdrawableinfo && "d-none"}`}
                                  >
                                    <div
                                      className={`col-lg-6 col-md-6 ${
                                        complitewithdrawal && "d-none"
                                      }`}
                                    >
                                      <div className="mb-3">
                                        <label>{t("Payment Method")}</label>
                                        <CommonDropdown
                                          label={
                                            Withdrawal?.payment_method?.title ||
                                            Withdrawallist?.[0]?.title
                                          }
                                          options={Withdrawallist}
                                          onSelect={async (val) => {
                                            setWithdrawal((state) => ({
                                              ...state,
                                              payment_method: val,
                                            }));
                                            let alldata = await currencyconvert(
                                              val?.apay_max_withdrawals,
                                              val?.currency,
                                            );
                                            setMaxwithdrawalamount(
                                              alldata?.converted,
                                            );
                                          }}
                                          labelKey="title"
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className={`col-lg-6 col-md-6 ${
                                        complitewithdrawal && "d-none"
                                      }`}
                                    >
                                      <label>{t("Amount")}</label>
                                      <div className="input-group mb-3">
                                        <input
                                          onChange={(e) => {
                                            const value = e.target.value;

                                            // Allow only numbers with up to 2 decimal places
                                            if (/^\d*\.?\d{0,2}$/.test(value)) {
                                              setWithdrawal((state) => ({
                                                ...state,
                                                amount: value,
                                              }));
                                            }
                                          }}
                                          value={Withdrawal?.amount}
                                          type="text"
                                          name="amount"
                                          className="form-control"
                                          placeholder=""
                                        />
                                        <span className="input-group-text">
                                          $
                                        </span>
                                      </div>
                                      {withdrawalErrors.amount && (
                                        <div className="text-danger">
                                          {withdrawalErrors.amount}
                                        </div>
                                      )}
                                    </div>
                                    {withdrawalload ? (
                                      <div className="col-12">
                                        <div className="alertBox">
                                          <div className="alert alert-danger">
                                            <ul>
                                              <li>
                                                Please wait for the trade to end
                                                before making a withdrawal.
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="col-12">
                                        <button
                                          onClick={() =>
                                            withdrawablesteps(Withdrawal)
                                          }
                                          type="button"
                                          className="btn bg-white "
                                        >
                                          Continue
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                  {userdata?.additional_document === 0 ||
                                  userdata?.additional_document_verified ===
                                    1 ? (
                                    <div
                                      className={`row ${withdrawableinfo && "d-none"}`}
                                    >
                                      {Withdrawal?.payment_method
                                        ?.payment_method === "imps" ? (
                                        <>
                                          <div
                                            className={`col-lg-6 col-md-6 ${
                                              complitewithdrawal && "d-none"
                                            }`}
                                          >
                                            <div className="mb-3">
                                              <label>Account name</label>

                                              <div className="input-group">
                                                <input
                                                  onChange={(e) =>
                                                    setWithdrawal((state) => ({
                                                      ...state,
                                                      account_name:
                                                        e.target.value,
                                                    }))
                                                  }
                                                  value={
                                                    Withdrawal?.account_name
                                                  }
                                                  type="text"
                                                  name="amount"
                                                  className="form-control"
                                                  placeholder=""
                                                />
                                              </div>
                                              {withdrawalErrors.account_name && (
                                                <div className="text-danger">
                                                  {
                                                    withdrawalErrors.account_name
                                                  }
                                                </div>
                                              )}
                                            </div>
                                          </div>{" "}
                                          <div
                                            className={`col-lg-6 col-md-6 ${
                                              complitewithdrawal && "d-none"
                                            }`}
                                          >
                                            <div className="mb-3">
                                              <label>Account Number</label>

                                              <div className="input-group">
                                                <input
                                                  onChange={(e) =>
                                                    setWithdrawal((state) => ({
                                                      ...state,
                                                      account_number:
                                                        e.target.value,
                                                    }))
                                                  }
                                                  value={
                                                    Withdrawal?.account_number
                                                  }
                                                  type="number"
                                                  name="amount"
                                                  className="form-control"
                                                  placeholder=""
                                                />
                                              </div>
                                              {withdrawalErrors.account_number && (
                                                <div className="text-danger">
                                                  {
                                                    withdrawalErrors.account_number
                                                  }
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                          <div
                                            className={`col-lg-6 col-md-6 ${
                                              complitewithdrawal && "d-none"
                                            }`}
                                          >
                                            <div className="mb-3">
                                              <label>Bank code</label>

                                              <div className="input-group">
                                                <input
                                                  type="text"
                                                  name="bank_code"
                                                  className="form-control"
                                                  placeholder="Example: BKID0000001"
                                                  maxLength={11}
                                                  value={
                                                    Withdrawal?.bank_code || ""
                                                  }
                                                  onChange={(e) => {
                                                    const value =
                                                      e.target.value.toUpperCase();

                                                    // allow only A-Z and 0-9
                                                    if (
                                                      !/^[A-Z0-9]*$/.test(value)
                                                    )
                                                      return;

                                                    setWithdrawal((state) => ({
                                                      ...state,
                                                      bank_code: value,
                                                    }));
                                                  }}
                                                />
                                              </div>
                                              {withdrawalErrors.bank_code && (
                                                <div className="text-danger">
                                                  {withdrawalErrors.bank_code}
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </>
                                      ) : Withdrawal?.payment_method
                                          ?.payment_method === "pkr_w" ? (
                                        <>
                                          <div
                                            className={`col-lg-6 col-md-6 ${
                                              complitewithdrawal && "d-none"
                                            }`}
                                          >
                                            <div className="mb-3">
                                              <label>
                                                Account Phone Number
                                              </label>

                                              <div className="input-group">
                                                <input
                                                  type="text"
                                                  name="phone_number"
                                                  className="form-control"
                                                  value={
                                                    Withdrawal?.phone_number ||
                                                    ""
                                                  }
                                                  placeholder="Enter phone number"
                                                  maxLength={17}
                                                  onChange={(e) => {
                                                    const value =
                                                      e.target.value;

                                                    // Allow only numbers
                                                    if (!/^\d*$/.test(value))
                                                      return;

                                                    setWithdrawal((state) => ({
                                                      ...state,
                                                      phone_number: value,
                                                    }));
                                                  }}
                                                />
                                              </div>
                                              {withdrawalErrors.phone_number && (
                                                <div className="text-danger">
                                                  {
                                                    withdrawalErrors.phone_number
                                                  }
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                          <div
                                            className={`col-lg-6 col-md-6 ${
                                              complitewithdrawal && "d-none"
                                            }`}
                                          >
                                            <div className="mb-3">
                                              <label>Bank Name</label>

                                              <CommonDropdown
                                                label={Withdrawal?.bank_name}
                                                options={Pakbankname}
                                                onSelect={(val) =>
                                                  setWithdrawal((state) => ({
                                                    ...state,
                                                    bank_name: val,
                                                  }))
                                                }
                                                labelKey="title"
                                              />
                                              {withdrawalErrors.bank_name && (
                                                <div className="text-danger">
                                                  {withdrawalErrors.bank_name}
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </>
                                      ) : Withdrawal?.payment_method
                                          ?.payment_method === "bkash_b" ? (
                                        <>
                                          {/* Account Email */}
                                          <div
                                            className={`col-lg-6 col-md-6 ${
                                              complitewithdrawal && "d-none"
                                            }`}
                                          >
                                            <div className="mb-3">
                                              <label>Account Email</label>

                                              <div className="input-group">
                                                <input
                                                  onChange={(e) =>
                                                    setWithdrawal((state) => ({
                                                      ...state,
                                                      account_email:
                                                        e.target.value.slice(
                                                          0,
                                                          100,
                                                        ),
                                                    }))
                                                  }
                                                  value={
                                                    Withdrawal?.account_email ||
                                                    ""
                                                  }
                                                  type="email"
                                                  className="form-control"
                                                  placeholder="johndoe@gmail.com"
                                                />
                                              </div>

                                              {withdrawalErrors.account_email && (
                                                <div className="text-danger">
                                                  {
                                                    withdrawalErrors.account_email
                                                  }
                                                </div>
                                              )}
                                            </div>
                                          </div>

                                          {/* Account Number */}
                                          <div
                                            className={`col-lg-6 col-md-6 ${
                                              complitewithdrawal && "d-none"
                                            }`}
                                          >
                                            <div className="mb-3">
                                              <label>Account Number</label>

                                              <div className="input-group">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  placeholder="01XXXXXXXXX"
                                                  maxLength={11}
                                                  value={
                                                    Withdrawal?.account_number ||
                                                    ""
                                                  }
                                                  onChange={(e) => {
                                                    const value =
                                                      e.target.value;

                                                    // only numbers
                                                    if (!/^\d*$/.test(value))
                                                      return;

                                                    // must start with 01 after 2 digits entered
                                                    if (
                                                      value.length >= 2 &&
                                                      !value.startsWith("01")
                                                    )
                                                      return;

                                                    setWithdrawal((state) => ({
                                                      ...state,
                                                      account_number: value,
                                                    }));
                                                  }}
                                                />
                                              </div>

                                              {withdrawalErrors.account_number && (
                                                <div className="text-danger">
                                                  {
                                                    withdrawalErrors.account_number
                                                  }
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </>
                                      ) : Withdrawal?.payment_method
                                          ?.payment_method === "egp_fast" ? (
                                        <div
                                          className={`col-lg-6 col-md-6 ${
                                            complitewithdrawal && "d-none"
                                          }`}
                                        >
                                          <div className="mb-3">
                                            <label>Phone Number</label>

                                            <div className="input-group">
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="01342958723"
                                                maxLength={11}
                                                value={
                                                  Withdrawal?.phone_number || ""
                                                }
                                                onChange={(e) => {
                                                  const value = e.target.value;

                                                  // allow only numbers
                                                  if (!/^\d*$/.test(value))
                                                    return;

                                                  // enforce starting with 01
                                                  if (
                                                    value.length >= 2 &&
                                                    !value.startsWith("01")
                                                  )
                                                    return;

                                                  setWithdrawal((state) => ({
                                                    ...state,
                                                    phone_number: value,
                                                  }));
                                                }}
                                              />
                                            </div>

                                            {withdrawalErrors.phone_number && (
                                              <div className="text-danger">
                                                {withdrawalErrors.phone_number}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      ) : Withdrawal?.payment_method
                                          ?.payment_method === "ipay_fast" ? (
                                        <div
                                          className={`col-lg-6 col-md-6 ${
                                            complitewithdrawal && "d-none"
                                          }`}
                                        >
                                          <div className="mb-3">
                                            <label>Phone Number</label>

                                            <div className="input-group">
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="1234567890"
                                                maxLength={10}
                                                value={
                                                  Withdrawal?.phone_number || ""
                                                }
                                                onChange={(e) => {
                                                  const value = e.target.value;

                                                  // allow only numbers
                                                  if (!/^\d*$/.test(value))
                                                    return;

                                                  setWithdrawal((state) => ({
                                                    ...state,
                                                    phone_number: value,
                                                  }));
                                                }}
                                              />
                                            </div>

                                            {withdrawalErrors.phone_number && (
                                              <div className="text-danger">
                                                {withdrawalErrors.phone_number}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <div
                                          className={`col-lg-6 col-md-6 ${
                                            complitewithdrawal && "d-none"
                                          }`}
                                        >
                                          <div className="mb-3">
                                            <label>
                                              {Withdrawal?.payment_method?.title
                                                ? Withdrawal?.payment_method?.title
                                                    ?.split("(")[0]
                                                    ?.trim()
                                                : Withdrawallist?.[0]?.title
                                                    ?.split("(")[0]
                                                    ?.trim()}{" "}
                                              address
                                            </label>

                                            <div className="input-group">
                                              {checkwalletaddress && (
                                                <span className="input-group-text">
                                                  {" "}
                                                  <i
                                                    onClick={() =>
                                                      setCheckwalletaddress(
                                                        !checkwalletaddress,
                                                      )
                                                    }
                                                    class="fa-solid fa-pen z2"
                                                    style={{
                                                      color:
                                                        "rgb(255, 255, 255)",
                                                      cursor: "pointer",
                                                    }}
                                                  ></i>
                                                </span>
                                              )}

                                              <input
                                                onClick={() =>
                                                  setCheckwalletaddress(false)
                                                }
                                                onChange={(e) =>
                                                  setWithdrawal((state) => ({
                                                    ...state,
                                                    payment_address:
                                                      e.target.value,
                                                  }))
                                                }
                                                readOnly={checkwalletaddress}
                                                value={
                                                  Withdrawal?.payment_address
                                                }
                                                type="text"
                                                name="amount"
                                                className="form-control"
                                                placeholder=""
                                              />
                                            </div>
                                            {withdrawalErrors.payment_address && (
                                              <div className="text-danger">
                                                {
                                                  withdrawalErrors.payment_address
                                                }
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                      {invalidaddress && (
                                        <div className="col-12">
                                          <div className="alertBox">
                                            <div className="alert alert-danger">
                                              <ul>
                                                <li>
                                                  {t(
                                                    "You have specified an invalid",
                                                  )}{" "}
                                                  {Withdrawal?.payment_method
                                                    ?.title
                                                    ? Withdrawal?.payment_method?.title
                                                        ?.split("(")[0]
                                                        ?.trim()
                                                    : Withdrawallist?.[0]?.title
                                                        ?.split("(")[0]
                                                        ?.trim()}{" "}
                                                  .
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {!complitewithdrawal ? (
                                        userdata?.additional_document === 0 ||
                                        userdata?.additional_document_verified ===
                                          1 ? (
                                          userdata?.identity_status === 1 ||
                                          userdata?.type === 2 ? (
                                            <div className="col-12">
                                              <button
                                                disabled={withdrawaldeposit}
                                                onClick={() =>
                                                  withdrawalrequest(Withdrawal)
                                                }
                                                type="button"
                                                className="btn bg-white "
                                              >
                                                {t("Continue")}
                                              </button>
                                            </div>
                                          ) : userdata?.identity_status === 0 ||
                                            userdata?.identity_status === 2 ||
                                            userdata?.identity_status === 3 ? (
                                            <div className="col-12">
                                              <div className="alertBox">
                                                <div className="alert alert-danger justify-content-center">
                                                  <ul>
                                                    <li>
                                                      {t(
                                                        "To place a withdrawal, please verify your account.",
                                                      )}
                                                    </li>
                                                    <Link
                                                      to={`${base_url}accounthistory`}
                                                      state={{
                                                        from: "profile",
                                                      }}
                                                      className="btn bg-white"
                                                      style={{
                                                        maxWidth: "fit-content",
                                                        margin: "0 auto",
                                                      }}
                                                    >
                                                      Upload documents
                                                    </Link>
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            ""
                                          )
                                        ) : (
                                          <div className="col-12">
                                            <div className="alertBox">
                                              <div className="alert alert-danger">
                                                <ul>
                                                  <li>
                                                    Additional document
                                                    verification is required.
                                                    Your withdrawal will be
                                                    processed after the required
                                                    documents have been
                                                    successfully submitted and
                                                    verified.
                                                  </li>
                                                  <Link
                                                    to={`${base_url}accounthistory`}
                                                    state={{ from: "profile" }}
                                                    className="btn bg-white "
                                                  >
                                                    {/* <div className="col-12"> */}
                                                    Upload documents
                                                    {/* </div> */}
                                                  </Link>
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      ) : (
                                        ""
                                      )}

                                      <div className="col-12">
                                        {Number(walletprice?.bonus) > 0 ? (
                                          <div className="alertBox">
                                            <div className="alert alert-danger">
                                              <ul>
                                                <li>
                                                  {t(
                                                    "Withdrawing money will deactivate your bonus.",
                                                  )}
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        {complitewithdrawal && (
                                          <>
                                            <div className="alertBox">
                                              <div className="alert alert-success">
                                                <p>
                                                  <b>
                                                    {t(
                                                      "Withdrawal request has been sent",
                                                    )}
                                                  </b>
                                                  <br />
                                                  {t(
                                                    "Your request has been queued. You will receive the funds within a few business days.",
                                                  )}
                                                </p>
                                              </div>
                                            </div>
                                            {/* <div className="alertBox">
                                          <div className="alert alert-danger">
                                            <ul>
                                              <li>
                                                Please cancel the pending
                                                withdrawal to place a new one.
                                              </li>
                                            </ul>
                                          </div>
                                        </div> */}
                                          </>
                                        )}
                                        <p className="mb-0">
                                          <span className="text-white">
                                            {t("Note")} :
                                          </span>{" "}
                                          {t(
                                            "Withdrawal process becomes available after you deposit on your account. Typically, a withdrawal request is processed automatically and takes a few minutes, and in some cases up to 3 business days",
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  ) : (
                                    <div
                                      className={`row ${withdrawableinfo && "d-none"}`}
                                    >
                                      <div className="col-12">
                                        <div className="alertBox">
                                          <div className="alert alert-danger">
                                            <ul>
                                              <li>
                                                Additional document verification
                                                is required. Your withdrawal
                                                will be processed after the
                                                required documents have been
                                                successfully submitted and
                                                verified.
                                              </li>
                                              <Link
                                                to={`${base_url}accounthistory`}
                                                state={{ from: "profile" }}
                                                className="btn bg-white "
                                              >
                                                {/* <div className="col-12"> */}
                                                Upload documents
                                                {/* </div> */}
                                              </Link>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${
                      state?.from === "promo_codes" && "show active"
                    }`}
                    id="promocodes"
                    role="tabpanel"
                    aria-labelledby="promocodes-tab"
                  >
                    {/* <!-- cashback content  --> */}
                    <div className="row">
                      <div className="col-xl-4 col-lg-5 col-md-12 col-sm-12 mb-lg-0 mb-3">
                        <div className="cardBox">
                          <div className="promo-card">
                            <h5 className="text-center">
                              {t("Do you have a Bonus Code?")}
                            </h5>
                            <div className="input-group my-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder={t("Enter Bonus Code")}
                                value={pomocodedata?.code}
                                aria-label="Bonus Code"
                                onChange={(e) =>
                                  setPomocodedata((state) => ({
                                    ...state,
                                    code: e.target.value,
                                  }))
                                }
                              />
                              <button
                                className="btn btn-primary"
                                onClick={() =>
                                  checkpomocode(pomocodedata?.code, "promocode")
                                }
                              >
                                {t("Check")}
                              </button>
                            </div>
                            <div className="text-center mb-4">
                              <h5 className="promo-code">
                                {pomocodedata?.code}
                              </h5>
                              <p className="text-muted">{t("Bonus Code")}</p>
                            </div>

                            {pomocodedata?.id ? (
                              <>
                                <div className="input-group mb-3">
                                  <span className="input-group-text">$</span>
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={pomocodedata?.deposit}
                                    aria-label="Deposit amount"
                                    onChange={(e) => {
                                      setPomocodedata((state) => ({
                                        ...state,
                                        deposit: e.target.value,
                                      }));
                                    }}
                                  />
                                </div>
                                {parseInt(pomocodedata?.deposit) <
                                parseInt(pomocodedata?.min_deposit) ? (
                                  <p className="p-0 text-danger">
                                    {t("Min. deposit to activate a Bonus Code")}
                                    : ${pomocodedata?.min_deposit}
                                  </p>
                                ) : (
                                  ""
                                )}
                                <div className="row text-center mb-3">
                                  <div className="col-6">
                                    <div className="bord-e">
                                      <h6>{pomocodedata?.discount}%</h6>
                                      <p className="text-muted">{t("Bonus")}</p>
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="bord-e">
                                      <h6>${pomocodedata?.min_deposit}</h6>
                                      <p className="text-muted">
                                        {t("Min. Deposit")}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="row text-center mb-3">
                                  <div className="col-6">
                                    <div className="bord-e">
                                      <h6>
                                        $
                                        {parseInt(pomocodedata?.deposit) >
                                        parseInt(pomocodedata?.min_deposit)
                                          ? (parseInt(pomocodedata?.discount) *
                                              parseInt(pomocodedata?.deposit)) /
                                            100
                                          : (parseInt(pomocodedata?.discount) *
                                              parseInt(
                                                pomocodedata?.min_deposit,
                                              )) /
                                            100}
                                      </h6>
                                      <p className="text-muted">
                                        {t("Bonus amount")}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <div className="bord-e">
                                      <h6>
                                        {pomocodedata?.ends_at
                                          ? convertLocalToUTCFormatted(
                                              pomocodedata?.ends_at,
                                              updatetimezone,
                                            )?.datetime.split(" ")[0]
                                          : "-"}
                                        {/* $
                                        {parseInt(pomocodedata?.deposit) >
                                        parseInt(pomocodedata?.min_deposit)
                                          ? (parseInt(pomocodedata?.discount) *
                                              parseInt(pomocodedata?.deposit)) /
                                              100 +
                                            parseInt(pomocodedata?.deposit)
                                          : (parseInt(pomocodedata?.discount) *
                                              parseInt(
                                                pomocodedata?.min_deposit
                                              )) /
                                              100 +
                                            parseInt(pomocodedata?.min_deposit)} */}
                                      </h6>
                                      <p className="text-muted">
                                        {t("Valid Date")}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="d-grid"
                                  onClick={() => activepromocode()}
                                >
                                  <button className="btn bg-white w">
                                    {t("Activate")}
                                  </button>
                                </div>
                                <Accordion className="Terms_Conditions_accordion_content">
                                  <Accordion.Item eventKey="0">
                                    <Accordion.Header className="text-center">
                                      {t("Terms and conditions")}
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <div className="Terms_Conditions_collapse_content">
                                        <p>
                                          1. Bonus gives you{" "}
                                          {pomocodedata?.discount}% on deposit
                                          amount into Real account's balance
                                        </p>
                                        <p>
                                          2. You can cancel Bonus at any time,
                                          Bonus amount and Bonus profit will be
                                          deducted from your Real account's
                                          balance.
                                        </p>
                                        <p>
                                          3. Bonus profit ={" "}
                                          {pomocodedata?.discount}% / ({" "}
                                          {pomocodedata?.discount}% +{" "}
                                          {pomocodedata?.discount}% ) * Profit
                                          made when trading using bonus funds.
                                        </p>
                                        <p>
                                          4. Available profit = Trading profit -
                                          Bonus profit, as if you were trading
                                          without bonus funds.
                                        </p>
                                        <p>
                                          5. You can withdraw your deposited
                                          amount and available profit at any
                                          time, as long as you have enough funds
                                          in your real account balance.
                                        </p>
                                        <p>
                                          6. In case of creating a withdrawal
                                          request, your active and not-executed
                                          bonus and bonus profit will be
                                          deducted from your real account
                                          balance.
                                        </p>
                                        <p>
                                          7. The bonus is executed and the bonus
                                          profit becomes available for
                                          withdrawal as soon as your net trading
                                          turnover reaches x
                                          {pomocodedata?.turnover_required} of
                                          the bonus amount.
                                        </p>
                                        <p>
                                          8. The Company has a right to amend
                                          the bonus terms or terminate this
                                          promotion at any time without any
                                          notice.
                                        </p>
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-8 col-lg-7 col-md-12 col-sm-12">
                        {/* <div className="cardBox table-mobile-view mb-3"> */}
                        <div className="row">
                          <div className="col-lg-12 mb-3">
                            <div className="cardBox table-mobile-view">
                              <h4 className="card_title">
                                {t("Available Bonus Codes")}
                              </h4>
                              <div className="table-responsive">
                                <table
                                  className="table table-dark table-striped promo-table AvailableBonusCodes"
                                  data-bs-theme="dark"
                                >
                                  <thead>
                                    <tr>
                                      <th>{t("Bonus Code")}</th>
                                      <th>{t("Percent")}</th>
                                      <th>{t("Min. Deposit")}</th>
                                      <th>{t("Max. Bonus")}</th>
                                      <th>{t("Valid From")}</th>
                                      <th>{t("Valid Until")}</th>
                                      <th className="text-center">
                                        {t("Action")}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {bonusloading ? (
                                      <tr>
                                        <td
                                          colSpan="7"
                                          className="loaderparentpositaion"
                                        >
                                          <Commonloader show={true} />
                                        </td>
                                      </tr>
                                    ) : pomocode?.length ? (
                                      pomocode.map((result, key) => {
                                        if (result?.forall === 0) return;
                                        return (
                                          <tr key={key}>
                                            <td>
                                              {result?.code
                                                ? result?.code
                                                : "-"}
                                            </td>
                                            <td>
                                              {result?.discount
                                                ? result?.discount
                                                : "-"}
                                              %
                                            </td>
                                            <td>
                                              $
                                              {result?.min_deposit
                                                ? result?.min_deposit
                                                : "0.00"}
                                            </td>
                                            <td>
                                              $
                                              {result?.max_bonus
                                                ? result?.max_bonus
                                                : "0.00"}
                                            </td>
                                            <td>
                                              {result?.starts_at
                                                ? convertLocalToUTCFormatted(
                                                    result?.starts_at,
                                                    updatetimezone,
                                                  )?.datetime
                                                : "-"}
                                            </td>
                                            <td>
                                              {result?.ends_at
                                                ? convertLocalToUTCFormatted(
                                                    result?.ends_at,
                                                    updatetimezone,
                                                  )?.datetime
                                                : "-"}
                                            </td>
                                            <td className="text-center">
                                              <button
                                                className="btn btn-success"
                                                onClick={() =>
                                                  checkbonus(result)
                                                }
                                              >
                                                {t("Check")}
                                              </button>
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr className="no_data_table">
                                        <td colSpan={7} className="text-center">
                                          {t("No Data Found")}
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          {usercouponlist?.length ? (
                            <div className="col-lg-12 mb-3">
                              <div className="cardBox table-mobile-view">
                                <h4 className="card_title">
                                  Active promo code
                                </h4>
                                <div className="table-responsive">
                                  <table
                                    className="table table-dark table-striped promo-table Activepromocode"
                                    data-bs-theme="dark"
                                  >
                                    <thead>
                                      <tr>
                                        <th>Promo Code</th>
                                        <th>Activated</th>
                                        <th>Deposit amount</th>
                                        <th>Bonus amount</th>
                                        <th>Current net turnover</th>
                                        <th>Required net turnover</th>
                                        <th>Available profit*</th>
                                        <th>Bonus profit*</th>
                                        <th className="text-center">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {usercouponlist?.length
                                        ? usercouponlist.map((result, key) => {
                                            return (
                                              <tr>
                                                <td>
                                                  {result?.promo_code
                                                    ? result?.promo_code
                                                    : ""}
                                                </td>
                                                <td>
                                                  {result?.activated
                                                    ? convertLocalToUTCFormatted(
                                                        result?.activated,
                                                        updatetimezone,
                                                      )?.datetime
                                                    : "-"}
                                                </td>
                                                <td>
                                                  $
                                                  {result?.deposit_amount
                                                    ? formatPrice(
                                                        result?.deposit_amount,
                                                        2,
                                                      )
                                                    : "0.00"}
                                                </td>
                                                <td>
                                                  $
                                                  {result?.bonus_amount
                                                    ? formatPrice(
                                                        result?.bonus_amount,
                                                        2,
                                                      )
                                                    : "0.00"}
                                                </td>
                                                <td>
                                                  $
                                                  {result?.current_turnover
                                                    ? formatPrice(
                                                        result?.current_turnover,
                                                        2,
                                                      )
                                                    : "0.00"}
                                                </td>
                                                <td>
                                                  $
                                                  {result?.required_turnover
                                                    ? formatPrice(
                                                        result?.required_turnover,
                                                        2,
                                                      )
                                                    : "0.00"}
                                                </td>
                                                <td>
                                                  $
                                                  {result?.available_profit
                                                    ? formatPrice(
                                                        result?.available_profit,
                                                        2,
                                                      )
                                                    : "0.00"}
                                                </td>
                                                <td>
                                                  $
                                                  {result?.bonus_profit
                                                    ? formatPrice(
                                                        result?.bonus_profit,
                                                        2,
                                                      )
                                                    : "0.00"}
                                                </td>
                                                <td
                                                  className="text-center"
                                                  onClick={() => {
                                                    openModal(
                                                      "removeCouponModal",
                                                    );
                                                    setCanclecouponid(
                                                      result?.transaction_id,
                                                    );
                                                  }}
                                                >
                                                  <button className="btn bg-danger">
                                                    Cancel
                                                  </button>
                                                </td>
                                              </tr>
                                            );
                                          })
                                        : ""}
                                    </tbody>
                                  </table>
                                </div>
                                <div className="mt-3">
                                  <p className="mb-0">Execution</p>
                                  <div
                                    className="progress progressdg mt-1"
                                    style={{ height: "5px" }}
                                  >
                                    <div
                                      className="progress-bar progress-bar-striped progress-bar-animated"
                                      role="progressbar"
                                      aria-valuenow={
                                        bonusData.executionPercent || 0
                                      }
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                      style={{
                                        width: `${bonusData.executionPercent || 0}%`,
                                      }}
                                    ></div>
                                  </div>
                                  <h6 className="text-white mt-1">
                                    <small>
                                      {bonusData.executionPercent || 0}%
                                    </small>
                                  </h6>
                                  <h6 className="text-white mt-2">
                                    *These value may change when trading
                                    activity takes place.
                                  </h6>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {usercouponhistorylist?.length ? (
                            <div className="col-lg-12 mb-3">
                              <div className="cardBox table-mobile-view">
                                <h4 className="card_title">History</h4>
                                <div className="table-responsive">
                                  <table
                                    className="table table-dark table-striped promo-table Historycodetable"
                                    data-bs-theme="dark"
                                  >
                                    <thead>
                                      <tr>
                                        <th>Promo code</th>
                                        <th>Percent</th>
                                        <th>Bonus amount</th>
                                        <th>Date activated</th>
                                        {/* <th>Execution/Cancellation date</th> */}
                                        <th>Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {usercouponhistorylist?.length
                                        ? usercouponhistorylist.map(
                                            (result, key) => {
                                              return (
                                                <tr>
                                                  <td>
                                                    {result?.promo_code
                                                      ? result?.promo_code
                                                      : "-"}
                                                  </td>
                                                  <td>100%</td>
                                                  <td>
                                                    $
                                                    {result?.bonus
                                                      ? formatPrice(
                                                          result?.bonus,
                                                          2,
                                                        )
                                                      : "0.00"}
                                                  </td>
                                                  <td>
                                                    {" "}
                                                    {result?.created_at
                                                      ? convertLocalToUTCFormatted(
                                                          result?.created_at,
                                                          updatetimezone,
                                                        )?.datetime
                                                      : "-"}
                                                  </td>
                                                  {/* <td>2026-05-27 00:51</td> */}
                                                  <td>
                                                    {result?.message
                                                      ? result?.message
                                                      : "-"}
                                                  </td>
                                                </tr>
                                              );
                                            },
                                          )
                                        : ""}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      {/* </div> */}
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${
                      state?.from === "transaction_history" && "show active"
                    }`}
                    id="WithdrawalHistory"
                    role="tabpanel"
                    aria-labelledby="WithdrawalHistory-tab"
                  >
                    <form action="#" className="trade_historyfilter mb-4">
                      <CommonHistorydate
                        fetchServerTime={fetchServerTimefordate}
                        onChange={handledepositDateChange}
                      />
                      <div className="form-group HistorySelect">
                        <CommonDropdown
                          label={walletfilter?.action?.label || "All History"}
                          options={[
                            { label: "All History", value: "" },
                            { label: "Deposit History", value: "Deposit" },
                            {
                              label: "Withdrawal History",
                              value: "Withdrawal",
                            },
                          ]}
                          onSelect={(val) =>
                            setWalletfilter((state) => ({
                              ...state,
                              action: val,
                            }))
                          }
                          labelKey="label"
                        />
                      </div>
                      <button
                        type="button"
                        className="btn bg_btn"
                        onClick={() => {
                          transactionHistory(walletfilter, true, true);
                        }}
                      >
                        {t("Apply Filters")}{" "}
                        <i className="fa-solid fa-circle-check"></i>
                      </button>
                      {exportexceldata?.length ? (
                        <button
                          type="button"
                          className="btn bg_btn"
                          onClick={() =>
                            exportToExcel(
                              exportexceldata,
                              "Transaction_history.xlsx",
                            )
                          }
                        >
                          {t("Export to XLS")}{" "}
                          <i className="fa-solid fa-circle-check"></i>
                        </button>
                      ) : (
                        ""
                      )}
                    </form>
                    <div className="cardBox table-mobile-view mb-3">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                          <h4 className="card_title">
                            {t("Transaction history")}
                          </h4>
                        </div>
                        <div className="col-lg-6 col-md-6 ol-sm-6 col-12">
                          <div className="fillterOption">
                            <form
                              className="searchbar"
                              style={{
                                maxWidth: "350px",
                                width: "100%",
                              }}
                            >
                              <button type="button" className="">
                                <img src={searchnormal} alt="" />
                              </button>
                              <input
                                value={searchhistory}
                                type="search"
                                className="form-control"
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  setSeachhistory(e.target.value);
                                }}
                                placeholder="Search by Order ID and Method..."
                              />
                            </form>
                            {/* <!-- <button type="button" className="fillterBtn"><img src="images/setting-5.svg"></button> --> */}
                          </div>
                        </div>
                        <div className="col-lg-12 mt-md-4 mt-3">
                          <div className="table-responsive">
                            <table className="finance-table table table-dark table-striped mb-md-3 mb-0">
                              <thead>
                                <tr>
                                  <th>{t("Date/Time")}</th>
                                  <th>{t("Transaction Type")}</th>
                                  <th>{t("Method")}</th>
                                  <th>{t("Amount")}</th>
                                  <th>{t("ID")}</th>

                                  <th>{t("Status")}</th>
                                  <th>{t("Bonus")}</th>
                                  <th>Lapsed bonus</th>
                                  {/* <th>Update UTR</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td
                                      colSpan="8"
                                      className="loaderparentpositaion"
                                    >
                                      <Commonloader show={true} />
                                    </td>
                                  </tr>
                                ) : wallethistory?.length ? (
                                  wallethistory.map((result, key) => {
                                    return (
                                      <tr>
                                        <td>
                                          {
                                            convertLocalToUTCFormatted(
                                              result?.created_at,
                                              updatetimezone,
                                            )?.formatted
                                          }
                                        </td>
                                        <td>{result?.action}</td>
                                        <td>
                                          {result?.payment_transaction
                                            ?.gateway_name
                                            ? result?.payment_transaction
                                                ?.gateway_name
                                            : result?.payment_transaction
                                                ?.payment_name}
                                        </td>
                                        <td>
                                          $
                                          {result?.payment_transaction?.amount
                                            ? formatPrice(
                                                result?.payment_transaction
                                                  ?.amount,
                                                2,
                                              )
                                            : 0.0}
                                        </td>
                                        <td>
                                          {result?.payment_transaction
                                            ?.transaction_id !== "0"
                                            ? result?.payment_transaction
                                                ?.transaction_id
                                            : "-"}
                                        </td>

                                        <td>
                                          {result?.payment_transaction
                                            ?.payment_status && (
                                            <span
                                              className={`status-badge ${
                                                result.payment_transaction.payment_status.toLowerCase() ===
                                                "completed"
                                                  ? "status-completed"
                                                  : result.payment_transaction.payment_status.toLowerCase() ===
                                                      "failed"
                                                    ? "status-failed"
                                                    : result.payment_transaction.payment_status.toLowerCase() ===
                                                        "invalid"
                                                      ? "status-invalid"
                                                      : result.payment_transaction.payment_status.toLowerCase() ===
                                                          "pending"
                                                        ? "status-pending"
                                                        : result.payment_transaction.payment_status.toLowerCase() ===
                                                            "canceled"
                                                          ? "status-failed"
                                                          : result.payment_transaction.payment_status.toLowerCase() ===
                                                              "underconsideration"
                                                            ? "status-underconsideration"
                                                            : result.payment_transaction.payment_status.toLowerCase() ===
                                                                "processing"
                                                              ? "status-invalid"
                                                              : ""
                                              }`}
                                            >
                                              {result.payment_transaction.payment_status.toLowerCase() ===
                                              "underconsideration"
                                                ? "UNDER CONSIDERATION"
                                                : result.payment_transaction.payment_status.toUpperCase()}
                                            </span>
                                          )}
                                          {result?.payment_transaction
                                            ?.payment_status && (
                                            <span
                                              onClick={() => {
                                                setShowCancel(true);
                                                canlelwithdrawal({
                                                  id: result
                                                    ?.payment_transaction?.id,
                                                  status:
                                                    result?.payment_transaction
                                                      ?.payment_status,
                                                  amount:
                                                    result?.payment_transaction
                                                      ?.amount,
                                                });
                                              }}
                                              className={`status-badge ${
                                                (result.payment_transaction.payment_status.toLowerCase() ===
                                                  "pending" ||
                                                  result.payment_transaction.payment_status.toLowerCase() ===
                                                    "underconsideration") &&
                                                result?.action ===
                                                  "Withdrawal" &&
                                                !showcancel
                                                  ? "mx-1 status-failed pointercursor"
                                                  : "d-none"
                                              }`}
                                            >
                                              Cancel
                                            </span>
                                          )}
                                          {result?.action === "Deposit" &&
                                          result?.payment_transaction
                                            ?.converted_currency === "INR" &&
                                          (result?.payment_transaction
                                            ?.payment_status === "pending" ||
                                            result?.payment_transaction
                                              ?.payment_status ===
                                              "underconsideration") ? (
                                            <span
                                              className="ms-2 badgeBtnModal status-badge status-completed"
                                              data-bs-toggle="modal"
                                              data-bs-target="#othTablemodal"
                                              onClick={() =>
                                                setUpdateapaydetails(
                                                  result?.payment_transaction,
                                                )
                                              }
                                            >
                                              Update UTR
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                        <td>
                                          {result?.payment_transaction
                                            ?.original_bonus_amount > 0
                                            ? `$${formatPrice(
                                                result?.payment_transaction
                                                  ?.original_bonus_amount,
                                                2,
                                              )}`
                                            : "$0"}

                                          {Number(
                                            result?.payment_transaction
                                              ?.original_bonus_amount,
                                          ) > 0 ? (
                                            <span className="position-relative toolTip-position-center-right d-inline-block ms-2">
                                              <i class="fa-solid fa-circle-exclamation"></i>{" "}
                                              <span class="toolTip01">
                                                The bonus amount and bonus
                                                profit will be deducted from the
                                                balance after a withdrawal
                                                request is made if the
                                                conditions of the applied bonus
                                                promo code are not met.
                                              </span>
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                        <td>
                                          {result?.payment_transaction
                                            ?.deduct_bonus_amount !== "0.00" &&
                                          result?.payment_transaction
                                            ?.deduct_bonus_amount
                                            ? `-$${formatPrice(
                                                result?.payment_transaction
                                                  ?.deduct_bonus_amount,
                                                2,
                                              )}`
                                            : "$0"}
                                        </td>
                                        {/* <td>
                                          {" "}
                                          {result?.action === "Deposit" &&
                                          result?.payment_transaction
                                            ?.converted_currency === "INR" &&
                                          (result?.payment_transaction
                                            ?.payment_status === "pending" ||
                                            result?.payment_transaction
                                              ?.payment_status ===
                                              "underconsideration") ? (
                                            <span
                                              className="status-badge status-completed"
                                              data-bs-toggle="modal"
                                              data-bs-target="#othTablemodal"
                                              onClick={() =>
                                                setUpdateapaydetails(
                                                  result?.payment_transaction,
                                                )
                                              }
                                            >
                                              UTR
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </td> */}
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr className="no_data_table">
                                    <td colSpan={8} className="text-center">
                                      {!loading && t("No Data Found")}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <Pagination
                            totalItems={totalPages || 20}
                            itemsPerPage={itemsPerPage || 20}
                            currentPage={currentPage || 1}
                            goToPage={goToPage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div
          ref={(el) => (modalRefs.current["removeCouponModal"] = el)}
          className="modal fade"
          id="removeCouponModal"
          tabindex="-1"
          aria-labelledby="removeCouponLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="removeCouponLabel">
                  {t("Confirm")}
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p className="text-white m-0">
                  {t("Are you sure you want to remove Promo code?")}
                </p>
              </div>
              <div className="modal-footer justify-content-between">
                <span
                  className="status-badge status-cancel cursor-pointer"
                  data-bs-dismiss="modal"
                  style={{ minWidth: "auto" }}
                >
                  {t("No")}
                </span>

                <span
                  className="status-badge status-completed cursor-pointer"
                  onClick={() => canclecoupon(canclecouponid)}
                >
                  {t("Yes")}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="othTablemodal" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <strong>UTR Update </strong>{" "}
                </h5>

                <button className="btn-close" data-bs-dismiss="modal"></button>
              </div>

              <div className="modal-body">
                <div className="withdrawal_form ">
                  <label>UTR</label>
                  <input
                    type="text"
                    name=""
                    className="form-control"
                    value={updateapaydetails?.utr_apay}
                    onChange={(e) =>
                      setUpdateapaydetails((state) => ({
                        ...state,
                        utr_apay: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="modal-footer border-0 justify-content-center">
                  <button
                    type="button"
                    className="btn bg_btn py-2"
                    onClick={() => updateutr(updateapaydetails)}
                  >
                    Update UTR
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          ref={(el) => (modalRefs.current["Deposit"] = el)}
          className="modal fade"
          id="hotkeysModal"
          tabindex="-1"
          aria-labelledby="joinUsModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h5 className="modal-title mb-3">{t("Deposit Request")}</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>

                <div className="row">
                  {/* <div className="col-lg-5 col-md-6">
                          <img src={hotkeys} className="hot-keys-img" alt="" />
                        </div> */}
                  <div className="col-lg-12 col-md-12">
                    <input
                      type="number"
                      className="form-control"
                      value={value}
                      onChange={handleChange}
                      min="1"
                      placeholder="Enter a positive number"
                    />

                    <div className="btnsGroup hotkeysactive mt-3">
                      <Link
                        className="btn green_btn"
                        to=""
                        onClick={(e) => e.preventDefault()}
                        // onClick={() => {
                        //   hotkeysset(1);
                        // }}
                      >
                        {t("Request Submit")}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Dashboarddeposit;
